import { normalizeCity } from 'utils/normalizeCity';

/**
 * City option with display name and normalized key
 */
export interface CityOption {
  displayName: string;
  key: string; // normalized key for API calls
}

export const Cities: string[] = [
  '',
  'Pinole',
  'Baton Rouge',
  'Tuscaloosa',
  'Pembroke',
  'Buffalo',
  'Union Point',
  'Tamarac',
  'New Franklin',
  'Columbus',
  'Chandler',
  'Stockton',
  'Seffner',
  'Houston',
  'Euless',
  'Chowchilla',
  'Taft',
  'Capitola',
  'Tampa',
  'Philadelphia',
  'East Dorset',
  'Hickory',
  'Knoxville',
  'Overland',
  'Guadalupe',
  'Hollywood',
  'Charlotte',
  'Homestead',
  'Alamogordo',
  'Nashville',
  'Fayetteville',
  'Littleton',
  'San Antonio',
  'West New York',
  'Converse',
  'Dallas',
  'Greensburg',
  'Coolidge',
  'Amityville',
  'San Francisco',
  'Brooklyn',
  'North Yarmouth',
  'Conroe',
  'Los Angeles',
  'Greenfield',
  'Colcord',
  'Reno',
  'Norfolk',
  'Denver',
  'Lake Elsinore',
  'New York',
  'Chicago',
  'Cheyenne',
  'Arlington',
  'Boston',
  'Hampton',
  'Jamaica',
  'Bloomington',
  'Denton',
  'Phoenix',
  'New Haven',
  'The Bronx',
  'Waterbury',
  'Iowa',
  'Gladewater',
  'Dracut',
  'Leander',
  'Grand Rapids',
  'Melbourne',
  'Round Rock',
  'Wadesboro',
  'Jackson',
  'Eaton Rapids',
  'North Las Vegas',
  'Seattle',
  'Jacksonville',
  'Temecula',
  'San Marcos',
  'Honesdale',
  'Lawton',
  'Summertown',
  'Lubbock',
  'Annapolis',
  'Lone Tree',
  'Flat Rock',
  'Texas City',
  'La Fayette',
  'West Valley City',
  'Washington',
  'Uniontown',
  'Bay Shore',
  'Raritan',
  'Aberdeen',
  'Licking',
  'Durham',
  'Gonzales',
  'Cedar Hill',
  'Allentown',
  'Mesa',
  'Kansas City',
  'Leesville',
  'Kissimmee',
  'Sunnyvale',
  'Wilmington',
  'Laurinburg',
  'Champaign',
  'Hawthorne',
  'Lakewood',
  'Colton',
  'Seneca Falls',
  'Coconut Creek',
  'Augusta',
  'Salisbury',
  'Provo',
  'San Jose',
  'Shakopee',
  'Omaha',
  'Haverhill',
  'Richardson',
  'Halethorpe',
  'Hammonton',
  'Indianapolis',
  'Hesperia',
  'Winston-Salem',
  'Tallahassee',
  'Dayton',
  'West Columbia',
  'St. Louis',
  'Iowa City',
  'Noblesville',
  'Woodbury',
  'Ronkonkoma',
  'Milwaukee',
  'Bayonne',
  'Pooler',
  'Christmas',
  'Englewood',
  'North Richland Hills',
  'Shreveport',
  'Pflugerville',
  'Fort Worth',
  'Hempstead',
  'Ellenwood',
  'Grapevine',
  'Casa Grande',
  'Oxon Hill',
  'Miami',
  'Taunton',
  'Northport',
  'Cranston',
  'Tyner',
  'Makakilo',
  'Marcus Hook',
  'Shamokin',
  'Waco',
  'Springdale',
  'Daytona Beach',
  'Raceland',
  'Wauchula',
  'Port Vue',
  'Detroit',
  'North Charleston',
  'Peachtree Corners',
  'Peabody',
  'Wareham',
  'Palm Springs',
  'Broussard',
  'Muskegon Heights',
  'Hillcrest Heights',
  'Seguin',
  'Thibodaux',
  'Meridian',
  'Winter Haven',
  'Bellingham',
  'Oaklyn',
  'Normal',
  'Rarden',
  'Woodbridge',
  'Reisterstown',
  'Spokane Valley',
  'Ellwood City',
  'Cape Elizabeth',
  'Hudson',
  'Orlando',
  'Oak Harbor',
  'Gilbert',
  'Pacific Grove',
  'Yonkers',
  'Lynwood',
  'Rockford',
  'Lincoln',
  'Decatur',
  'Shirley',
  'Godley',
  'Mountain View',
  'Antioch',
  'Nashua',
  'Hartford',
  'Lodi',
  'Cape Coral',
  'Oklahoma City',
  'Atlanta',
  'Trenton',
  'Waycross',
  'Grand Prairie',
  'Schererville',
  'Saint Francisville',
  'Lawrenceville',
  'Macon',
  'Gaffney',
  'Cedar Rapids',
  'Lancaster',
  'Columbia',
  'Lufkin',
  'Manville',
  'Concord',
  'Lake Charles',
  'Aurora',
  'Bronx',
  'Pasadena',
  'Methuen',
  'Perth Amboy',
  'Cleveland',
  'Portsmouth',
  'Santa Rosa',
  'Georgetown',
  'Palm Desert',
  'Waldorf',
  'Salinas',
  'Harrisburg',
  'Beaverton',
  'Gaithersburg',
  'Johnston City',
  'Hopewell',
  'El Paso',
  'Brooklyn Park',
  'Painesville',
  'Atlantic City',
  'Bellflower',
  'Sulphur',
  'Redding',
  'Charleston',
  'Canton',
  'Cincinnati',
  'Hallsville',
  'Douglas',
  'Farmington',
  'Fort Smith',
  'Kittanning',
  'Bartlett',
  'East Falmouth',
  'Peoria',
  'Minneola',
  'Laredo',
  'Gobles',
  'Bakersfield',
  'Ontario',
  'Norwalk',
  'Yucaipa',
  'Syracuse',
  'Irving',
  'Riverdale',
  'Milton',
  'New Castle',
  'Tucker',
  'Newton',
  'Bolingbrook',
  'Santa Clarita',
  'Chico',
  'Ceres',
  'Spanaway',
  'Kalamazoo',
  'Baltimore',
  'Malibu',
  'San Leandro',
  'Lake Park',
  'Carl Junction',
  'Las Vegas',
  'Marshall',
  'Deerfield Beach',
  'Birmingham',
  'Marlin',
  'Middletown',
  'Spokane',
  'Beacon',
  'Clarkesville',
  'Huntington Beach',
  'Mabank',
  'Warren',
  'Seaford',
  'Matteson',
  'Hauula',
  'Sylmar',
  'Lawrence',
  'Lansing',
  'Neenah',
  'Duncanville',
  'Colorado Springs',
  'Jersey City',
  'Pembroke Pines',
  'Little Falls',
  'Blountville',
  'Asheville',
  'New Orleans',
  'Harrisonburg',
  'Saint Petersburg',
  'Sheboygan',
  'Moreno Valley',
  'Daly City',
  'Hereford',
  'Westlake',
  'Fort Collins',
  'Sioux Falls',
  'East Hartford',
  'Hillsboro',
  'Portland',
  'Revere',
  'Nutley',
  'Farmers Branch',
  'Gresham',
  'Holland',
  'Baytown',
  'Shaker Heights',
  'Austin',
  'Cottonwood',
  'Oakland',
  'Albany',
  'Little Rock',
  'Oxnard',
  'Rocky Face',
  'Cibolo',
  'Arnaudville',
  'Versailles',
  'Kennewick',
  'Southaven',
  'Oakdale',
  'Lebanon',
  'Ray',
  'Winnsboro',
  'Mason',
  'Rock Hill',
  'Hastings',
  'Iowa Falls',
  'Mt Vernon',
  'Lindenhurst',
  'Worcester',
  'Athens',
  'Hammond',
  'Somers Point',
  'Simpsonville',
  'Victoria',
  'Mansfield',
  'Chester',
  'Savannah',
  'Benton',
  'Daytona Beach Shores',
  'Glendale',
  'Carson',
  'Clovis',
  'Fenton',
  'North Tonawanda',
  'Hyattsville',
  'Smiths Station',
  'Poughkeepsie',
  'Minneapolis',
  'Forest Park',
  'Texarkana',
  'Burnsville',
  'Central Falls',
  'Holly',
  'Richmond',
  'San Pablo',
  'Reidsville',
  'Conley',
  'Denham Springs',
  'Hamilton',
  'Raleigh',
  'Kirkland',
  'Hollister',
  'Mont Belvieu',
  'Ocala',
  'Rapid City',
  'Fort Myers',
  'Levelland',
  'Silver Spring',
  'Berwyn',
  'Spartanburg',
  'Virginia Beach',
  'Camden',
  'San Diego',
  'Circleville',
  'Ionia',
  'Metairie',
  'Douglassville',
  'Missouri City',
  'Marion',
  'Anchorage',
  'Plaquemine',
  'Whittier',
  'Silverton',
  'St Joseph',
  'Merced',
  'Swampscott',
  'Muscoy',
  'Houma',
  'Queen Creek',
  'Victorville',
  'Fitchburg',
  'Paramount',
  'Calera',
  'Santa Maria',
  'DeLand',
  'Hawkeye',
  'Plymouth',
  'Woodstock',
  'Bound Brook',
  'Albuquerque',
  'Morgantown',
  'Louisville',
  'Los Fresnos',
  'Gulfport',
  'Elkhart',
  'Bristol',
  'Liberty Township',
  'Hurst',
  'Fallon',
  'Homewood',
  'Irmo',
  'North Bergen',
  'Lakeland',
  'Owings Mills',
  'Fort Walton Beach',
  'Cresco',
  'Sparks',
  'Braddock',
  'Texas 76082',
  'Azle',
  'Hoffman',
  'Huntsville',
  'Fairfield',
  'Carmichael',
  'Sacramento',
  'Bowling Green',
  'Little Egg Harbor Township',
  'Valley',
  'Baldwin Park',
  'Elizabeth City',
  'Nampa',
  'Amarillo',
  'Red Rock',
  'Danville',
  'Palatine',
  'Refugio',
  'Jensen Beach',
  'Roanoke',
  'Abbeville',
  'Rodessa',
  'Saint Louis',
  'Tucson',
  'Oakman',
  'Surprise',
  'Alamo',
  'Violet',
  'Covington',
  'Buchanan',
  'Waterville',
  'Adamsville',
  'Sierra Vista',
  'Flushing',
  'Belleville',
  'Independence',
  'Chalmette',
  'Pearl',
  'Newcastle',
  'Spring',
  'High Point',
  'Panama City',
  'Memphis',
  'Providence Village',
  'Sterling',
  'Kent',
  'Streator',
  'Garland',
  'Harlingen',
  'Gainesville',
  'Easton',
  'Toledo',
  'Providence',
  'Clarksville',
  'Richland',
  'Saint Paul',
  'Lake Worth',
  'Sullivan',
  'Atoka',
  'Altoona',
  'Newark',
  'La Grange',
  'Tempe',
  'Biloxi',
  'Wesley Chapel',
  'Maple Heights',
  'Azusa',
  'Snellville',
  'Winona',
  'Crowley',
  'Boone',
  'Tracy',
  'Laurens',
  'Two Rivers',
  'Valley Park',
  'Grand Forks',
  'Rochester',
  'Bowie',
  'Simi Valley',
  'Harrison',
  'Powder Springs',
  'South Euclid',
  'Frankfort',
  'Tiffin',
  'Duncan',
  'Greensboro',
  'Sunrise',
  'Murray',
  'Mukilteo',
  'Mayfield Heights',
  'Woonsocket',
  'Brenham',
  'San Jacinto',
  'Salem',
  'Ste. Genevieve',
  'Duluth',
  'Lockport',
  'Springfield',
  'Ashland',
  'Meadville',
  'Dodd City',
  'Arizona City',
  'Diamond Bar',
  'Brocton',
  'Turtle Creek',
  'Fort Lauderdale',
  'West Richland',
  'Chatsworth',
  'Carlinville',
  'Westford',
  'Beaver Falls',
  'Redford',
  'Mercer Island',
  'Willow Springs',
  'Chesapeake',
  'Madera',
  'Smyrna',
  'Greenwood',
  'New Albany',
  'Inverness',
  'North Plainfield',
  'Roswell',
  'Claremont',
  'Clinton',
  'Smithfield',
  'Akron',
  'Napoleonville',
  'Nahunta',
  'Hazleton',
  'Wellington',
  'Blue Island',
  'Westbury',
  'Ogden',
  'Galveston',
  'Trinity',
  'Webster',
  'Paw Paw',
  'Xenia',
  'Palo Alto',
  'Dolton',
  'Braselton',
  'Bastrop',
  'Lynchburg',
  'Lake Hopatcong',
  'Riviera Beach',
  'Bay City',
  'Sumter',
  'Stone Mountain',
  'Delmar',
  'Red Oak',
  'Millington',
  'Manchester',
  'Pryor',
  'Greenville',
  'Kosciusko',
  'Holiday',
  'Lauderdale Lakes',
  'Glen Oaks',
  'West Allis',
  'Carrollton',
  'Palmyra',
  'Bessemer',
  'Stuart',
  'Alton',
  'Palmdale',
  'Killeen',
  'Elizabethtown',
  'Leesburg',
  'Grand Island',
  'Walhalla',
  'Gilmer',
  'Jeannette',
  'Oxford',
  'Des Plaines',
  'Fort White',
  'Temple',
  'Biddeford',
  'Oak Lawn',
  'Weatherford',
  'Nicholasville',
  'Lexington',
  'Fresno',
  'Marrero',
  'Wichita',
  'Commerce',
  'Mishawaka',
  'Glassboro',
  'Raven',
  'Westport',
  'Cypress',
  'Plainsboro',
  'West Point',
  'New Hartford',
  'Ashford',
  'Ocean Gate',
  'Breese',
  'Pomona',
  'West Palm Beach',
  'Dearborn Heights',
  'Fuquay-Varina',
  'Pfafftown',
  'Haysville',
  'Myrtle Beach',
  'Brook Park',
  'Scenery Hill',
  'Vineland',
  'Franklinton',
  'Ulster Park',
  'Brandywine',
  'Apopka',
  'Natchitoches',
  'Lake Mary',
  'Bluefield',
  'Stilwell',
  'LaGrange',
  'Flagstaff',
  'Pocatello',
  'Hercules',
  'Raytown',
  'Sun Valley',
  'Monroeville',
  'Slidell',
  'Medina',
  'South Holland',
  'Marietta',
  'South Fulton',
  'Dothan',
  'Cedar Lake',
  'Latham',
  'Douglasville',
  'Theodore',
  'Harker Heights',
  'Robinson',
  'Gardner',
  'Golden Valley',
  'The Colony',
  'Kerman',
  'Murfreesboro',
  'Caldwell',
  'Bismarck',
  'Montgomery',
  'Coral Springs',
  'North Fort Myers',
  'Lowell',
  'La Vergne',
  'Waynesboro',
  'Carteret',
  'Wentzville',
  'Montross',
  'Valley Stream',
  'Sherman',
  'Tulare',
  'Okeechobee',
  'South Burlington',
  'Goffstown',
  'Pittsfield',
  'Union City',
  'Wichita Falls',
  'Texas 78617',
  'Herculaneum',
  'Lithonia',
  'Statham',
  'Stafford',
  'Fort Drum',
  'Monterey Park',
  'Laguna Niguel',
  'Sandy Springs',
  'Lynn Haven',
  'Clearwater',
  'Phenix City',
  'Paterson',
  'South Gate',
  'Cuero',
  'Baldwin',
  'Manchester Center',
  'West Hollywood',
  'Somersworth',
  'Brockton',
  'Long Beach',
  'Happy Valley',
  'Arp',
  'Lanham',
  'Sylvania',
  'Mount Pleasant',
  'Avondale',
  'Eustis',
  'Pittsburgh',
  'Siloam Springs',
  'Lakemoor',
  'Grayson',
  'Tacoma',
  'Elkton',
  'Byron Center',
  'Ewa Beach',
  'Gwynn Oak',
  'Pleasant Prairie',
  'York',
  'Plano',
  'Sulphur Springs',
  'Barnegat',
  'Capitol Heights',
  'Alden',
  'Gibsonia',
  'Rosenberg',
  'Calverton',
  'Groveland',
  'Aspermont',
  'Newville',
  'Jonesboro',
  'Tupelo',
  'Lansdowne',
  'Naples',
  'Leeds',
  'East Rockaway',
  'Flint',
  'East Meadow',
  'Wyalusing',
  'Wickenburg',
  'Griffin',
  'Williamsburg',
  'West',
  'Kokomo',
  'Callaway',
  'Eugene',
  'Ponchatoula',
  'Harvest',
  'Sanford',
  'Hialeah',
  'Gray',
  'Lutz',
  'Redlands',
  'Spring Hill',
  'Anderson',
  'Paducah',
  'Tioga',
  'Chesnee',
  'Claymont',
  'Lemoore',
  'Poquoson',
  'Newington',
  'Moncks Corner',
  'Harper Woods',
  'Southfield',
  'Monroe',
  'Newport News',
  'Timmonsville',
  'Schertz',
  'DeRidder',
  'Griffith',
  'Goodview',
  'Alexandria',
  'De Kalb',
  'Kite',
  'Katy',
  'Honey Grove',
  'Seat Pleasant',
  'Meredith',
  'Coal City',
  '2177 Monroe Dr',
  'Painted Post',
  'Boynton Beach',
  'Fort Wayne',
  'Winchendon',
  'Fort Plain',
  'Tyler',
  'Southgate',
  'Shelby',
  'West Chester Township',
  'Hasbrouck Heights',
  'El Centro',
  'Butler',
  'Sicklerville',
  'Milan',
  'Elk Grove Village',
  'Export',
  'Waterford Twp',
  'Moss Point',
  'Seabrook',
  'Lehigh Acres',
  'Kilgore',
  'Ecorse',
  'Haltom City',
  'Shawano',
  'Plantation',
  'Hoboken',
  'La Mesa',
  'Alamosa',
  'Lakeville',
  'Framingham',
  'Jefferson Hills',
  'Stover',
  'Rialto',
  'Massillon',
  'Ashtabula',
  'Benbrook',
  'Locust Grove',
  'McDonough',
  'Bensalem',
  'Sevierville',
  'Belton',
  'River Rouge',
  'Grantville',
  'Batavia',
  'McFarland',
  'Deer Park',
  'Poteet',
  'Center Point',
  'Frisco',
  'Greeley',
  'Farmersville',
  'Lafayette',
  'Summerville',
  'Troy',
  'Whiteford',
  'Oak Park',
  'College Station',
  'Muskegon',
  'Piedmont',
  'Cartersville',
  'New Tazewell',
  'Beachwood',
  'Burleson',
  'Oneonta',
  'Glade Hill',
  'Prudenville',
  'Freeport',
  'Burlington',
  'Huntersville',
  'Wrightstown',
  'Shubuta',
  'Runaway Bay',
  'Riverside',
  'Charlottesville',
  'Bryan',
  'Evansville',
  'Dunwoody',
  'Palm Bay',
  'McKees Rocks',
  'Glen Ellyn',
  'Hazen',
  'Wadesville',
  'Newnan',
  'Barnwell',
  'Gothenburg',
  'Gary',
  'Reading',
  'Manhattan',
  'Mobile',
  'Renton',
  'Arcadia',
  'Odenton',
  'Central',
  'Bigfork',
  'Rantoul',
  'Swanton',
  'Lindenwold',
  'New Iberia',
  'Central Square',
  'Bossier City',
  'Orange',
  'Miami Beach',
  'Dewitt',
  'Dover',
  'Longview',
  'Castro Valley',
  'Interlachen',
  'Roxboro',
  'St Paul',
  'Heartland',
  'Kaukauna',
  'Green Bay',
  'Boise',
  'Rotonda West',
  'Norcross',
  'Tarpon Springs',
  'Winchester',
  'Nottingham',
  'Crossroads',
  'Dunn',
  'Delaware',
  'Piscataway',
  'Grass Lake',
  'Harlem',
  'Granger',
  'Levittown',
  'Whitehall',
  'Manassas',
  'Wahpeton',
  'Phillipsburg',
  'Orange Park',
  'Seminole',
  'Newburg',
  'San Bernardino',
  'Reserve',
  'Crestview',
  'Bunkie',
  'Michigan City',
  'Grand Blanc',
  'Chattanooga',
  'Jay',
  'Campbell',
  'North Little Rock',
  'Atlantic Beach',
  'Urbandale',
  'Boyce',
  'Rio Rancho',
  'Somerset',
  'Paradise',
  'Horn Lake',
  'Muscatine',
  'Leonard',
  'Bend',
  'Fort Dodge',
  'Opelika',
  'Lyndhurst',
  'Hoover',
  'Nazareth',
  'Shelby Township',
  'Clinton Township',
  'Connellsville',
  'Joliet',
  'Poland',
  'Fort Mill',
  'Fultondale',
  'Pottstown',
  'Tukwila',
  'Cedarbluff',
  'Dawsonville',
  'Highlands Ranch',
  'McKinney',
  '??????',
  'Wise',
  'Weslaco',
  'Wayne',
  'Selma',
  'Cornelius',
  'Austell',
  'Eureka',
  'Livonia',
  'Summit',
  'Corona',
  'Floral City',
  'West Bridgewater',
  'Washington Court House',
  'Mount Prospect',
  'Starkville',
  'Bluffton',
  'Carneys Point',
  'Poplar Bluff',
  'Dexter',
  'El Reno',
  'Binghamton',
  'Grand Forks Afb',
  'Zanesville',
  'Cocoa',
  'Conyers',
  'Brandon',
  'Ashley',
  'Cedar Grove',
  'Plant City',
  'Altamonte Springs',
  'East Haven',
  'Alpharetta',
  'Corpus Christi',
  'Polson',
  'Highland Park',
  'Liberal',
  'North Miami',
  'Garfield Heights',
  'Brighton',
  'Mt Holly',
  'Gilroy',
  'Gaylord',
  'Suffolk',
  'Blakely',
  'Mills River',
  'Fullerton',
  'Bell Gardens',
  'Port Richey',
  'Barrington',
  'Bothell',
  'Iowa Colony',
  'Wyoming',
  'Scottsdale',
  'Port Arthur',
  'Stockholm',
  'Elmhurst',
  'Lima',
  'East Moline',
  'Apache Junction',
  'Lincolnville',
  'Rembert',
  'Deltona',
  'Sweetwater',
  'Tulsa',
  'Maxton',
  'Ballwin',
  'Keswick',
  'Beaumont',
  'Speedway',
  'Monmouth Junction',
  'Madisonville',
  'Loves Park',
  'Solsberry',
  'Zephyrhills',
  'Garden Grove',
  'Newburgh',
  'Gadsden',
  'Lantana',
  'Montello',
  'El Mirage',
  'Watertown',
  'Newbern',
  'Plainfield',
  'Addison',
  'Hagerstown',
  'Oak Ridge',
  'Ansonia',
  'Walker',
  'Hanceville',
  'Saint Charles',
  'Elkins Park',
  'Waukesha',
  'Midland',
  'Washburn',
  'Morgan',
  'Bay St Louis',
  'Murrysville',
  'New Port Richey',
  'Archdale',
  'Burton',
  'Carrier Mills',
  'Tryon',
  'York Haven',
  'Maiden',
  'Gatesville',
  'Lorain',
  'Corinth',
  'Big Spring',
  'North Platte',
  'Warner Robins',
  'Pink Hill',
  'Americus',
  'Anniston',
  'Burkburnett',
  'Cuyahoga Falls',
  'Enoree',
  'Princeton',
  'Maineville',
  'Oviedo',
  'Hague',
  'Delray Beach',
  'Abilene',
  'Ormond Beach',
  'Kenduskeag',
  'Everett',
  'Forest',
  'Wauwatosa',
  'Goshen',
  'Magnolia',
  'Sarasota',
  'Miami Gardens',
  'Williston',
  'Leola',
  'Dearborn',
  'San Angelo',
  'Garden City',
  'Westbrook',
  'Hudsonville',
  'Saint Ann',
  'DeSoto',
  'Venetia',
  'Pascagoula',
  'Margate',
  'Eastland',
  'Breinigsville',
  'Bells',
  'Mamou',
  'Tunnel Hill',
  'Vineyard',
  'Forest View',
  'Swansea',
  'Maryland Heights',
  'Pittsburg',
  'Tomball',
  'New Lexington',
  'Lake City',
  'Buckner',
  'Powhatan',
  'Destin',
  'Bogue Chitto',
  'Peachtree City',
  'Collingswood',
  'Lynnwood',
  'Ripley',
  'Taylors',
  'Balch Springs',
  'Trumbull',
  'Midwest City',
  'Andalusia',
  'Keithville',
  'Minden',
  'Unionville',
  'Spanish Fork',
  'Riverview',
  'Homedale',
  'Titusville',
  'Post Falls',
  'Shawnee',
  'Scarborough',
  'Fort Hood',
  'Clover',
  'Conneaut',
  'Mentor',
  'Eden',
  'Newcomerstown',
  'Pass Christian',
  'Machipongo',
  'Struthers',
  'Emporia',
  'Cullman',
  'Oil City',
  'Creve Coeur',
  'Henrietta',
  'Norwood',
  'Edwardsville',
  'Palatka',
  'Hancock',
  'Rogers',
  'Staffordsville',
  'Garner',
  'Sapulpa',
  'Lemont Furnace',
  'Easley',
  'Plain Dealing',
  'Queensbury',
  'Union',
  'Los Banos',
  'Pensacola',
  'Edison',
  'Kinston',
  'Rancho Cucamonga',
  'Purlear',
  'San Bruno',
  'Dry Ridge',
  'South Salt Lake',
  'Bemidji',
  'White Settlement',
  'Madison',
  'Euclid',
  'Adrian',
  'Calhoun',
  'Wilson',
  'Valrico',
  'Florence',
  'Chillicothe',
  'Byron',
  'Taylorsville',
  'Orting',
  'Vero Beach',
  'Livingston',
  'Falls Church',
  'Bradenton',
  'St. Petersburg',
  'Rockmart',
  'Dixon Springs',
  'Vale',
  'Valdosta',
  'Merritt Island',
  'Wilmerding',
  'Gaston',
  'Harleyville',
  'Marked Tree',
  'Fort Lewis',
  'Palmetto',
  'Odessa',
  'Smithtown',
  'Round Lake Beach',
  'Grove City',
  'Chamblee',
  'Dardanelle',
  'Tuscumbia',
  'Reynoldsburg',
  'Sharon',
  'Cameron',
  'Youngstown',
  'Niceville',
  'Dunedin',
  'North Olmsted',
  'Davenport',
  'Port Charlotte',
  'Athol',
  'Sioux City',
  'Casselberry',
  'Folkston',
  'Parkland',
  'Maricopa',
  'Oriental',
  'Pickerington',
  'Volo',
  'West Pittston',
  'Winsted',
  'Hamden',
  'Coralville',
  'Battlefield',
  'McLoud',
  'Morristown',
  'Rome',
  'Hinesville',
  'Jasper',
  'Barre',
  'San Benito',
  'Branson',
  'Crystal City',
  'Kennesaw',
  'Severn',
  'Bailey',
  'Kentwood',
  'Inglewood',
  'Rockwall',
  'La Fontaine',
  'Hopkinsville',
  'Dorchester',
  'Mount Vernon',
  'Skokie',
  'La Quinta',
  'Fernley',
  'Citrus Heights',
  'North Chesterfield',
  'Aransas Pass',
  'Saint Clair Shores',
  'Conway',
  'Blacksburg',
  'Adel',
  'Trumann',
  'Spring Valley',
  'Nanuet',
  'Midvale',
  'Pueblo',
  'Aubrey',
  'Rockville',
  'Elizabeth',
  'Soddy-Daisy',
  'Perrysville',
  'Schenectady',
  'Passaic',
  'Brookfield',
  'Saginaw',
  'Jamestown',
  'Jeffersonville',
  'Jefferson City',
  'Hot Springs',
  'Henderson',
  'Frederick',
  'Orangevale',
  'Fort Riley',
  'Dequincy',
  'Conshohocken',
  'Mechanicsville',
  'Attleboro',
  'North Wilkesboro',
  'Midway',
  'Port Saint Lucie',
  'Ohkay Owingeh',
  'Saratoga Springs',
  'North Augusta',
  'Roseville',
  'Lewisville',
  'Niles',
  'Shelton',
  'Visalia',
  'Kemp',
  'Yankton',
  'Live Oak',
  'Hapeville',
  'Bremerton',
  'Goldsboro',
  'South Beloit',
  'Melrose',
  'Gosnell',
  'Temple Hills',
  'Clute',
  'Cut Off',
  'Naugatuck',
  'Pompano Beach',
  'Elba',
  'Lenoir',
  'New Carrollton',
  'Kingman',
  'Rittman',
  'Wake Forest',
  'Medley',
  'Aliquippa',
  'Twin Falls',
  'Statesboro',
  'Lake in the Hills',
  'Coppell',
  'West Stockbridge',
  'Vincent',
  'Palisades Park',
  'Mesquite',
  'Joplin',
  'Upper Darby',
  'New Braunfels',
  'Middle Point',
  'Urbana',
  'El Monte',
  'Johnson City',
  'Chetek',
  'Ankeny',
  'Kensington',
  'Falkville',
  'La Porte',
  'Staunton',
  'New Britain',
  'Moulton',
  'Walkersville',
  'Evans Mills',
  'Waxahachie',
  'Spencer',
  'Greeneville',
  'Trotwood',
  'Olympia',
  'Gautier',
  'Cowiche',
  'Immokalee',
  'Battle Creek',
  'Cambridge',
  'Topeka',
  'Chino Hills',
  'St. Augustine',
  'Elmwood Park',
  'Cedar Park',
  'Patterson',
  'Clementon',
  'Westland',
  'Keansburg',
  'Brunswick',
  'Rincon',
  'Vincennes',
  'Grove',
  'Mount Sterling',
  'St. Joseph',
  'Pierre',
  'Tonasket',
  'Muskogee',
  'East Canton',
  'Ridgeland',
  'Fall River',
  'Rensselaer',
  'Wheeling',
  'Montclair',
  'Fremont',
  'Canaseraga',
  'Essex',
  'Bellefonte',
  'Bethlehem',
  'Scottsburg',
  'Lilburn',
  'Fairborn',
  'Church Point',
  'Rancho Cordova',
  'Harriman',
  'Marlborough',
  'Willow Spring',
  'Cookeville',
  'Homer',
  'Clayton',
  'Fairbanks',
  'Canyon',
  'Eufaula',
  'Linganore',
  'Hermiston',
  'Marysville',
  'Pinellas Park',
  'Hillsborough',
  'Van Buren',
  'Bokeelia',
  'Lauderhill',
  'Arkansas City',
  'Blue Springs',
  'Amelia',
  'Cusseta',
  'Greer',
  'Lutherville Timonium',
  'Copperas Cove',
  'Massena',
  'McMinnville',
  'Siler City',
  'Orrville',
  'Vancouver',
  'Kernersville',
  'Wesleyville',
  'Lumberton',
  'Klamath Falls',
  'Tavares',
  'Palestine',
  'Des Moines',
  'Swannanoa',
  'Shelbyville',
  'Franklin',
  'Fairburn',
  'Buckhannon',
  'Little River',
  'La Crosse',
  'Vallejo',
  'Oconomowoc',
  'Mercedes',
  'Gloucester City',
  'Swartz Creek',
  'Minatare',
  'Rhome',
  'Wolfe City',
  'Buna',
  'Ragland',
  'Egg Harbor Township',
  'Rowland',
  'Racine',
  'Loganville',
  'Gamewell',
  'Galesburg',
  'Rockingham',
  'Nixa',
  'Dousman',
  'Kalispell',
  'Festus',
  'Nederland',
  'Dahlonega',
  'New Paris',
  'Spring City',
  'Boca Raton',
  'South Hadley',
  'Fruitport',
  'Apple Creek',
  'Caneyville',
  'Spring Hope',
  'Hamersville',
  'Mt Pleasant',
  'New Richmond',
  'Stanton',
  'Stonecrest',
  'Ardmore',
  'Carlisle',
  'Mount Juliet',
  'Williamston',
  'Overland Park',
  'Darlington',
  'Kerrville',
  'Norman',
  'North Myrtle Beach',
  'Panorama Village',
  'Draper',
  'Kankakee',
  'Yakima',
  'McAllen',
  'South Point',
  'Starks',
  'Windsor Mill',
  'Warsaw',
  'Ypsilanti',
  'West Haven',
  'Inkster',
  'Pageland',
  'Panacea',
  'Danielsville',
  'Queens',
  'Evington',
  'Gastonia',
  'Monaca',
  'Borger',
  'Epping',
  'Brownwood',
  'Macclenny',
  'Windsor',
  'Ephrata',
  'Eunice',
  'Whiteville',
  'Weirton',
  'Gallatin',
  'Maysville',
  'Park Hills',
  'Boggstown',
  'Bolivia',
  'Alsip',
  'Laurel',
  'Vinton',
  'Yemassee',
  'Edgewood',
  'Northwood',
  'Creola',
  'Compton',
  'Elyria',
  'Tallmadge',
  'Pikeville',
  'Mankato',
  'Granbury',
  'Allen',
  'West Warwick',
  'Thompson Falls',
  'Grain Valley',
  'Greenbrier',
  'Porterville',
  'Olaton',
  'Lavonia',
  'Millersville',
  'Milledgeville',
  'Woodward Township',
  'Liberty',
  'Beebe',
  'Montevallo',
  'LaFollette',
  'Paulsboro',
  'Port Huron',
  'Malden',
  'Olive Branch',
  'Dickinson',
  'Wurtsboro',
  'Crete',
  'Sandusky',
  'Laveen Village',
  'South Bend',
  'West Monroe',
  'Allen Park',
  'Greenacres',
  'Utica',
  'West Chester',
  'Hobart',
  'Weir',
  'Cayce',
  'Maple Grove',
  'Germantown',
  'Orrum',
  'Statesville',
  'El Cajon',
  'Wisconsin Rapids',
  'Moore',
  'Bangor',
  'Albertville',
  'Henrico',
  'Morven',
  '???-????',
  'Jennings',
  'Creedmoor',
  'Upper Marlboro',
  'Oroville',
  'Blanchard',
  'Vermilion',
  'Fontana',
  'Bedford',
  'Joshua Tree',
  'Cassatt',
  'Troutman',
  'Del City',
  'Weirsdale',
  'Traverse City',
  'Roseburg',
  'Ozark',
  'Tolleson',
  'Longwood',
  'Largo',
  'Moultrie',
  'Lady Lake',
  'Cedar Bluff',
  'San Mateo',
  'New Brunswick',
  'Erie',
  'Burien',
  'Saddle Brook',
  'Lincolnton',
  'Acworth',
  'DeForest',
  'Altus',
  'Torrington',
  'Wylie',
  'Antlers',
  'Gregory',
  'Eagle',
  'Mission',
  'Florissant',
  'San José',
  'Valparaiso',
  'Terre Haute',
  'Hogansburg',
  'Downey',
  'Friendswood',
  'Wilmore',
  'Milwaukie',
  'Bellport',
  'Water Valley',
  'Natalia',
  '8950 McDowell Common',
  'Petersburg',
  'Rockwood',
  'Radcliff',
  'Auburn',
  'Glen Burnie',
  'Glenside',
  'Benson',
  'Waleska',
  'St Marys',
  'Bennettsville',
  'Avon',
  'Green',
  'Maywood',
  'Escalon',
  'Palos Hills',
  'Broad Brook',
  'Glasgow',
  'Takoma Park',
  'Chelsea',
  'Bremen',
  'Santa Ana',
  'Petaluma',
  'Midlothian',
  'Phil Campbell',
  'West Bloomfield',
  'South Jordan',
  'Calumet City',
  'Kenosha',
  'Sherwood',
  'Plato',
  'DeKalb',
  'Belen',
  'Dade City',
  'Indian Trail',
  'Tarboro',
  'Linden',
  'Grovetown',
  'Westminster',
  'Westchester',
  'Camas',
  'Clay',
  'Piermont',
  'Galax',
  'Niagara Falls',
  'Remington',
  'Slinger',
  'Brambleton',
  'Alvarado',
  'Van Nuys',
  'Lansdale',
  'Plaistow',
  'Catonsville',
  'Thornville',
  'Kensett',
  'Federal Way',
  'Wahiawa',
  'Mebane',
  'Del Rio',
  'West Salem',
  'West Grove',
  'Waterford',
  'Bland',
  'Bay Point',
  'Carmel',
  'Portage',
  'Yuba City',
  'Mount Auburn',
  'Lithia',
  'New Market',
  'Moorhead',
  'Northfield',
  'Brownsburg',
  'Fredericktown',
  'Melba',
  'Southwest Greensburg',
  'Hermitage',
  'Ellenboro',
  'Carolina Beach',
  'Mandan',
  'Fredericksburg',
  'Flora',
  'Blackwell',
  'Glen Gardner',
  'Meridianville',
  'Barstow',
  'Long Island City',
  'Bernardsville',
  'Saint Anthony',
  'Toccoa',
  'Scottsboro',
  'Mableton',
  'Raymond',
  'Bay Saint Louis',
  'Winter Springs',
  'Novi',
  'Plain City',
  'Kents Store',
  'Clay City',
  'North Chicago',
  'Hoosick Falls',
  'Calexico',
  'Kannapolis',
  'Ludlow',
  'Grants Pass',
  'Marina',
  'Harvey',
  'Lovejoy',
  'El Segundo',
  'Kenner',
  'Chula Vista',
  'Morrow',
  'Lakeside',
  'Rossville',
  'Atascosa',
  'Lawndale',
  'Enumclaw',
  'San Gabriel',
  'New Milford',
  'Rancho Palos Verdes',
  'Homestead Meadows',
  'Saint Bernard',
  'Salina',
  'Moline',
  'Drummond Island',
  'Ellenville',
  'Hamburg',
  'Canyon Creek',
  'Senatobia',
  'Union Grove',
  'Exton',
  'Martinez',
  'Weymouth',
  'Auburndale',
  'West Park',
  'Eagan',
  'Wellston',
  'Pottsville',
  'Wood River',
  'Kirby',
  'Godfrey',
  'Eau Claire',
  'Norlina',
  'Fostoria',
  'Johnsburg',
  'Tamiment',
  'Galesville',
  'Miramar',
  'North Aurora',
  'West Covina',
  'Amsterdam',
  '9031 Whispering Pine Ct',
  'Hershey',
  'Holbrook',
  'Land O Lakes',
  'Meadow Vista',
  'Thermopolis',
  'Belgrade',
  'Warrensburg',
  'Cologne',
  'Ironton',
  'Myrtle Creek',
  'Castle Shannon',
  'Newport',
  'Ferris',
  'Belle Glade',
  'North Ridgeville',
  'Carter Lake',
  'Scott City',
  'Goose Creek',
  'Fordyce',
  'Townsend',
  'Brookhaven',
  'New Salem',
  'Olathe',
  'Yellville',
  'Brush',
  'Castle Rock',
  'Ashville',
  'Granby',
  'Dyersburg',
  'Lorton',
  'Stockbridge',
  'Council Bluffs',
  'Springwater',
  'Blue Mound',
  'Horizon City',
  'Commerce Township',
  'Irvine',
  'Camano',
  'Ocean Shores',
  'Breaux Bridge',
  'Bayside',
  'Westover',
  'Sugar Land',
  'Rogersville',
  'Mount Dora',
  'Berkeley',
  'Woodridge',
  'East Rochester',
  'Lacey',
  'Rawlings',
  'Fort Denaud',
  'Spring Lake',
  'Carrizo Springs',
  'Las Cruces',
  'Zion',
  'Brushton',
  'Columbia Station',
  'Humble',
  'Howell',
  'Kingsport',
  'Snow Camp',
  'Redwood City',
  'Chestertown',
  'St Johns',
  'Ludowici',
  'Point Pleasant',
  'Kasson',
  'Marble',
  'Parker',
  'Tinley Park',
  'Canon',
  'Fountain Valley',
  'South Bloomfield',
  'Mart',
  'Saraland',
  'Cromwell',
  'Wallburg',
  'Meeker',
  'Dublin',
  'Brookings',
  'Bennington',
  'Honolulu',
  'Norristown',
  'Pike Road',
  'Walnut Cove',
  'Brownsville',
  'Grand Junction',
  'Hiram',
  'East Point',
  'Clio',
  'Bidwell',
  'Walnut Creek',
  'Toms River',
  'Kelso',
  'Holly Hill',
  'Lenexa',
  'Huntley',
  'Perry',
  'Spotsylvania',
  'Middle River',
  'Saint Johns',
  'Derry',
  'Eaton',
  'Paramus',
  'Mastic',
  'Oakwood',
  'Hebron',
  'Wrens',
  'Graham',
  'Carnesville',
  'St. Charles',
  'Vernon',
  'Sealy',
  'Havana',
  'Kirksville',
  'Gray Court',
  'Payette',
  'Wickliffe',
  'Scaggsville',
  'Hogansville',
  'Clifton',
  'Saint George',
  'Aiken',
  'Rowlett',
  'Fox Lake',
  'Lost Creek',
  'Huntington Park',
  'Fort Gratiot',
  'Hope Mills',
  'Loveland',
  'Newport Beach',
  'North Canton',
  'Hixson',
  'Angola',
  'Brentwood',
  'Colonia',
  'Waukegan',
  'Coraopolis',
  'Bensville',
  'Greenup',
  'West Orange',
  'Belmont',
  'Hoytville',
  'Wellsville',
  'Batesburg',
  'Amherst',
  'Brooklet',
  'Tooele',
  'Seven Mile',
  'Masontown',
  'Grandview',
  'Miamiville',
  'Elgin',
  'Stamford',
  'Pennsauken',
  'Jesup',
  'Sugar Hill',
  'Pisgah Forest',
  'Whitesboro',
  'Elsmere',
  'Sayreville',
  'Ichinomiya-Shi',
  'Marana',
  'Tully',
  'Mount Holly',
  'Johnston',
  'Chehalis',
  'Paris',
  'Alabaster',
  'Holdrege',
  'Keystone Heights',
  'Flatwoods',
  'Manteca',
  'Caruthers',
  'Bloomfield',
  'Litchfield',
  'Camdenton',
  'La Marque',
  'Palm Beach Gardens',
  'Medford',
  'Summerland Key',
  'Port Bolivar',
  'Mooresville',
  'Brown Deer',
  'Murphysboro',
  'Desert Hot Springs',
  'Delphos',
  'Baxter Springs',
  'Coram',
  'North Hampton',
  'Bentonville',
  'Eagle Springs',
  'Strawberry Plains',
  'Gleannloch Farms',
  'Palm Coast',
  'Evanston',
  'Junction City',
  'Lapeer',
  'Wheatland',
  'North Miami Beach',
  'Huntingdon Valley',
  'Middleburg',
  'Bixby',
  'Wimauma',
  'Enid',
  'Gurnee',
  'West Bend',
  'Holley',
  'Hollins',
  'Lexington Park',
  'Carbondale',
  'Bowman',
  'Crossville',
  'Holdenville',
  'Lonedell',
  'Verona',
  'Alabama 35184',
  'Moorpark',
  'Mt Olive',
  'Culpeper',
  'Salt Lake City',
  'Holcomb',
  'Ruffin',
  'Meriden',
  'Parma Heights',
  'Myerstown',
  'Marksville',
  'Cleburne',
  'Oakley',
  'Hahira',
  'Duncannon',
  'Menard',
  'Doral',
  'Sylacauga',
  'Ward',
  'Lake Alfred',
  'Stafford Township',
  'Winder',
  'Gulf Breeze',
  'Avella',
  'Montour Falls',
  'Darien',
  'Pampa',
  'Crocker',
  'Centerville',
  'West Melbourne',
  'Coats',
  'Kimball',
  'Otwell',
  'Colmesneil',
  'Cape Girardeau',
  'Forked River',
  'Hutto',
  'Fort Pierce',
  'Gordonsville',
  'Villas',
  'Sumner',
  'Venice',
  'Lykens',
  'Nancy',
  'Ringgold',
  'Avilla',
  'Chapel Hill',
  'Thomaston',
  'Jefferson',
  'Kearney',
  'Richfield',
  'Hazel Park',
  'Nathalie',
  'Geneseo',
  'New Oxford',
  'Muncie',
  'Norwich',
  'Boydton',
  'Ellerbe',
  'Palm Harbor',
  'Waldo',
  'Irvington',
  'Sequim',
  'Granite City',
  'Toney',
  'Millbrook',
  'Winter Park',
  'Vandalia',
  'Big Sandy',
  'Bayville',
  'Villa Ridge',
  'Troup',
  'Mineral Wells',
  'Deptford',
  'Silsbee',
  'Sanders',
  'Vine Grove',
  'DeBary',
  'Falmouth',
  'Maryville',
  'Clear Lake',
  'Montoursville',
  'Throop',
  'Media',
  'Watson',
  'TX 78759',
  'Doylestown',
  'Claremore',
  'Hertford',
  'West Terre Haute',
  'Marthasville',
  'Corunna',
  'New Providence',
  'Butte',
  'North Port',
  'Durant',
  'Stow',
  'Wilkes-Barre',
  'Groton',
  'Edcouch',
  'Mokena',
  'Green Cove Springs',
  'Galena',
  'Bridgeport',
  'Byesville',
  'Louisa',
  'Rock Falls',
  'Ferguson',
  'Minot',
  'Camilla',
  'Haines City',
  'Scottsbluff',
  'Moscow',
  'Lake Wales',
  'Hemby Bridge',
  'Cape Canaveral',
  'Pullman',
  'Medway',
  'Winnfield',
  'Cuba',
  'Copiague',
  'Willard',
  'Wormleysburg',
  'Suitland',
  'Brooksville',
  'Fort Wright',
  'Wedgefield',
  'Costa Mesa',
  'Mayfield',
  'Westfield',
  'Oak Grove',
  'Abernathy',
  'Bellair',
  'Cheviot',
  'Indio',
  'Rancho Mirage',
  'Parkin',
  'Darby',
  'Holly Springs',
  'East Orange',
  'Reedley',
  'Blackshear',
  'Pasco',
  'Indiana',
  'Willis',
  'Allendale',
  'Prentiss',
  'Stephens City',
  'Marlton',
  'Flossmoor',
  'Edinburg',
  'Gardena',
  'Bath',
  'Sebring',
  'Fort Campbell',
  'Cheshire',
  'Crawfordsville',
  'Commerce City',
  'East Jordan',
  'Washingtonville',
  'New Bern',
  'Sterling Heights',
  'Clear Spring',
  'Chicopee',
  'California',
  'Big Rapids',
  'Pomfret Center',
  'Pitcairn',
  'Tilton',
  'Hodges',
  'Cicero',
  'Cerritos',
  'Springville',
  'Broken Arrow',
  'Hampstead',
  'Fort Polk',
  'Punxsutawney',
  'Westwego',
  'Olanta',
  'Villa Hills',
  'Forsyth',
  'Eastpointe',
  'Elkridge',
  'Webb City',
  'Johns Creek',
  'Hayward',
  'Altadena',
  'Greencastle',
  'Arcade',
  'Fallbrook',
  'Mountlake Terrace',
  'Glendale Heights',
  'Asheboro',
  'College Park',
  'Euharlee',
  'Joppa',
  'Ammon',
  'Imperial',
  'Avon Park',
  'Pulaski',
  'Cullowhee',
  'Naperville',
  'Jurupa Valley',
  'Emerald Hills',
  'Quincy',
  'Mattoon',
  'Port Orchard',
  'Puyallup',
  'Little Elm',
  'Anadarko',
  'North Highlands',
  'Anaheim',
  'Oilville',
  'Aliso Viejo',
  'Eastvale',
  'Coronado',
  'Cottleville',
  'Yorkville',
  'Turner',
  'Leto',
  'San Clemente',
  'George West',
  'Turlock',
  'Temple City',
  'Pikesville',
  'Mendenhall',
  'La Follette',
  'New Hempstead',
  'Saint Augustine',
  'Wadsworth',
  'Stony Point',
  'Lorena',
  'Lillian',
  'South Berwick',
  'Berea',
  'Dyer',
  'Ellicott City',
  'Uniondale',
  'Southern Pines',
  'Kyle',
  'Monticello',
  'Billings',
  'Liverpool',
  'Upland',
  'Cottage Grove',
  'Sandersville',
  'Alhambra',
  'Hamptonville',
  'Twin Lakes',
  'Warrior',
  'Yulee',
  'Chino',
  'Hillside',
  'Havre',
  'Sand Creek',
  'Freemansburg',
  'McLean',
  'Monahans',
  'Hayesville',
  'Hobbs',
  'Tallassee',
  'Warrenton',
  'Jersey Village',
  'West College Corner',
  'Colonial Beach',
  'DuPont',
  'Martinsburg',
  'Pearland',
  'Miami Lakes',
  'Martins Ferry',
  'Holts Summit',
  'Ruston',
  'Littlefield',
  'Fountain Hill',
  'Goodyear',
  'Thomasboro',
  'Cheney',
  'Lewes',
  'Cleveland Heights',
  'Maplewood',
  'New Smyrna Beach',
  'Albert Lea',
  'Doraville',
  'Cheraw',
  'Federalsburg',
  'Bellwood',
  'Williamstown',
  'Cedarville',
  'Pine Island',
  'Margate City',
  'West Chicago',
  'Winston Salem',
  'Edgewater',
  'Rougemont',
  'Buford',
  'Youngsville',
  'Mount Joy',
  'Beckley',
  'New Boston',
  'Burbank',
  'De Soto',
  'Alliance',
  'Guyton',
  'Natchez',
  'Atwater',
  'Crawford',
  'Kenai',
  'Camp Hill',
  'Morgan Hill',
  'Fargo',
  'La Place',
  'Apple Valley',
  'Daleville',
  'Saltville',
  'Moore Haven',
  'Temple Terrace',
  'Nipomo',
  'Woodlawn',
  'Rancho Santa Margarita',
  'Hanford',
  'Brooklyn Center',
  'Skiatook',
  'Morrison',
  'Skowhegan',
  'Oak Point',
  'Rock Springs',
  'East Bend',
  'Landaff',
  'Linwood',
  'River Edge',
  'Dalton',
  'Redfield',
  'Blackwood',
  'Suisun City',
  'Manteno',
  'Checheng Township',
  'Travelers Rest',
  'North Kansas City',
  'Huger',
  'Brookshire',
  'Highland',
  'Fort Stockton',
  'Miamisburg',
  'Clawson',
  'Crosbyton',
  'Cantonment',
  'San Rafael',
  'Shawnee Land',
  'Milpitas',
  'Escondido',
  'Walla Walla',
  'Crystal Lake',
  'Herkimer',
  'Eolia',
  'Hutchins',
  'La Habra',
  'Crest Hill',
  'Channahon',
  'La Crescenta',
  'Manhattan Beach',
  'Bardstown',
  'Jacksonville Beach',
  'Fruitland',
  'Mims',
  'Greenwich',
  'Weiser',
  'Webberville',
  'Kenilworth',
  'Bauxite',
  'Port Wentworth',
  'Santa Monica',
  'Coldspring',
  'New London',
  'Oswego',
  'Busy',
  'Roy',
  'Ventura',
  'Hazel Green',
  'Berne',
  'Wittmann',
  'Covina',
  'Tarrytown',
  'Kimberly',
  'Danbury',
  'Williamsville',
  'Clarksburg',
  'Sewell',
  'Vonore',
  'Chuluota',
  'Forest Lake',
  'Gretna',
  'Waxhaw',
  'Yadkinville',
  'Champlin',
  'Shepherd',
  'Latta',
  'Sallisaw',
  'Duquesne',
  'Lucedale',
  'Broadview',
  'Winfield',
  'Powell',
  'Leicester',
  'New Cumberland',
  'Cutler Bay',
  'Sabina',
  'Flowery Branch',
  'West Babylon',
  'Hemet',
  'Russellville',
  'Fort Valley',
  'Oceanside',
  'Higginsville',
  'Elkin',
  'Hazel Crest',
  'Buena Park',
  'White Lake',
  'Hart',
  'Grafton',
  'Silver Creek',
  'Bexley',
  'Lillington',
  'East Stroudsburg',
  'Atchison',
  'Juliette',
  'Reedsville',
  'Dalhart',
  'Rio Grande',
  'Neptune',
  'North Fond du Lac',
  'Orangeburg',
  'Maple Shade',
  'Chipley',
  'Fairmount',
  'River Falls',
  'Swedesboro',
  'Hazelwood',
  'Ashdown',
  'Cathedral City',
  'London',
  'Rocky Mount',
  'Nassau Village',
  'Gibsonville',
  'Blythe',
  'Pawtucket',
  'Coffeeville',
  'Jackson Springs',
  'Opelousas',
  'Cumming',
  'Inman',
  'Roanoke Rapids',
  'Snohomish',
  'Sheffield',
  'West End',
  'Wasilla',
  'Wrightsville Beach',
  'Frostburg',
  'Elk Grove',
  'Park Forest',
  'Edmond',
  'Ithaca',
  'Fort Mitchell',
  'Dwale',
  'Villa Rica',
  'Franklin Park',
  'Castaic',
  'Wauconda',
  'Yuma',
  'Sidney',
  'Talladega',
  'East Lake',
  'Williamson',
  'Chanhassen',
  'Kingsford Heights',
  'Colonie',
  'Encinitas',
  'Cedartown',
  'Waynesville',
  'Grottoes',
  'Gulf Shores',
  'Dana Point',
  'Forest Hill',
  'Montalvin',
  'Tigard',
  'Mattapoisett',
  'Key West',
  'Front Royal',
  'Parkville',
  'San Luis Obispo',
  'Ludington',
  'East Bridgewater',
  'Dawson',
  'Kingwood',
  'Santa Paula',
  'Prattville',
  'Nueva York',
  'Fishers',
  'Bellbrook',
  'Flordell Hills',
  'Erlanger',
  'Egg Harbor City',
  'Ravenna',
  'West Jordan',
  'Pico Rivera',
  'Cross',
  'Bainbridge',
  'Royal Oak',
  'Broxton',
  'Bartow',
  'Stafford Springs',
  'La Mirada',
  'League City',
  'Cordele',
  'Saint Cloud',
  'Prince Frederick',
  'Barnesville',
  'Sachse',
  'Placentia',
  'Boyne City',
  'Diberville',
  'Bonham',
  'Albemarle',
  'Sugarloaf',
  'Natick',
  'Mission Viejo',
  'Folsom',
  'Roselle',
  'Windermere',
  'Pontiac',
  'Warwick',
  'Zebulon',
  'Lake Zurich',
  'Marianna',
  'Cudahy',
  'Mc Alisterville',
  'Coosada',
  'National City',
  'East Quogue',
  'Sanger',
  'Cary',
  'Bolivar',
  'Jonesville',
  'Spindale',
  'West Hartford',
  'Dillwyn',
  'Markham',
  'Richmond Hill',
  'White Haven',
  'Aventura',
  'Orwell',
  'Clifton Heights',
  'Waldoboro',
  'Outlook',
  'Elmont',
  'Palm City',
  'Dunkirk',
  'Bellevue',
  'Fortson',
  'Saint Anne',
  'Grosse Pointe Farms',
  'Totowa',
  'Longmont',
  'Vista',
  'Vacaville',
  'Thomasville',
  'Goleta',
  'South Chicago Heights',
  'Dubach',
  'Lockbourne',
  'Belzoni',
  'Thermal',
  'Redondo Beach',
  'Morrisville',
  'Elon',
  'LaFayette',
  'Grayling',
  'Shippensburg',
  'Morrisonville',
  'Bradford',
  'Wakeman',
  'Sahuarita',
  'Weeki Wachee',
  'Weston',
  'Prince George',
  'Folcroft',
  'Lompoc',
  'Rapidan',
  'Long View',
  'Newaygo',
  'Magna',
  'Celina',
  'Raeford',
  'Stanley',
  'Frewsburg',
  'Parkersburg',
  'Evans',
  'Morehead City',
  'Louisburg',
  'Holualoa',
  'Sunnyside',
  'South Milwaukee',
  'North Kingstown',
  'Delta',
  'University City',
  'Alice',
  'Banning',
  'Daphne',
  'Hueytown',
  'Fairfax',
  'Loma Linda',
  'Farmville',
  'Fernandina Beach',
  'Bridgeton',
  'Osceola',
  'Apex',
  'Overton',
  'White Plains',
  'Fair Lawn',
  'Saint Helens',
  'Mount Ephraim',
  'Ann Arbor',
  'Joshua',
  'Snow Hill',
  'Rio Grande City',
  'Vinita Park',
  'Dansville',
  'Pleasantville',
  'South Tucson',
  'Aptos Hills',
  'Harrisonville',
  'Kenmore',
  'Sweeny',
  'Prichard',
  'Willmar',
  'Massapequa',
  'Mohegan Lake',
  'La Puente',
  'Hialeah Gardens',
  'Sparkman',
  'Randallstown',
  'Centereach',
  'Crewe',
  'Manassas Park',
  'East Petersburg',
  'Canfield',
  'Triangle',
  'Stevensville',
  'Strafford',
  'Dumfries',
  'Jonesborough',
  'Ellensburg',
  'Lynn',
  'Rockville Centre',
  'Wadley',
  'District Heights',
  'Ashburn',
  'Kings Mountain',
  'Bryant',
  'Brownstown',
  'Baker',
  'Martinsville',
  'Livermore',
  'Lombard',
  'Franklin Lakes',
  'Reston',
  'Burtonsville',
  'Marsing',
  'Castle Hills',
  'Antigo',
  'Santa Barbara',
  'Murrieta',
  'Westmont',
  'Bean Station',
  'De Pere',
  'Buckeye',
  'Boiling Springs',
  'Hamilton Township',
  'Huntington Station',
  'Ijamsville',
  'Tuskegee',
  'Opa-locka',
  'Glenn Heights',
  'North Providence',
  'Morganfield',
  'Berwick',
  'Danvers',
  'Warr Acres',
  'Mason City',
  'Florida City',
  'Pine Bluff',
  'Hanahan',
  'Alcoa',
  'Chichester',
  'Roosevelt',
  'Tyngsboro',
  'West York',
  'Robbins',
  'Fairview',
  'Canyonville',
  'Anaconda',
  'Bullhead City',
  'Millsboro',
  'Clyde',
  'Maurice',
  'Antelope',
  'Leominster',
  'Fort Myer',
  'Plainville',
  'The Acreage',
  'Clifton Springs',
  'Huntington',
  'Kingston',
  'Beaufort',
  'Fair Oaks Ranch',
  'Bunnlevel',
  'Sultan',
  'Denison',
  'Muskego',
  'Wheelersburg',
  'Rex',
  'Sylvester',
  'Carol Stream',
  'Shallowater',
  'Byram',
  'Kennett',
  'Hackensack',
  'Westville',
  'Bladensburg',
  'Pharr',
  'Lomita',
  'Mauldin',
  'Rocky Gap',
  'Teaneck',
  'Bell',
  'Leland',
  'Harahan',
  'Warrensville Heights',
  'Pataskala',
  'Talbotton',
  'Morriston',
  'Mattapan',
  'Coatesville',
  'Lyons',
  'Stella',
  'Davie',
  'Middleburgh',
  'North Wales',
  'South Miami',
  'Conover',
  'Laramie',
  'Avalon',
  'Hartsville',
  'Kingsville',
  'Lahaina',
  'West Sacramento',
  'Edwards',
  'Four Oaks',
  'View Park',
  'West Milwaukee',
  'Waverly',
  'Cardington',
  'Windcrest',
  'Bolckow',
  'Central Islip',
  'Bergenfield',
  'Rocklin',
  'Cockatoo Valley',
  'Hodgkins',
  'Tonawanda',
  'Pineland',
  'Mancos',
  'Quakertown',
  'Proctorville',
  'Iselin',
  'Scotland Neck',
  'Safety Harbor',
  'Crawfordville',
  'Saucier',
  'Fairport',
  'Galion',
  'Glen Allen',
  'Hilton Head Island',
  'Morganton',
  'Manitowoc',
  'West Deptford',
  'Shawneetown',
  'Golden',
  'Stratford',
  'Anacortes',
  'South Elgin',
  'Spotsylvania Courthouse',
  'Cowan',
  'Irons',
  'Beverly Hills',
  'Saint Peters',
  'Panorama City',
  'Redmond',
  'Rock Island',
  'Lockhart',
  'Stanford',
  'Arnold',
  'Walnutport',
  'Strongsville',
  'Swissvale',
  'Menifee',
  'The Plains',
  'Pantego',
  'Shorewood',
  'Pleasant Shade',
  'East Providence',
  'Bethune',
  'Cockeysville',
  'Royal Palm Beach',
  'Downers Grove',
  'Kilmarnock',
  'Wendell',
  'Carmi',
  'Affton',
  'Woodruff',
  'Villa Park',
  'Kenneth City',
  'Cameron Park',
  'Waldwick',
  'Beeville',
  'Broadway',
  'Denver City',
  'North Mankato',
  'Fulton',
  'Richland Hills',
  'Silverhill',
  'Buena Vista',
  'Sugar Notch',
  'Haverstraw',
  'Amite',
  'Fort Blackmore',
  'Hohenwald',
  'Black Mountain',
  'Washington Terrace',
  'Montgomery Village',
  'Los Lunas',
  'Masury',
  'Richmond Heights',
  'Glen Lyn',
  'Twinsburg',
  'Cassopolis',
  'Richwood',
  'Springport',
  'New Roads',
  'Hallandale Beach',
  'Narvon',
  'Sorrento',
  'Oregon',
  'Riverdale Park',
  'Semmes',
  'Whatley',
  'Drexel',
  'Chantilly',
  'Lecanto',
  'South Orange',
  'Fruita',
  'Taneytown',
  'Roma',
  'West Fargo',
  'Desloge',
  'Hoffman Estates',
  'Mystic',
  'Wagener',
  'Eden Prairie',
  'Clarksdale',
  'Eagle Lake',
  'Gordon',
  'Effingham',
  'Geneva',
  'Harmans',
  'Streetsboro',
  'Diamond Springs',
  'Saint James',
  'Lehi',
  'Wallace',
  'Craig',
  'Romeoville',
  'Bluff City',
  'Herriman',
  'Thousand Palms',
  'Woburn',
  'Big Stone Gap',
  'Milford',
  'Scranton',
  'Shrewsbury',
  'Madill',
  'Wenatchee',
  'Chanute',
  'Etta',
  'Calumet Park',
  'MO 63939',
  'Fleming Island',
  'Forest Heights',
  'Lake Placid',
  'Prescott Valley',
  'Northglenn',
  'Spearfish',
  'Westerville',
  'Mechanicville',
  'Ponte Vedra Beach',
  'Palos Heights',
  'Crosby',
  'Montezuma',
  'Centreville',
  'East Cleveland',
  'East Lansing',
  'Hendersonville',
  'East Bangor',
  'Susanville',
  'University Place',
  'South Saint Paul',
  'Seagrove',
  'Reminderville',
  'Lyles',
  'Vernon Rockville',
  'Dakota City',
  'Whitehouse',
  'Thiells',
  'Moses Lake',
  'Tangipahoa',
  'DeFuniak Springs',
  'West Cape May',
  'Hull',
  'Golf Manor',
  'Blackfoot',
  'Stallings',
  'Rienzi',
  'Port St. Lucie',
  'Knightdale',
  'Donalsonville',
  'Biscoe',
  'Labelle',
  'Lavon',
  'Dingmans Ferry',
  'Upper Sandusky',
  'Town Creek',
  'Rockwell',
  'Dinuba',
  'Olivehurst',
  'Connelly Springs',
  'Ooltewah',
  'Litchfield Park',
  'Ruskin',
  'Winamac',
  'North Salt Lake',
  'Lake Forest',
  'Cleves',
  'West Lafayette',
  'Lisle',
  'Catoosa',
  'Brackenridge',
  'Tobyhanna',
  'Ocoee',
  'Woodfin',
  'Riverton',
  'Leawood',
  'Cliffside Park',
  'Landing',
  'Raymore',
  'Ellington',
  'Olching',
  'South Colton',
  'Corrales',
  'Slab Fork',
  'Gervais',
  'Sheridan',
  'Tualatin',
  'Dunbar',
  'Winter Garden',
  'Deming',
  'Gladstone',
  'El Campo',
  'Midville',
  'Park City',
  'Wanaque',
  'Village of Pewaukee',
  'Flowood',
  'Ladson',
  'Crestwood',
  'Aulander',
  'Lewisburg',
  'Prescott',
  'Issaquah',
  'Sauk Rapids',
  'Mexico',
  'Auburntown',
  'Wausau',
  'Deland',
  'Berlin',
  'Pineville',
  'Yorba Linda',
  'East Helena',
  'Hopkins',
  'Imlay City',
  'Missoula',
  'Mount Clemens',
  'Barnstable',
  'Quinby',
  'Jenkintown',
  'Chino Valley',
  'Richton Park',
  'Vanceburg',
  'Rayville',
  'Saint Albans',
  'The Rock',
  'Tustin',
  'Camby',
  'Stroudsburg',
  'Bordentown',
  'American Fork',
  'Rushville',
  'Bessemer City',
  'Mt. Juliet',
  'Keene',
  'Dutton',
  'Culver City',
  'West Selmont',
  'Peshastin',
  'Pierce',
  'North College Hill',
  'Taylor',
  'Ararat',
  'Kamas',
  'Carson City',
  'Fountain Inn',
  'Pemberville',
  'Herndon',
  'Wapakoneta',
  'Walton',
  'Herisau',
  'South Hempstead',
  'Crystal',
  'Pilot Point',
  'Parma',
  'Tuttle',
  'Needham',
  'Olean',
  'Roland',
  'Maurepas',
  'Anna',
  'Angier',
  'Punta Gorda',
  'Fife',
  'Dundee',
  'Talent',
  'Mount Morris',
  'Coquille',
  'Belle Chasse',
  'Hope Hull',
  'Blue Ash',
  'Judsonia',
  'West St. Paul',
  'Big Lake',
  'South Charleston',
  'Eutawville',
  'Galloway',
  'Lilesville',
  'Glenwood Springs',
  'Mt Eden',
  'Boonville',
  'Casper',
  'Selah',
  'Cherokee',
  'Socorro',
  'South San Francisco',
  'San Tan Valley',
  'Manakin-Sabot',
  'Corry',
  'Creal Springs',
  'Barberton',
  'Saint Clairsville',
  'Elma',
  'Norco',
  'Box Elder',
  'Bellefontaine',
  'Wappingers Falls',
  'Janesville',
  'Drexel Hill',
  'Columbia Heights',
  'Clemmons',
  'West Loch Estates',
  'Windsor Heights',
  'Hanson',
  'Kapolei',
  'Porter',
  'Modesto',
  'Tecumseh',
  'Spur',
  'Menomonee Falls',
  'Hornell',
  'Stanwood',
  'Austinville',
  'Sonora',
  'Somerville',
  'Penrose',
  'California City',
  'Dixon',
  'Gunter',
  'Prosper',
  'Floresville',
  'Indian Head',
  'New Bedford',
  'Kettering',
  'Lynden',
  'Leonardtown',
  '8050 N 19th Ave',
  'Hilo',
  'Linn',
  'Wilton Manors',
  'Gore',
  'Kendall West',
  'Rolesville',
  'Worthington',
  'Parsippany',
  'Alburtis',
  'Federal Heights',
  'Rigby',
  'Wonder Lake',
  'Byrdstown',
  'St Anthony',
  'Selinsgrove',
  'Overbrook',
  'Ridgway',
  'Barboursville',
  'Maple Hill',
  'Westby',
  'Wilsonville',
  'Watauga',
  'Wheat Ridge',
  'Weed',
  'Aloha',
  'Parkside',
  'Port Allegany',
  'Glenwood',
  'Nocona',
  'Destrehan',
  'Advance',
  'Ringtown',
  'Itasca',
  'Ragley',
  'Ridgefield',
  'Union Springs',
  'Melrose Park',
  'Port Angeles',
  'Sandy',
  'Brick',
  'Hardy',
  'Slatington',
  'East Wenatchee',
  'Ayden',
  'Chesterfield',
  'Clarkston',
  'Fort Fairfield',
  'Winterville',
  'Baldwinsville',
  'Ballston Spa',
  'Onalaska',
  'Dunmore',
  'Haddon Township',
  'Rockland',
  'Lathrop',
  'Boonsboro',
  'Idabel',
  'Pendleton',
  'Seymour',
  'Hartsdale',
  'Orosi',
  'Modena',
  'Orland',
  'Owasso',
  'Elwood',
  'Manvel',
  'Fruitland Park',
  'Delhi',
  'Crown Point',
  'Wolfforth',
  'Zillah',
  'Fort George G Meade',
  'Beloit',
  'Montpelier',
  'New Kent',
  'Newtown Square',
  'Pipestone',
  'Brockport',
  'Kutztown',
  'Perris',
  'Middleton',
  'Oregonia',
  'Gause',
  'Fort Mc Coy',
  'Springtown',
  'Willow Grove',
  'Watsontown',
  'Dewy Rose',
  'Port Allen',
  'Clermont',
  'Plains',
  'Barbourville',
  'Menasha',
  'Manistee',
  'Ramona',
  'Widefield',
  'Sturbridge',
  'Olivet',
  'Le Roy',
  'Laurel Hill',
  'Caddo Mills',
  'Mashpee',
  'Enfield',
  'Cedar Falls',
  'Rockton',
  'Woodsville',
  'Accokeek',
  'Farmingdale',
  'Streamwood',
  'Hot Springs Township',
  'Standish',
  'Red Wing',
  'Oak Vale',
  'Atascadero',
  'New Kensington',
  'Sunset',
  'Loudon',
  'Kouts',
  'Cordova',
  'Nicoma Park',
  'Howardville',
  'Radford',
  'Crescent Springs',
  'Greenhills',
  'Bonney Lake',
  'Ridgefield Park',
  'Great Mills',
  'Amissville',
  'Golconda',
  'Woodville',
  'Veedersburg',
  'Waunakee',
  'Mt Royal',
  'Adelanto',
  'Red Bank',
  'Stoneville',
  'Mt Airy',
  'North Catasauqua',
  'Shelocta',
  'Everman',
  'Edenton',
  'Pollock',
  'Deloit',
  'Alvin',
  'Princeville',
  'West Blocton',
  'Hartsburg',
  'Lewis Center',
  'Mt Hermon',
  'Nutter Fort',
  'Big Rock',
  'Bellmawr',
  'Calcium',
  'Maple Falls',
  'Midfield',
  'Chickamauga',
  'Manteo',
  'Pine Hill',
  'Beech Creek',
  'Bealeton',
  'Ninety Six',
  'Clearfield',
  'Owatonna',
  'Whitney',
  'Chester Springs',
  'Orem',
  'Arden',
  'Brewerton',
  'McAdenville',
  'Birch Run',
  'Hookerton',
  'Perryville',
  'Owensboro',
  'Ball Ground',
  'New Baltimore',
  'Lock Haven',
  'West Memphis',
  'Macomb',
  'Hanover',
  'Palmer',
  'Hatfield',
  'Robbinsdale',
  'Hobe Sound',
  'Torrance',
  'Quilcene',
  'Hyde Park',
  'Sumiton',
  'Big Bear City',
  'South Lake Tahoe',
  'Wilton',
  'Hawkinsville',
  'Pelham',
  'Paragould',
  'Bourbonnais',
  'Guttenberg',
  'Nevada',
  'Belmar',
  'Grant',
  'Kearneysville',
  'Canal Winchester',
  'Pelahatchie',
  'Pottsboro',
  'Dunnellon',
  'Reagan',
  'New Waterford',
  'Leavenworth',
  'Lakehills',
  'Hardeeville',
  'Jerseyville',
  'University Heights',
  'Munfordville',
  'Chalfont',
  'Chesilhurst',
  'Churubusco',
  'Collinsville',
  'Cohoes',
  'Moody',
  'Chattahoochee',
  'Battle Ground',
  'Buda',
  'Swainsboro',
  'Blair',
  'Granite Falls',
  'Lititz',
  'Cornwall',
  'Paso Robles',
  'Neosho',
  'East Amherst',
  'Orange City',
  'Afton',
  'Autryville',
  'Walterboro',
  'South Chesterfield',
  'Santa Fe',
  'Commack',
  'Millstone Township',
  'Newbury',
  'Ekron',
  'Roper',
  'Rosemount',
  'Ocean Township',
  'Fort Recovery',
  'Eatonton',
  'San Augustine',
  'Camarillo',
  'Ebony',
  'Hawaiian Gardens',
  'Defiance',
  'Laie',
  'Oolitic',
  'Pevely',
  'Mukwonago',
  'Clinton Twp',
  'Granville',
  'Estill Springs',
  'Post',
  'Oak Creek',
  'Rice Lake',
  'Mount Olive',
  'Andersonville',
  'Grifton',
  'Secane',
  'Williamsport',
  'Shafter',
  'North Middletown',
  'Mount Laurel',
  'Lime Springs',
  'Southampton',
  'North Bay Village',
  'Idaho Falls',
  'Council',
  'Galena Park',
  'Searcy',
  'Guthrie',
  'Blaine',
  'Lakeport',
  'North Brunswick',
  'Prospect',
  'East Freedom',
  'Forest Acres',
  'Eure',
  'Dadeville',
  'El Dorado',
  'Havelock',
  'Pioneer',
  'Hot Springs National Park',
  'Channelview',
  'Felton',
  'Coon Rapids',
  'Republic',
  'Browns Summit',
  'Port Orange',
  'North Logan',
  'Saukville',
  'Dakota',
  'El Lago',
  'Middleboro',
  'Elkmont',
  'Standard',
  'Spooner',
  'Stagecoach',
  'Rolling Meadows',
  'Sandston',
  'Beatrice',
  'Sunset Beach',
  'Bogart',
  'Fosters',
  'Mooresboro',
  'Homer Glen',
  'Silverdale',
  'Pioneer Village',
  'Uncasville',
  'Burgettstown',
  'Supply',
  'Colusa',
  'Phelan',
  'Prospect Park',
  'Star City',
  'Sunbury',
  'Burney',
  'Clairton',
  'Wasco',
  'Fair Haven',
  'High Ridge',
  'Margaret',
  'Shadyside',
  'Lithia Springs',
  'Chesterland',
  'Nebo',
  'Beverly',
  'New Brighton',
  'Moneta',
  'Ellsworth',
  'Weehawken',
  'Parshall',
  'Pelion',
  'Mamaroneck',
  'Dalzell',
  'Sarah',
  'Lauderdale',
  'Wilsons',
  'Bayport',
  'Hollandale',
  'East Ridge',
  'Helendale',
  'Seaman',
  'Charlestown',
  'Eastman',
  'Tarrant',
  'North Beach',
  'Bel Alton',
  'Dittmer',
  'Thousand Oaks',
  'Roseland',
  'Camp Lejeune Marine Corps Base',
  'North East',
  'Fort Rucker',
  'Calamus',
  'Mill Spring',
  'Mont Clare',
  'Bridgeville',
  'Quinton',
  'Star',
  'Stamping Ground',
  'Silverado',
  'Rosharon',
  'West Carrollton',
  'Imperial Beach',
  'Payneville',
  'Merrillville',
  'Brea',
  'Wagoner',
  'Primera',
  'Harleysville',
  'Yorktown',
  'Cresson',
  'West Des Moines',
  'Pacific',
  'Cheverly',
  'Easthampton',
  'Scioto Mills',
  'Falls Of Rough',
  'Corning',
  'New Carlisle',
  'Sour Lake',
  'Fortville',
  'Bondurant',
  'Spanish Fort',
  'Homosassa',
  'Pleasant Hill',
  'Beaver Dam',
  'Broadview Heights',
  'Timberlake',
  'Franklinville',
  'Gallipolis',
  'Wamego',
  'Winters',
  'Alabama 36750',
  'Colmar Manor',
  'Springboro',
  'Posen',
  'Downingtown',
  'Abbottstown',
  'Central City',
  'Lake Jackson',
  'Winterset',
  'Cave City',
  'Hibbing',
  'Aledo',
  'Alba',
  'Sun Prairie',
  'Tifton',
  'Carthage',
  'Elmira',
  'Canterbury',
  'Mount Healthy',
  'Sugar Grove',
  'Tullahoma',
  'Colonial Heights',
  'Lusby',
  'Catawba',
  'Snyder',
  'Half Moon Bay',
  'Summerdale',
  'De Berry',
  'Mt Hope',
  'New Springfield',
  'Sainte Genevieve',
  'Van Wert',
  'Ojai',
  'Hartselle',
  'Cooleemee',
  'Great Falls',
  'Matthews',
  'Gilbertown',
  'Lemon Grove',
  'Dulzura',
  'Forest Grove',
  'Mabton',
  'Millport',
  'Ponca City',
  'Mount Hope',
  'Vidor',
  'Crestline',
  'Cat Spring',
  'Brilliant',
  'Liberty Twp',
  'Los Ángeles',
  'East Windsor',
  'Fairmont',
  'Rice',
  'Fritch',
  'Mount Airy',
  'Fort Edward',
  'Thomas',
  'Mc Cormick',
  'Morning View',
  'Baden',
  'Coalgate',
  'Howard',
  'Sandy Hook',
  'Nolensville',
  'North Lauderdale',
  'Claysburg',
  'Fate',
  'Libertyville',
  'Norton',
  'Chatham',
  'Gibson',
  'New Salisbury',
  'Sharonville',
  'Maplesville',
  'San Ramon',
  'Salida',
  'White Bear Lake',
  'Randleman',
  'Romulus',
  'Cynthiana',
  'Laguna Hills',
  'La Verne',
  'Bridge City',
  'Splendora',
  'San Juan',
  'Napa',
  'Carlsbad',
  'Milbank',
  'Steelton',
  'Phoenixville',
  'Ames',
  'Cody',
  'Ingram',
  'Waverly Hall',
  'McClellanville',
  'Montgomery City',
  'Yorktown Heights',
  'Cascade',
  'Inwood',
  'Belvidere',
  'Rose City',
  'Riverhead',
  'Plainview',
  'Cochran',
  'Hockley',
  'Bayboro',
  'Rock Rapids',
  'Croydon',
  'High Falls',
  'Essex Junction',
  'Polk City',
  'Oran',
  'Bremo Bluff',
  'Woodinville',
  'Lula',
  'Findlay',
  'Bonneauville',
  'Bellville',
  'Lemont',
  'Kaplan',
  'Evergreen',
  'Sutton',
  'Rockfield',
  'Islip Terrace',
  'Dulac',
  'Canonsburg',
  'Candler',
  'Owosso',
  'Arkport',
  'Sauk Village',
  'West Union',
  'East Mountain',
  'Lansford',
  'Fountain',
  'Apple Grove',
  'Graceville',
  'Plattsburgh',
  'Muldrow',
  'Eatontown',
  'Pitts',
  'Sneads Ferry',
  'Fitzgerald',
  'Crescent City',
  'Island Lake',
  'Mounds View',
  'Delano',
  'Trainer',
  'Belleview',
  'Swansboro',
  'Huntsburg',
  'Southbridge',
  'Northampton',
  'Honokaa',
  'Firebaugh',
  'Yreka',
  'Ridgeville',
  'Sammamish',
  'Bedford Heights',
  'Locust',
  'Stockport',
  'Alma',
  'Butlerville',
  'Saint Thomas',
  'Kadoka',
  'Dubuque',
  'Wilkinsburg',
  'Southampton Township',
  'Aston',
  'Interlaken',
  'Pekin',
  'Marquette',
  'Alto',
  'Rosemead',
  'Wetumpka',
  'East Dundee',
  'Hughesville',
  'Nappanee',
  'Dearing',
  'Bear',
  'Exmore',
  'Thornton',
  'Fort Lupton',
  'Arrington',
  'Callahan',
  'Unadilla',
  'Amherstdale',
  'Leadington',
  'Jones',
  'Mineral Bluff',
  'Fridley',
  'Stillwater',
  'Mc Kenzie',
  'Vidalia',
  'Pahrump',
  'Joint Base Elmendorf-Richardson',
  'Maylene',
  'Rutherfordton',
  'Philipsburg',
  'Albrightsville',
  'Crystal Springs',
  'Dudley',
  'Blountsville',
  'Woodland',
  'North Conway',
  'High Springs',
  'Ottumwa',
  'Fond du Lac',
  'Vandergrift',
  'New Derry',
  'Frostproof',
  'Latrobe',
  'Whitefield',
  'Shokan',
  'North Prince George',
  'Alfred',
  'Mint Hill',
  'University Park',
  'Ashwaubenon',
  'Ambridge',
  'Obetz',
  'Pinnacle',
  'Napoleon',
  'Madras',
  'Fort Lee',
  'Ocean Springs',
  'St Clair',
  'Hicksville',
  'Veguita',
  'Chaparral',
  'Maitland',
  'Hurlburt Field',
  'Ely',
  'Aylett',
  'Bogalusa',
  'Ketchikan',
  'Albion',
  'Kathleen',
  'North Arlington',
  'Boulder',
  'Holyoke',
  'Shelley',
  'Cramerton',
  'North Woodstock',
  'Cape Carteret',
  'Saluda',
  'Tahlequah',
  'Bridgewater',
  'Hazard',
  'Newburgh Heights',
  'Grayslake',
  'White Pine',
  'Middlebury',
  'Ayer',
  'Machesney Park',
  'Ingalls',
  'Rexville',
  'Troutdale',
  'Harrodsburg',
  'Hinckley',
  'Sandia',
  'Meherrin',
  'Potosi',
  'Flower Mound',
  'Cherryville',
  'Brigham City',
  'Lottsburg',
  'Holtsville',
  'Pelican Bay',
  'Parkton',
  'Huber Heights',
  'Old Bridge',
  'Hope',
  'Mineral Springs',
  'Cache',
  'Belcher',
  'Ira',
  'Chase City',
  'Ramseur',
  'Logansport',
  'Seneca',
  'Seaside',
  'Garfield',
  'Lake Dallas',
  'Mulberry',
  'Bel-Ridge',
  'Aldie',
  'Bulverde',
  'Morris',
  'Munford',
  'Chicago Ridge',
  'Ephraim',
  'Hebbronville',
  'Metter',
  'Elizabethton',
  'Alameda',
  'Farmington Hills',
  'Savage',
  'Good Hope',
  'Blackstone',
  'Jan Phyl Village',
  'Olar',
  'Rosedale',
  'Seekonk',
  'Dacono',
  'Millcreek',
  'Watsonville',
  'Warminster',
  'Quebec City',
  'Shoreline',
  'Exeter',
  'Ellabell',
  'Grandview Heights',
  'Satellite Beach',
  'Virgilina',
  'The Village',
  'Irondequoit',
  'American Canyon',
  'North Babylon',
  'Lincoln Park',
  'Forney',
  'Norton Shores',
  'South Portland',
  'Carnot',
  'La Center',
  'East Prairie',
  'Signal Hill',
  'Johns Island',
  'Mountain Top',
  'West Mifflin',
  'Waim?nalo',
  'Alstead',
  'Canyon Lake',
  'Somers',
  'Buckley',
  'Bethesda',
  'Ave Maria',
  'Ransomville',
  'West Wendover',
  'Grants',
  'Bladenboro',
  'Lake Stevens',
  'Vevay',
  'Broomfield',
  'North Haledon',
  'Black Jack',
  'Dix Hills',
  'Lakeway',
  'Walsenburg',
  'Mc Intyre',
  'Jessup',
  'Cayuga',
  'San Dimas',
  'Erwin',
  'Ringwood',
  'Hearne',
  'Pontoon Beach',
  'Bonita Springs',
  'Amesbury',
  'Sparta',
  'Lehighton',
  'Mize',
  'Stevenson Ranch',
  'Ruffs Dale',
  'Poth',
  'Selden',
  'West Seneca',
  'Greenwood Village',
  'Millbury',
  'Zeeland',
  'Enoch',
  'Red Lion',
  'Pacifica',
  'Ridgewood',
  'Telford',
  'Berkeley Heights',
  'Budd Lake',
  'Tehachapi',
  'Pennington Gap',
  'Noble',
  'Deatsville',
  'Pen Argyl',
  'New Rochelle',
  'South Boston',
  'Cortland',
  'Schaumburg',
  'Hattiesburg',
  'Chicago Heights',
  'Alorton',
  'Central Point',
  'Wyandotte',
  'Woodcreek',
  'Princess Anne',
  'Trinidad',
  'Yazoo City',
  'Mc Intosh',
  'Lawtey',
  'La Vista',
  'Bradley',
  'Keller',
  'Nogales',
  'Richlandtown',
  'Willingboro',
  'Laughlin',
  'Keizer',
  'Kirkwood',
  'Awendaw',
  'Oregon City',
  'Dermott',
  'Mascotte',
  'Asbury',
  'Monarch',
  'Center Valley',
  'Russell Springs',
  'Whitney Point',
  'Bozeman',
  'Karnak',
  'Oglethorpe',
  'Loomis',
  'Tumwater',
  'Cortlandt Manor',
  'Lockland',
  'Deer Lodge',
  'Lewiston',
  'Beech Island',
  'Atkins',
  'Kittery',
  'Yukon',
  'Edgefield',
  'Rocky River',
  'Hutchinson Island',
  'Wendover',
  'Bellamy',
  'Suffern',
  'Okemos',
  'Beltsville',
  'Staten Island',
  'Cambridge Springs',
  'East Dublin',
  'Dacula',
  'Millville',
  'Maumelle',
  'Beavercreek',
  'Mililani',
  'Collins',
  'Fort Bliss',
  'Saugerties',
  'Brookeville',
  'Frankford',
  'Cranberry Township',
  'Senoia',
  'Bethel Park',
  'Auburn Hills',
  'Wantagh',
  'Higganum',
  'Lead',
  'Rochelle',
  'Navarre',
  'Oshkosh',
  'Southington',
  'Harbor City',
  'San Lorenzo',
  'Lake St Louis',
  '11815 Alden Rd',
  'Logan',
  'Watervliet',
  'St Albans',
  'Sterrett',
  'Burgaw',
  'Rocky Point',
  'Bloomsdale',
  'Fern Park',
  'Waterloo',
  'Balcones Heights',
  'Port Jefferson',
  'Hephzibah',
  'Northville',
  'Randolph',
  'Hinton',
  'Saratoga',
  'South Shore',
  'Columbus Grove',
  'Forest City',
  'Loris',
  'Dewey',
  'Dumas',
  'East Chicago',
  'West Miami',
  'Lackawanna',
  'Dickson City',
  'Fort Bragg',
  'Towson',
  'Quitman',
  'Thomson',
  'Pilot Mountain',
  'South Windsor',
  'Burnet',
  'Graniteville',
  'Saint Joseph',
  'Plantersville',
  'Millinocket',
  'West Simsbury',
  'Terrell',
  'Dripping Springs',
  'Raton',
  'Andover',
  'Alvord',
  'Sparland',
  'Cocoa Beach',
  'Schuylkill Haven',
  'Pinson',
  'Alexander City',
  'Minnetonka',
  'Walkerton',
  'Durand',
  'Butner',
  'Aiea',
  'Jupiter',
  'Fountain Hills',
  'Santee',
  'Gila Bend',
  'Rowland Heights',
  'Sawmills',
  'Cumberland',
  'Girard',
  'Maggie Valley',
  'Saint Helen',
  'Caro',
  'Mound House',
  'Alvordton',
  'Maumee',
  'Kenansville',
  'Burnt Hills',
  'Goff',
  'Maple Lake',
  'Galt',
  'Tilghman',
  'Camp Verde',
  'Carroll',
  'Harbinger',
  'Bardonia',
  'The Dalles',
  'Cochranville',
  'Chaska',
  'Maple Valley',
  'Evergreen Park',
  'Aldan',
  'Edgerton',
  'Rio Linda',
  'Santaquin',
  'Bel Air',
  'Highlands',
  'Merriam',
  'New Underwood',
  'Attalla',
  'Forestdale',
  'Port Neches',
  'DeWitt',
  'Mechanicsburg',
  'Port Clinton',
  'Foley',
  'Chapmanville',
  'Delavan',
  'Cushing',
  'Collingdale',
  'Winneconne',
  'River Grove',
  'Santa Clara',
  'Quinlan',
  'McComb',
  'Eustace',
  'Wrightsville',
  'Sunland Park',
  'Poplar Grove',
  'Atlantic Highlands',
  'Canandaigua',
  'Wadena',
  'Elmore',
  'Bethel',
  'Suwanee',
  'Wisconsin Dells',
  'Willowick',
  'Marlow Heights',
  'Damascus',
  'De Forest',
  'Wakefield',
  'Mingo Junction',
  'Sumrall',
  'Offerman',
  'Cherokee Village',
  'New Lenox',
  'Fort Washington',
  'Waipio',
  'Proctor',
  'Coachella',
  'Lawrence Township',
  'Hollidaysburg',
  'Rustburg',
  'Elk River',
  'White Post',
  'Clarendon',
  'Kihei',
  'Bryceville',
  'Boerne',
  'East Palo Alto',
  'Wyncote',
  'Castalia',
  'Angels Camp',
  'Cadet',
  'Waynesburg',
  'Coweta',
  'Winslow',
  'Gun Barrel City',
  'West Haverstraw',
  'Luray',
  'Harrington',
  'Port Chester',
  'Fletcher',
  'Mahtomedi',
  'Jamesville',
  'Cupertino',
  'Skidmore',
  'Manning',
  'Dale',
  'Hanoverton',
  'Tenafly',
  'Haskell',
  'Edinburgh',
  'Jerome',
  'Valley Center',
  'Vass',
  'Whitsett',
  'Nitro',
  'Morton Grove',
  'Chesterton',
  'Waianae',
  'Cherry Hill',
  'Loxley',
  'Salunga',
  'North Zulch',
  'Mountain Brook',
  'North Pole',
  'Coshocton',
  'Edina',
  'Fair Oaks',
  'St. Bernard',
  'Hutchinson',
  'West Mansfield',
  'Commerce Charter Twp',
  'Blairs',
  'Opdyke',
  'Caney City',
  'Papillion',
  'Rodeo',
  'Rohnert Park',
  'Laguna Beach',
  'Poolesville',
  'Chambersburg',
  'Fox River Grove',
  'Bay Minette',
  'Tonganoxie',
  'Santa Rosa Beach',
  'Universal City',
  'Wenonah',
  'Healdsburg',
  'Willoughby Hills',
  'Mifflintown',
  'Marshalltown',
  'St. Anthony',
  'Voorheesville',
  'Odem',
  'Glen Saint Mary',
  'Northern Cambria',
  'Trussville',
  'New Whiteland',
  'Comstock Park',
  'Vacherie',
  '10300 Flowerree Ln',
  'Layton',
  'Kodak',
  'Rumford',
  'Pine Bush',
  'Whitmore Lake',
  'Santa Cruz',
  'Mayer',
  'Thurman',
  'Steubenville',
  'Piqua',
  'Leon Valley',
  'Hamlin',
  'Olmsted Falls',
  'Bethel Springs',
  'Eagle Mountain',
  'Christiansburg',
  'Wood Village',
  'Kenton',
  'Enterprise',
  'Donna',
  'Kempner',
  'Trion',
  'Kimbolton',
  'Moreland',
  'Yerington',
  'Phillipston',
  'Idalou',
  'South Hill',
  'Glennville',
  'Brookline',
  'Lillie',
  'Deltaville',
  'Royal Oaks',
  'Hazlehurst',
  'Worland',
  'SeaTac',
  'Fairport Harbor',
  'Centralia',
  'Cairo',
  'West Wyoming',
  'Luling',
  'Walls',
  'Fort Knox',
  'Potomac',
  'Mc Kees Rocks',
  'Aumsville',
  'Osteen',
  'Rutherford',
  'Wethersfield',
  'Westwood Lake',
  'Lewistown',
  'Hacienda Heights',
  'Ridgecrest',
  '7588 Quail Run Ln',
  'Twentynine Palms',
  'Glenolden',
  'Munroe Falls',
  'Heber City',
  'Fords',
  'Manasquan',
  'Belchertown',
  'Murphy',
  'Mt Carmel',
  'Gloversville',
  'Poulsbo',
  'Gloster',
  'Montecito',
  'Centennial',
  'Lake Tapps',
  'South Kingstown',
  'Umatilla',
  'Grandview Plaza',
  'Middleville',
  'Hedgesville',
  'Jeffersontown',
  'Ivanhoe',
  'Rockledge',
  'Wallingford',
  'Fresh Meadows',
  'Camp Springs',
  'Grand Terrace',
  'Smartsville',
  'Sewaren',
  'Churchville',
  'Sardis',
  'Lathrup Village',
  'Wrightwood',
  'Allston',
  'Solon',
  'Mogadore',
  'Parsons',
  'Maple Park',
  'Laingsburg',
  'Sykesville',
  'Fort Carson',
  'Wooster',
  'Sullivans Island',
  'Chickasha',
  'Mays Landing',
  'Safford',
  'Vinemont',
  'Flanders',
  'Wyandanch',
  'Batesburg-Leesville',
  'Pocahontas',
  'Pinetops',
  'Windham',
  'El Dorado Hills',
  'Runge',
  'New Prague',
  'Willimantic',
  'New Caney',
  'Cortez',
  'Duarte',
  'Vance',
  'New Fairfield',
  'Marengo',
  'Pahokee',
  'Mt Sterling',
  'Bethalto',
  'Kingsland',
  'Hortense',
  'Wentworth',
  'Cohutta',
  'Fountain City',
  'Old Town',
  'Neodesha',
  'Stuarts Draft',
  'Labadie',
  'Linda',
  'Ash',
  'Halawa',
  'Anoka',
  'Yardley',
  'Limington',
  'Bluffdale',
  'St. Francis',
  'Mount Gilead',
  'Montebello',
  'Watkinsville',
  'McKeesport',
  'Alpine',
  'Terlton',
  'Shepherdsville',
  'Wolcott',
  'Snowflake',
  'St Robert',
  'Merrick',
  'Firestone',
  'Roselle Park',
  'Point Reyes Station',
  'Amite City',
  'Johnstown',
  'Houlka',
  'Clewiston',
  'Saint Maries',
  'McCordsville',
  'Harrison Township',
  'Prairie Grove',
  'Indianápolis',
  'Fort Belvoir',
  'Sardinia',
  'Social Circle',
  'Appleton',
  'Midland City',
  'Brookville',
  'Monroe Township',
  'Freedom',
  'Ocean City',
  'Pawnee',
  'Stoneham',
  'Kennebunk',
  'Fort Payne',
  'Braintree',
  'Pleasant Grove',
  'McQueeney',
  'Navasota',
  'Howard City',
  'Allegany',
  'Ottawa',
  'Leslie',
  'Huntingdon',
  'Elkhorn',
  'Port Jervis',
  'Ridgeway',
  'Godwin',
  'Tatamy',
  'Bronson',
  'Agawam',
  'Woodrow',
  'Whitewright',
  'Grambling',
  'Pecos',
  'South Dartmouth',
  'Santa Fe Springs',
  'East Patchogue',
  'Fishkill',
  'Murrayville',
  'King George',
  'Mt Solon',
  'Discovery Bay',
  'Marinette',
  'Voorhees',
  'West Harrison',
  'England',
  'Angleton',
  'Midway City',
  'Arvada',
  'North Smithfield',
  'Hanover Township',
  'Center Barnstead',
  'Uriah',
  'New Martinsville',
  'Pell City',
  'Hightstown',
  'West Islip',
  'Aguanga',
  'Newtown',
  'Snowmass',
  'Kilauea',
  'Tarrs',
  'Derby',
  'Park Ridge',
  'Indianola',
  'Gloucester',
  'Chadbourn',
  'Von Ormy',
  'Lake Orion',
  'McCaysville',
  'Utqiagvik (Barrow)',
  'Steilacoom',
  'Perkasie',
  'Frackville',
  'Fairview Park',
  'Middlesex',
  'Garyville',
  'Wilder',
  'Stem',
  'Somerton',
  'Bolton',
  'Robstown',
  'Poseyville',
  'Little Genesee',
  'Preston',
  'Carriere',
  'Corvallis',
  'Rhinelander',
  'Tunkhannock',
  'Holmdel',
  'Dunlow',
  'Powhatan Point',
  'Hernandez',
  'Shannon',
  'Dupont',
  'Scottdale',
  'Luzerne',
  'Hammondsville',
  'Artesia',
  'King',
  'Woodside',
  'Citronelle',
  'Washougal',
  'Moriarty',
  'Burnettown',
  'Bloomingdale',
  'Moorcroft',
  'Chagrin Falls',
  'Culloden',
  'Starr',
  'Prairie',
  'Farnham',
  'Courtland',
  'Kaufman',
  'Oppelo',
  'Sharpsville',
  'Seven Hills',
  'Ewing',
  'South Plainfield',
  'Terry',
  'Maynard',
  'Slaton',
  'Manor',
  'Jenks',
  'Newbury Township',
  'Saint Leonard',
  'Bishopville',
  'Maple Shade Township',
  'Prairieville',
  'Lizella',
  'Midway Park',
  'Steger',
  'Susan Moore',
  'Pine Valley',
  'Schoolcraft',
  'Plattsmouth',
  'Lakeshire',
  'Chesterbrook',
  'Shively',
  'McHenry',
  'Bowdon',
  'Corbin',
  'Honeoye',
  'Mc Connellsburg',
  'Forestville',
  'Los Gatos',
  '1474 Co Rd 4125',
  'Dillon',
  'Hernando',
  'Newberry',
  'Prairie du Chien',
  'Campton',
  'Booneville',
  'Vilonia',
  'Riceville',
  'Cashion',
  'Essexville',
  'Zionsville',
  'Rixeyville',
  'Fairless Hills',
  'Liberty Lake',
  'Waterbury Village Historic District',
  'Belle Vernon',
  'Pace',
  'Country Club Hills',
  'Eastlake',
  'Sedona',
  'Stonington',
  'Winthrop',
  'Hewitt',
  'Eleva',
  'Westerly',
  'Thatcher',
  'Jamul',
  'Manlius',
  'Palacios',
  'Pacoima',
  'Wildomar',
  'Blairstown',
  'Waldport',
  'Amargosa Valley',
  'Essington',
  'Plumas Lake',
  'Bernville',
  'Sayre',
  'Placerville',
  'Chappell Hill',
  'Walnut',
  'St. Louis Park',
  'Reeseville',
  'South Haven',
  'North Chili',
  'Cabot',
  'Bellmead',
  'Omak',
  '?Aiea',
  'Yucca Valley',
  'Branford',
  'Tyngsborough',
  'Elkview',
  'Woodford',
  'Corapeake',
  'Esparto',
  'Hanover Park',
  'Pemberton',
  'Stoughton',
  'Walkertown',
  'Falfurrias',
  'Eighty Four',
  'Maize',
  'Wellsburg',
  'Rentz',
  'Alturas',
  'Mountain Home Afb',
  'Millbrae',
  'Gahanna',
  'Longmeadow',
  'San Fernando',
  'Castle Pines',
  'Derwood',
  'Zuni',
  'Madison Heights',
  'Summerfield',
  'Neptune City',
  'Mentor-on-the-Lake',
  'Campobello',
  'Vivian',
  'Wheatley Heights',
  'East Greenwich',
  'Hampton Bays',
  'Ukiah',
  'South El Monte',
  'Tell City',
  'Arlington Heights',
  'Solvang',
  'Poway',
  'Canal Fulton',
  'Mantua',
  'Hayden',
  'Northvale',
  'Perrysburg',
  'Dunellen',
  'Tahoka',
  'Washington Township',
  'Wildwood',
  'Mohnton',
  'Ray City',
  'North Attleboro',
  'Elm Mott',
  'Kirklin',
  'Belle Plaine',
  'Sedro Woolley',
  'Groveport',
  'Macedon',
  'Colon',
  'Millbourne',
  'Eagleville',
  'Demopolis',
  'Aimwell',
  'South Salem',
  'La Pine',
  'Varnell',
  'Orient',
  'Wood',
  'Westampton',
  'Chardon',
  'Mills',
  'Spring Brook Township',
  'Duette',
  'Attapulgus',
  'Abingdon',
  'Inola',
  'Avondale Estates',
  'Plover',
  'Belding',
  'Pinckney',
  'Bedford Park',
  'Lakewood Ranch',
  'Rockaway',
  'Tipton',
  'Wellford',
  'Altona',
  'Coolville',
  'Wood-Ridge',
  'Rockport',
  'Dodge Center',
  'Dedham',
  'Runnemede',
  'Cogan Station',
  'St Martinville',
  'Hilton',
  'Zachary',
  'Pomfret',
  'Bloomfield Hills',
  'South Park',
  'Ellettsville',
  'Chickasaw',
  'Fort Myers Beach',
  'Kearns',
  'Millsap',
  'Kirtland Afb',
  'Irondale',
  'Whitestone',
  'Cedar City',
  'Lockeford',
  'Cottage City',
  'Montrose',
  'Glenview',
  'Seagoville',
  'Fort Irwin',
  'Pueblo West',
  'Griswold',
  'Evart',
  'Beech Grove',
  'Cape May',
  'South Paris',
  'Rexford',
  'Momence',
  'Bulls Gap',
  'Cass City',
  'Adams',
  'Birnamwood',
  'East Kingston',
  'Vicksburg',
  'New Hope',
  'Nemacolin',
  'White Springs',
  'Gibsonton',
  'Great Bend',
  'Eielson Afb',
  'Whigham',
  'Hoschton',
  'Mineola',
  'Gay',
  'Calvert City',
  'Southwest Ranches',
  'Duryea',
  'Ewa Gentry',
  'Little Flock',
  'South Daytona',
  'Mill Creek',
  'Wixom',
  'Connersville',
  'Strasburg',
  'Monrovia',
  'Dryden',
  'Sunman',
  'Hitchcock',
  'Vail',
  'Weatogue',
  'Bedias',
  'Delaware City',
  'Lakemore',
  'Baldwin City',
  'Morgan City',
  'Manheim',
  'Moss',
  'West Greenwich',
  'Patchogue',
  'Johnsonville',
  'Bethpage',
  'Mohave Valley',
  'Hatboro',
  'Algonquin',
  'Ulmer',
  'Fort Stewart',
  'North Bellmore',
  'Woodland Park',
  'Cataula',
  'Tipp City',
  'Forrest City',
  'Roff',
  'Cadiz',
  'Cranford',
  'Gum Springs',
  'Roebuck',
  'Saline',
  'Spencerport',
  'Waimanalo',
  'Toms Brook',
  'Lakesite',
  'Grass Valley',
  'Pavo',
  'Thurmont',
  'East Saint Louis',
  'Olney',
  'Prosperity',
  'Kingsburg',
  'Coeburn',
  'Whitefish',
  'Mount Lookout',
  'Moscow Mills',
  'Oronogo',
  'La Feria',
  'Fuquay Varina',
  'Bellefontaine Neighbors',
  'New City',
  'Pleasant View',
  'Stewartstown',
  'Citrus Springs',
  'Teachey',
  'Waconia',
  'Copley',
  'Brevard',
  'Merrimack',
  'South Easton',
  'Brundidge',
  'Haslet',
  'Mannington',
  'Arcata',
  'Uxbridge',
  'Fort Gibson',
  'Eastover',
  'Haw River',
  'Breckenridge',
  'Morris Plains',
  'Beacon Falls',
  'Port Hueneme',
  'Richburg',
  'Alexander',
  'Northlake',
  'East Durham',
  'Redington Beach',
  'Oakfield',
  'Walnut Grove',
  'East Syracuse',
  'Pearl River',
  'Moraine',
  'Spring Park',
  'Depoe Bay',
  'Pine Ridge',
  'Winton',
  'Valdese',
  'Bunker Hill',
  'Port Edwards',
  'Follansbee',
  'Marbury',
  'Milnesville',
  'Monmouth',
  'Paden City',
  'Hickory Hills',
  'Needles',
  'Street',
  'Crafton',
  'Fort Polk South',
  'Silver Springs',
  'Northridge',
  'Mitchell',
  'Bethany',
  'Columbia City',
  'Foxborough',
  'Hayes',
  'Mountain Home',
  'Howell Township',
  'Sappington',
  'Talking Rock',
  'Fyffe',
  'Ahoskie',
  'Bacliff',
  'Dickinson Center',
  'Robersonville',
  'Greenbank',
  'San Luis',
  'Coldwater',
  'Goodrich',
  'Crum Lynne',
  'Lake Elmo',
  'Pegram',
  'Childersburg',
  'New Ringgold',
  'Lenoir City',
  'Remlap',
  'Beach Park',
  'Chapmansboro',
  'Benicia',
  'Kittredge',
  'Bellows Falls',
  'Newtonville',
  'Tontitown',
  'Diamond',
  'Paynesville',
  'Taylorville',
  'Dushore',
  'Miami Shores',
  'Sully',
  'Green Tree',
  'Olivette',
  'Abington',
  'CA 94580',
  'Mannford',
  'Pittsboro',
  'Windsor Locks',
  'Byhalia',
  'North York',
  'Wills Point',
  'Langhorne',
  'Schuyler',
  'Big Island',
  'Archie',
  'Browns Mills',
  'Poplar',
  '69 Sargent Square',
  'Highland Home',
  'Glenarden',
  'Leadville',
  'Marseilles',
  'North Palm Beach',
  'Carrboro',
  'Emeryville',
  'Hopatcong',
  'Kermit',
  'King City',
  'Scott Township',
  'Jean',
  'Valhermoso Springs',
  'North Belle Vernon',
  'Motley',
  'Marshallville',
  'Benkelman',
  'Leachville',
  'Glen Cove',
  'Highland Heights',
  'Mount Carmel',
  'Margarettsville',
  'New Sharon',
  'Crandall',
  'Three Rivers',
  'Buhl',
  'Ellendale',
  'Blythewood',
  'Pacolet',
  'Patton',
  'Crosslake',
  'Poteau',
  'Waelder',
  'Cottontown',
  'Vadnais Heights',
  'Branchburg',
  'Green Valley',
  'Hickman',
  'Hunter',
  'Floyd',
  'Greendale',
  'Alpaugh',
  'Curwensville',
  'Kila',
  'Hackettstown',
  'Scarsdale',
  'St. John',
  'Woodbine',
  'South Lyon',
  'Gravette',
  'Rainsville',
  'Mount Jackson',
  'Glenford',
  'Endicott',
  'Glouster',
  'Etters',
  'St Cloud',
  'Mequon',
  'Piney Flats',
  'OH 45895',
  'Linthicum Heights',
  'Hanscom Afb',
  'Price',
  'Hawesville',
  'Abita Springs',
  'Fort Wainwright',
  'Helotes',
  'Havertown',
  'Idyllwild-Pine Cove',
  'Le Center',
  'Fleetwood',
  'South Bound Brook',
  'Picayune',
  'Mojave',
  'Redkey',
  'Clyo',
  'Mill Valley',
  'Panama City Beach',
  'Anthony',
  'Olympia Fields',
  'Brownsboro',
  'Key Largo',
  'West Conshohocken',
  'Brimfield',
  'Ware Shoals',
  'Firth',
  'Richford',
  'Coulterville',
  'Lawnside',
  'Hugoton',
  'Lawrenceburg',
  'Bettendorf',
  'Madeira',
  'Vilas',
  'Feasterville Trevose',
  'Carterville',
  'Hugo',
  'Sumerduck',
  'White House',
  'Cannon Falls',
  'Oak Hill',
  'Jordan',
  'Lothian',
  'Humboldt',
  'Warrington',
  'Pittston',
  'Oro Valley',
  'Chevy Chase',
  'Jarrell',
  'Elko',
  'Lenox',
  'Dora',
  'Huxley',
  'Addis',
  'Landis',
  'Forest Falls',
  'Corydon',
  'MCB CAMP PENDLETON',
  'Hampshire',
  '5842 Fincastle Dr',
  'Port Royal',
  'Valley City',
  'Lake George',
  'Creswell',
  'Grenada',
  'Bristow',
  'Englishtown',
  'Thorndale',
  'Creston',
  'Pennsburg',
  'Dilworth',
  'Wake Village',
  'Olsburg',
  'Aberdeen Proving Ground',
  'Little Egg Harbor Twp',
  'Munster',
  'Rothville',
  'Josephine',
  'Bunnell',
  'Parachute',
  'Jenison',
  'Otto',
  'Berthoud',
  'Walters',
  'Wallington',
  'Carville',
  'Superior',
  'Hoxie',
  'Stapleton',
  'Bagley',
  'Panhandle',
  'West Plains',
  'FL 32277',
  'Calhoun Falls',
  'Etowah',
  'Payson',
  'Pickens',
  'Apollo Beach',
  'Brookland',
  'Cañon City',
  'Kinder',
  'Glendora',
  'Queen Anne',
  'Caddo',
  'Port Norris',
  'Coupeville',
  'Buxton',
  'Horseheads',
  'Brooklawn',
  'Tulia',
  'Vestavia Hills',
  'Woodson Terrace',
  'Raymondville',
  'Avon Lake',
  'Bon Aqua',
  'Wytheville',
  'Fluvanna',
  'Winnemucca',
  'Pendergrass',
  'Lake Butler',
  'Decker',
  'Vancleave',
  'South Mills',
  'Willow Wood',
  'Appomattox',
  'Dobson',
  'East Alton',
  'Eagle Point',
  'Ortonville',
  'Rock Spring',
  'Depew',
  'Pine Top',
  'Coventry',
  'Wilmette',
  'Manito',
  'Cowen',
  'Palisade',
  'Pine Plains',
  'Penns Grove',
  'Julian',
  'Woodlynne',
  'Sisters',
  'West Branch',
  'College Place',
  'Gouverneur',
  'Yelm',
  'Providence Forge',
  'Matawan',
  'Walden',
  'Benton Harbor',
  'Murrells Inlet',
  'West Henrietta',
  'Rubicon',
  'South Carthage',
  'Mt Gilead',
  'Richlands',
  'Lyndora',
  'Loch Sheldrake',
  'Shawboro',
  'Currie',
  'Gallipolis Ferry',
  'Saint Clair',
  'East Northport',
  'Coos Bay',
  'Calverton Park',
  'Henniker',
  'Beach Lake',
  'Steamboat Springs',
  'New Mexico 87529',
  'Royersford',
  'Monee',
  'Realitos',
  'Okolona',
  'Nacogdoches',
  'Mayville',
  '302 Apple Creek Dr',
  'Junction',
  'Keasbey',
  'Coplay',
  'Cottonwood Heights',
  'Shrub Oak',
  'Ramsey',
  'Encino',
  'Gleason',
  'Eagle Pass',
  'Vermillion',
  'Owingsville',
  'Center Line',
  'Emmaus',
  'Turkey',
  'Mapleton',
  'Mission Hills',
  'Peebles',
  'Kershaw',
  'Corsicana',
  'Stokesdale',
  'Caledonia',
  'Chiefland',
  'Sheffield Lake',
  'Houlton',
  'East Peoria',
  'Newman',
  'Marquette Heights',
  'Livingston Manor',
  'Maud',
  'Pinehurst',
  'Smithville',
  'Hico',
  'Eatonville',
  'Surfside Beach',
  'Winnabow',
  'Carencro',
  'Massapequa Park',
  'Belpre',
  'Elmer',
  'PA 16373',
  '1380 Groesbeck St',
  'Malone',
  'Kettle Falls',
  'Atmore',
  'Caribou',
  'Lacombe',
  'Pecatonica',
  'Potsdam',
  'Alabama 36081',
  'New Windsor',
  'Venus',
  'Rosston',
  'NM 88030',
  'Baxley',
  'Tyronza',
  'La Grande',
  'Battleboro',
  'Los Osos',
  'Bonsall',
  'Boardman',
  'Melvindale',
  'Morrilton',
  'Clearlake',
  'Sedro-Woolley',
  'South Houston',
  'Hannibal',
  'Grosse Ile',
  'West Kingston',
  'Duvall',
  'Newberg',
  'Kalkaska',
  'Clarence',
  'Pisgah',
  'Cadillac',
  'Horse Cave',
  'Chapin',
  'Gallup',
  'Mc Cool',
  'McRae',
  'O Brien',
  'Chauvin',
  'Airmont',
  'Brownfield',
  'La Plata',
  'Alpena',
  'Fergus Falls',
  'Toxey',
  'Glassport',
  'Winnetka',
  'Wetumka',
  'Elsberry',
  'Grover',
  'Soda Springs',
  'Jefferson Township',
  'West Frankfort',
  'Choctaw',
  'Rural Valley',
  'Soperton',
  'Macdona',
  'St George',
  'Hopedale',
  'Ipava',
  'Anchor Point',
  'Otis Orchards',
  'Elton',
  'Irwindale',
  'Centre',
  'Mandeville',
  'Elm Creek',
  'Sweet Home',
  'Pennsylvania 15223',
  'Rankin',
  'McCalla',
  'Addyston',
  'Clever',
  'Bicknell',
  'West Olive',
  'Boulder City',
  'Billingsley',
  'Moorestown',
  'West Springfield',
  'Longport',
  'Seminary',
  'Oyster Creek',
  'Winthrop Harbor',
  'Germanton',
  'Hilliard',
  'Grand Ridge',
  'Beaver',
  'Shiner',
  'Lakeview',
  'South Sioux City',
  'Rolla',
  'Guntersville',
  'Salters',
  'Nanticoke',
  'Winston',
  'Starke',
  'Freer',
  'Keysville',
  'Lindale',
  'Rosamond',
  'Lanai City',
  'Argonne',
  'Stephenville',
  'Vauxhall',
  'Crofton',
  'Kinards',
  'Wortham',
  'Palenville',
  'South Fork',
  'North Reading',
  'Palmetto Bay',
  'Inez',
  'El Cerrito',
  'Whiteland',
  'Pigeon Forge',
  'Castleford',
  'Kailua Kona',
  'De Queen',
  'Lindley',
  'KY 41603',
  'Purdy',
  'Miles City',
  'Mosheim',
  'Ohatchee',
  'Upton',
  'Round Lake',
  'Mount Washington',
  'Malvern',
  'Cuthbert',
  'Charlack',
  'Marlboro',
  'Earlimart',
  'Sand Springs',
  'Kearny',
  'Capon Bridge',
  'Oberlin',
  'Irwin',
  'Newkirk',
  'Lanett',
  'Allenhurst',
  'Scotlandville',
  'Old Hickory',
  'Ellenton',
  'Virginia',
  'Kopperl',
  'TX 75124',
  'Vernal',
  'Erath',
  'Boutte',
  'Belle',
  'Marlette',
  'Monte Vista',
  'Flovilla',
  'Gardendale',
  'Mount Pocono',
  'Mikado',
  'La Salle',
  'Saint Martinville',
  'Turners Station',
  'Colfax',
  'Seligman',
  'Cottageville',
  'Shelbina',
  'Mathis',
  'St Amant',
  'Fairhope',
  'Lake Katrine',
  'Nicholson',
  'Osseo',
  'Buckeye Lake',
  'Ledbetter',
  'Lumber City',
  'Waldron',
  'Ricetown',
  'Hooks',
  'Union Mills',
  'Delanco',
  'Denville',
  'Miramar Beach',
  'Dania Beach',
  'Crooksville',
  'Sikeston',
  'Topsham',
  'Smelterville',
  'Marshfield',
  'Orange Beach',
  'Stockdale',
  'AR 72073',
  'China Grove',
  'Tickfaw',
  'Chisholm',
  'North Vernon',
  'Gates Center',
  'Alderson',
  'Pingree Grove',
  'Pembroke Park',
  'Nokomis',
  'Hillview',
  'Tilden',
  'Horner',
  'Temperance',
  'Minocqua',
  'Sartell',
  'North Bend',
  'Sandstone',
  'Crandon',
  'Elliston',
  'Cincinnatus',
  'Bennett',
  'Orchard Park',
  'Peshtigo',
  'Marstons Mills',
  'Morton',
  'East Grand Forks',
  'Smiths Creek',
  'Middleport',
  'Fort Lawn',
  'Gillette',
  'Kewaskum',
  'Shillington',
  'Sawyerville',
  'Rio Rico',
  'Liberty Hill',
  'Salamanca',
  'Iva',
  'New Bloomington',
  'Ogallala',
  'Gurdon',
  'Wells',
  'Arkadelphia',
  'Grand Valley',
  'Arley',
  'North',
  'Barton',
  'Leonia',
  'Custar',
  'Vienna',
  'Saint Robert',
  'Saint John',
  'New Town',
  'Grimsley',
  'Holden',
  'Luthersville',
  'Hays',
  'Westwood',
  'Jackson Township',
  'Moorefield',
  'Altamont',
  'Matamoras',
  'Waurika',
  'Roberta',
  'Bamberg',
  'Fleming',
  'Allegan',
  'Fort Thomas',
  'Bonifay',
  'Saxe',
  'Cyrus',
  'Kealakekua',
  'West Linn',
  'Bear Creek',
  'Mayesville',
  'Mocksville',
  'Santa Margarita',
  'Opp',
  'Peterstown',
  'Sitka',
  'Glenn Dale',
  'Rosemont',
  'Taneyville',
  'Golden Meadow',
  'Hartland',
  'Mt Dora',
  'Rehoboth',
  'Yeadon',
  'Bertram',
  'Colwyn',
  'Eddington',
  'Menands',
  'Severna Park',
  'Lone Grove',
  'Flemington',
  'DeQuincy',
  'Watford City',
  'Leon',
  'Needville',
  'Fort Scott',
  'Carpinteria',
  'Pleasanton',
  'Tennille',
  'Trafford',
  'Laureldale',
  'Davis',
  'Frederica',
  'Hood River',
  'Dundalk',
  'Lucama',
  'Webster Groves',
  'Ellenburg Center',
  '1151 Arrow Hwy',
  'La Paz',
  'Continental',
  'Ripon',
  'Owensville',
  'Helena',
  'Tazewell',
  'Fallston',
  'Bellmore',
  'McCallsburg',
  'Schroeder',
  'Oro Grande',
  'Nuevo',
  'Naches',
  'Heathsville',
  'Charles Town',
  'Wayzata',
  'Gering',
  'Tuscola',
  'Bremond',
  'Falling Waters',
  'Rexburg',
  'East Fairfield',
  'Chuckey',
  'Edgar Springs',
  'Woodlake',
  'Bartlesville',
  'Harkers Island',
  'Roundhill',
  'Sherman Oaks',
  'Stayton',
  'Manitou Springs',
  'Idaho Springs',
  'Clint',
  'Fairview Heights',
  'Valley Mills',
  'Claypool',
  'De Motte',
  'Delong',
  'St James',
  'Lena',
  'Hawley',
  'Gurley',
  'Fishersville',
  'Oakland Park',
  'Merryville',
  'Sylvan Lake',
  'Mattawan',
  'Adairsville',
  'Dormont',
  'Belle Isle',
  'Traphill',
  'Annapolis Junction',
  'Carpentersville',
  'Woodland Hills',
  'Oliver Springs',
  'Boiling Spring Lakes',
  'Whitesville',
  'Reynolds',
  'White City',
  'Terreton',
  'Bald Knob',
  'Fayette',
  'Guy',
  'East Rutherford',
  'Mahanoy City',
  'Dresden',
  'Royse City',
  'West Newton',
  'Spencerville',
  'Mer Rouge',
  'East Setauket',
  'Fox Point',
  'Wading River',
  'Ville Platte',
  'St Ann',
  'Tyrone',
  'East Palestine',
  'Gig Harbor',
  'South Pittsburg',
  'North Haven',
  'Worth',
  'Chattahoochee Hills',
  'Estill',
  'New Ulm',
  'Oak View',
  'Finksburg',
  'Stockton Springs',
  'Portola',
  'McAlester',
  'White Hall',
  'Waltham',
  'Schwenksville',
  'Westworth Village',
  'Salmon',
  'Cecilia',
  'Lake Havasu City',
  'West Portsmouth',
  'Middle Island',
  'Quantico',
  'Ellaville',
  'Carnegie',
  'Chippewa Lake',
  'Eight Mile',
  'Zearing',
  'Coopersville',
  'Menomonie',
  'Feasterville-Trevose',
  'Grantsboro',
  'Clackamas',
  'Natural Bridge',
  'Headland',
  'Olmsted Twp',
  'Concho',
  'Mooringsport',
  'Pittsford',
  'Jeanerette',
  'Aptos',
  'Cole Camp',
  'Bushnell',
  'Carlyle',
  'De Leon',
  'Peru',
  'Krum',
  'Pontotoc',
  'New Baden',
  'Jewett City',
  'Cinco Bayou',
  'West Manchester Township',
  'Scurry',
  'Blacklick',
  'Whitesburg',
  'Jamaica Plain',
  'Kew Gardens',
  'Crowell',
  'Berwyn Heights',
  'Grimes',
  'Highland Lakes',
  'Powell Butte',
  'Fort Oglethorpe',
  'Stantonsburg',
  'Mendota',
  'Claysville',
  'Freeville',
  'Raphine',
  'Hurricane',
  'Arverne',
  'Fairmount Heights',
  'Shaw AFB',
  'Lovington',
  'Whiting',
  'Daisy',
  'Colquitt',
  'Scott',
  'Ocilla',
  'Apollo',
  'Beasley',
  'Milliken',
  'Marionville',
  'Colville',
  'North Hills',
  'Westborough',
  'Ashland City',
  'Heath Springs',
  'Novato',
  'West Milton',
  'Ridge',
  'Gray Summit',
  'Rockwell City',
  'Elmira Heights',
  'Long Prairie',
  'Amity',
  'Bloomsburg',
  'San Pedro',
  'Collierville',
  'Starlight',
  'Boaz',
  'Dickson',
  'Colbert',
  'Gardnerville',
  'Circle Pines',
  'Broken Bow',
  'Tallulah',
  'Lesage',
  'South Glens Falls',
  'Falls City',
  'Howard Lake',
  'Birdsboro',
  'Burkeville',
  'Hidalgo',
  'Croton-On-Hudson',
  'Sadieville',
  'East Palatka',
  'El Sobrante',
  'Wilkesboro',
  'Ridgely',
  'Grand Bay',
  'Kewanee',
  'Woodburn',
  'Saint Matthews',
  'Colburn',
  'Spring Grove',
  'Oriskany',
  'Harwich Port',
  'Stratham',
  'Henryetta',
  'West Creek',
  'State College',
  'Lake Hiawatha',
  'O Fallon',
  'East Liverpool',
  'Glen Ridge',
  'Redford Charter Twp',
  'Peekskill',
  'Hyannis',
  'LaBelle',
  'Silver Lake',
  'Fort Meade',
  'Burnham',
  'McMechen',
  'Twin Peaks',
  'Manalapan',
  'Highspire',
  'Port Townsend',
  'Humphrey',
  'St. Lawrence Borough',
  'Pine Hills',
  'Buchanan Dam',
  'St Charles',
  'Camargo',
  'Sturgis',
  'New Bloomfield',
  'Treasure Island',
  'Portales',
  'Crumpler',
  'Brazoria',
  'Sunny Isles Beach',
  'Mascoutah',
  'Berkeley Springs',
  'Richards',
  'Pacheco',
  'South Amboy',
  'Fort Gratiot Twp',
  'Enon',
  'White Oak',
  'Anthem',
  'Port Lavaca',
  'Ranchos De Taos',
  'San Ysidro',
  '41 Asbury St',
  'Las Animas',
  'North Hollywood',
  'Oakville',
  'Andrews',
  'Deep Run',
  'Port Ewen',
  'Spring Lake Park',
  'Brewster',
  'Pompton Plains',
  'Hallam',
  'North Royalton',
  'Wolfeboro',
  'Shoreham',
  'Grand Isle',
  'TX 77320',
  'Northbrook',
  'Highland Falls',
  'Cardwell',
  'Church Hill',
  'Lecompton',
  'Edinboro',
  'Ladera Ranch',
  'Austinburg',
  'Wixon Valley',
  'Washington 98374',
  'Wilkesville',
  'Norridge',
  'East Moriches',
  'Jackson Heights',
  'Laplace',
  'Bensenville',
  'Black River Falls',
  'Kodiak',
  'Winona Lake',
  'Amory',
  'Simsbury',
  'Lynbrook',
  'Wood Dale',
  'Stephenson',
  'West Collingswood Heights',
  'San Leon',
  'Oldsmar',
  'Ravena',
  'Wilmer',
  'New York Mills',
  'Lasalle',
  'King Of Prussia',
  'Rahway',
  'Sharon Hill',
  'Lizton',
  'Effie',
  'Holly Lake Ranch',
  'Temescal',
  'Sun Lakes',
  'Fredonia',
  'Macedonia',
  'Manderson',
  'Aultman',
  'Berryton',
  'Bethel Heights',
  'McGuire AFB',
  'New Holland',
  'Lumber Bridge',
  'WaKeeney',
  'Jemison',
  'Berryville',
  'Springvale',
  'St Gabriel',
  'Lambertville',
  'Lynnfield',
  'Westmoreland',
  'Breckenridge Hills',
  'Trophy Club',
  'NY 11697',
  'Annandale',
  'Deport',
  'Ambler',
  'Southwick',
  'Battle Mountain',
  'Shiloh',
  'Williams',
  'Vinita',
  'St Louisville',
  'Clintwood',
  'East Norriton',
  'Caseyville',
  'Tallapoosa',
  'Terryville',
  'Kula',
  'West Berlin',
  'Hamlet',
  'Quinebaug',
  'Arabi',
  'Cedarburg',
  'Coosawhatchie',
  'Maybrook',
  'Billerica',
  'Burke',
  'Arroyo Grande',
  'Mt Orab',
  'Burlington Junction',
  'Liberty Center',
  'Ellijay',
  'Río Grande City',
  'La Harpe',
  'Fort Eustis',
  'Lake Oswego',
  'West Reading',
  'La Vernia',
  'Cridersville',
  'Glen Mills',
  'Cass Lake',
  'Bullock',
  'Shasta Lake',
  'Bryn Mawr',
  'Pleasant Plain',
  'Canoga Park',
  'Pollock Pines',
  'Ivor',
  'West Milford',
  'Glenvil',
  'Melvin',
  'Fowlerville',
  'North Bethesda',
  'Pound',
  'Pennsauken Township',
  'Stonewall',
  'West Yarmouth',
  'Ennis',
  'McCurtain',
  'Topanga',
  '??? ???',
  'Archer Lodge',
  'Crittenden',
  'Whitakers',
  'Ambrose',
  'Walton Hills',
  'Heflin',
  'Thunderbolt',
  'Salley',
  'East Canaan',
  'Banks',
  'Heyburn',
  'Harrod',
  'Pomeroy',
  'Boyd',
  'Stamps',
  'Glen Head',
  'Manchester Township',
  'Metamora',
  'Rancho Mission Viejo',
  'Marina del Rey',
  'Kittrell',
  'Kuna',
  'Rising Sun',
  'Farmland',
  'Setauket- East Setauket',
  'Milner',
  'Wright City',
  'Ingleside',
  'Tewksbury',
  'Grand Haven',
  'Davison',
  'Charles City',
  'Saint Amant',
  'Burlingame',
  'Lipscomb',
  'Saco',
  'Coalinga',
  'Bella Vista',
  'Hazle Township',
  'Keithsburg',
  'Glastonbury',
  'Luck',
  'Floyds Knobs',
  'Melissa',
  'Bronxville',
  'Freehold',
  'Berlin Center',
  'Newfane',
  'Girardville',
  'McPherson',
  'Secaucus',
  'Justin',
  'CO 80925',
  'Bay Wood',
  'St Peters',
  'Willits',
  'Boonton',
  'Krugerville',
  'Kittery Point',
  'Chicora',
  'Bala Cynwyd',
  'Port Reading',
  'Juneau',
  'Roscoe',
  'Mapleville',
  'Milaca',
  'Nanty Glo',
  'Fortuna',
  'Natrona Heights',
  'West View',
  'CO 80010',
  'Evesham',
  'Nineveh',
  'Baldwyn',
  'Lunenburg',
  'Sonoma',
  'Peoria Heights',
  'Cheektowaga',
  'Fairfax Station',
  'Soddy Daisy',
  'South River',
  'Castleton On Hudson',
  'Leonardo',
  'Asbury Park',
  'Cerro Gordo',
  'Escanaba',
  'Stanhope',
  'Glenmont',
  'Fairlawn',
  'Rathdrum',
  'Estero',
  'Grandville',
  'Colby',
  'Mantua Township',
  'Belfry',
  'Heyworth',
  'Peach Bottom',
  'Luxora',
  'Plainwell',
  'OH 43140',
  'Varnville',
  'Leoma',
  'East Tawas',
  'Ruidoso Downs',
  'Narragansett',
  'De Witt',
  'Jemez Pueblo',
  'Stroud',
  'Pownal',
  'Trevorton',
  'La Junta',
  'Cheltenham',
  'Mangonia Park',
  'Como',
  'Mill Hall',
  'Daingerfield',
  'Eddy',
  'Gales Ferry',
  'Greenbelt',
  'Spring Creek',
  'Penbrook',
  'Mountain Iron',
  'Allison',
  'Grand Cane',
  'Loretto',
  'Riverbank',
  'Estherville',
  'Heath',
  'Spruce Pine',
  'Pleasant Valley',
  'Staples',
  'Corona Del Mar',
  'Mexia',
  'Moosic',
  'Citra',
  'Clifton Park',
  'Lebanon Junction',
  'West St Paul',
  'Kilbourne',
  'Sycamore',
  'Sweeden',
  'Austintown',
  'Decherd',
  'Lake Hamilton',
  'South Toms River',
  'Munhall',
  'New Ellenton',
  'Herrin',
  'Cotulla',
  'Pana',
  'Tulalip',
  'The Villages',
  'Morrice',
  'Vallonia',
  'Brewton',
  'Hickory Grove',
  'Harpersville',
  'North Adams',
  'Greenbush',
  'Inver Grove Heights',
  'Putnam',
  'Sun City',
  'Winnie',
  'Glen St Mary',
  'Willoughby',
  'Millstadt',
  'Kill Devil Hills',
  'Portville',
  'Castroville',
  'Ruther Glen',
  'Inglis',
  'Henryville',
  'Huffman',
  'Chestnut Ridge',
  'Orange Grove',
  'Sansom Park',
  'Nescopeck',
  'Port Barre',
  'Elverta',
  'Vesuvius',
  'Effort',
  'Goodwater',
  'NC 28147',
  'Prairie View',
  'South Vienna',
  'Adah',
  'Jourdanton',
  'St Pauls',
  'Canyon Country',
  'Amelia Court House',
  'South Zanesville',
  'Tonkawa',
  'Green Sea',
  'Woodway',
  'Weaverville',
  'Harrells',
  'Chesaning',
  'Aztec',
  'Hingham',
  'Scotch Plains',
  'Moyock',
  'Woodward',
  'Orland Park',
  'Fisherville',
  'Roslindale',
  'Arleta',
  'Cedar Creek',
  'Brick Township',
  'Bay Springs',
  'Germantown Hills',
  'Haddock',
  'Sunrise Beach',
  'Ferndale',
  'Webbers Falls',
  'Albertson',
  'New Philadelphia',
  'Clifton Forge',
  'South Roxana',
  'Kendallville',
  'Rush',
  'Cloverdale',
  'Kennedale',
  'Heiskell',
  'Warrenville',
  'New River',
  'Manns Harbor',
  'Coal Township',
  'Walnut Ridge',
  'Marine City',
  'Birchwood',
  'Atco',
  'Castle Hayne',
  'Shenandoah',
  'Cle Elum',
  'Tucumcari',
  'Round Lake Heights',
  'Oakbrook Terrace',
  'Shallotte',
  'The Woodlands',
  'Kingsley',
  'La Palma',
  'Apple Springs',
  'Durango',
  'Big Clifty',
  'Fairbury',
  'Nesbit',
  'Sebastian',
  'Del Valle',
  'Mullins',
  'Colleyville',
  'Village of Clarkston',
  'Woods Cross',
  'Roebling',
  'English',
  'Cape Charles',
  'Bryson City',
  'Bonfield',
  'Absecon',
  'Hardin',
  'Cowansville',
  'Cottondale',
  'Fort Sumner',
  'Mount Gay',
  'River Oaks',
  'Ridley Park',
  'West Unity',
  'Piketon',
  'Cambridge City',
  'Mc Leansville',
  'Garibaldi',
  'Camillus',
  'Brookwood',
  'Hermon',
  'Kingstree',
  'Garrett',
  'Hudson Oaks',
  'Atwood',
  'Lugoff',
  'Owens Cross Roads',
  'Norwell',
  'Loami',
  'Arundel',
  'Hopkinton',
  'Monetta',
  'Silverstreet',
  'Cedar Springs',
  'Elloree',
  'East Newark',
  'Tabernacle',
  'Rio Bravo',
  'Fillmore',
  'Graysville',
  'Landfall',
  'Bostic',
  'Sturgeon Bay',
  'Groves',
  'AL 36048',
  'Grimesland',
  'Pearsall',
  'Boling-Iago',
  'Cazenovia',
  'Louisiana',
  'Floral Park',
  'Wharton',
  'Witherbee',
  'Pawleys Island',
  'Saltillo',
  'Underhill',
  'St. Lucie Village',
  'South Pasadena',
  'Dixmoor',
  'Muncy',
  'Choudrant',
  'Lakin',
  'Stevinson',
  'Little Ferry',
  'Homeland',
  'Gettysburg',
  'Luverne',
  'Gainesboro',
  'Claudville',
  'East Marion',
  'Shiremanstown',
  'Ponca',
  'Spring Branch',
  'Tombstone',
  'Oneida',
  'Tunica',
  'Casselton',
  'Gilmanton Iron Works',
  'Story City',
  'Sanderson',
  'Thonotosassa',
  'Krebs',
  'Shortsville',
  'West Boylston',
  'Solana Beach',
  'Attica',
  'Bogata',
  'Aragon',
  'Tompkinsville',
  'Boswell',
  'Linton',
  'Cottrellville',
  'Carver',
  'Oskaloosa',
  'Elberton',
  'Rogue River',
  'Green River',
  'Uvalde',
  'Archbold',
  'Hickory Flat',
  'Excelsior Springs',
  'Forest Hills',
  'Upper Arlington',
  'Victor',
  'West Riverside',
  'North Liberty',
  'Miami Springs',
  'Far Rockaway',
  'Newalla',
  'Ware',
  'Fort Atkinson',
  'Avoca',
  'Pollok',
  'Weeksbury',
  'Coden',
  'Tijeras',
  'San Andreas',
  'Normandy',
  'North Chelmsford',
  'St Helens',
  'Green Forest',
  'Neeses',
  'Nortonville',
  'Kingfisher',
  'Clanton',
  'Guymon',
  'Lisbon',
  'Devine',
  'Salyersville',
  'Beattyville',
  'Barto',
  'St Michael',
  'Constable',
  'Redwater',
  'West Virginia 26104',
  'Rosebush',
  'Bryans Road',
  'Delaware 19966',
  'Brainerd',
  'Verbena',
  'Edmonds',
  'Hailey',
  'Jaffrey',
  'Salt Rock',
  'Seale',
  'Pylesville',
  'Arab',
  'Hopewell Junction',
  'Benavides',
  'Tylertown',
  'Paxtang',
  'Woodleaf',
  'Stevens Point',
  'Blanco',
  'Middleburg Heights',
  'James Island',
  'Ventnor City',
  'Cochranton',
  'Pleasant Gap',
  'Coleta',
  'Odenville',
  'Belwood',
  'Stantonville',
  'Bedminster',
  'Ferrysburg',
  'Keyport',
  'East Hampton',
  'Panama',
  'North Salem',
  'Sibley',
  'Clarkton',
  'Council Grove',
  'Nickelsville',
  'Belews Creek',
  'Elmendorf',
  'Harvard',
  'Kingston Springs',
  'Morehead',
  'Onancock',
  'Blue Bell',
  'Pauls Valley',
  'Cornersville',
  'Burns',
  'Lilbourn',
  'Sellersburg',
  'Lyman',
  'Old Fort',
  'Orleans',
  'Dennison',
  'Beulaville',
  'Mineral',
  'Cornelia',
  'Nolanville',
  'Rosita Valley Colonia',
  'Cedar Hills',
  'East Earl',
  'Haleyville',
  'Marcellus',
  'Otsego',
  'Pahoa',
  'Douglass',
  'Driftwood',
  'Sims',
  'Saint James City',
  'West Leechburg',
  'Cassville',
  'Greenleaf',
  'Crownsville',
  'Wyckoff',
  'Allouez',
  'Larkspur',
  'Evansdale',
  'Pelzer',
  'Meadows Place',
  'Indiantown',
  'Goliad',
  'John Day',
  'Paia',
  'Wynantskill',
  'Palmview',
  'Prestonsburg',
  'Red Springs',
  'Yanceyville',
  'North Dartmouth',
  'Eagle Grove',
  'Copperhill',
  'Quarryville',
  'Benwood',
  'Saint Stephen',
  'Hemingway',
  'Badin',
  'Hartville',
  'Soledad',
  'Estacada',
  'Batesville',
  'West Hempstead',
  'Hillcrest',
  'Willow Park',
  'New Berlin',
  'Westlake Village',
  'Haledon',
  'Fort Deposit',
  'Shady Spring',
  'Mahomet',
  'Jarrettsville',
  'Smackover',
  'Wiggins',
  'Glenburn',
  'Shell Knob',
  'Garnett',
  'Lamar',
  'Boligee',
  'Rural Hall',
  'Bogota',
  'Cedarhurst',
  'Harpswell',
  'Winooski',
  'Long Branch',
  'Wheaton',
  'Hubbard',
  'Plymouth Meeting',
  'Hominy',
  'Kinnelon',
  'Kilmichael',
  'Dry Branch',
  'Valentine',
  'Secretary',
  'Greeleyville',
  'Tonopah',
  'Saint Pauls',
  'Wind Gap',
  'Menominee',
  'Sedalia',
  'Kenova',
  'Marble Hill',
  'Ashton',
  'East Grand Rapids',
  'Hiddenite',
  'Ona',
  'Chualar',
  'Nyack',
  'Dwight',
  'Basehor',
  'Palos Verdes Estates',
  'Texas 75474',
  'Foster City',
  'Menlo Park',
  '1230 E Walnut St',
  'Bevil Oaks',
  'South Ozone Park',
  'Hummelstown',
  'Cheyenne Wells',
  'Sand Lake',
  'Holly Ridge',
  'Nephi',
  'Ewing Township',
  'Chittenango',
  'Halstead',
  'Solway',
  'Coates',
  'Pierce City',
  'Baraboo',
  'Munith',
  'Clarklake',
  'North Dinwiddie',
  'Fairland',
  'Palmerton',
  'Rutledge',
  'Bonaire',
  'Denmark',
  'Hensley',
  'South Ogden',
  'Emmitsburg',
  'Saint Gabriel',
  'Nettleton',
  'San Manuel',
  'Charlotte Hall',
  'Mt. Zion',
  'Waukee',
  'Shady Cove',
  'Monterey',
  'Franklin Square',
  'Lake Arthur',
  'Greenport',
  'Blackville',
  'Terrace Park',
  'Oreland',
  'Schulenburg',
  'Pearson',
  'Saint Simons Island',
  'Canby',
  'Martin',
  'Emmet',
  'Royalton',
  '??',
  'Bumpass',
  'Erin',
  'Southport',
  'Perry Hall',
  'Sioux Center',
  'Sharpsburg',
  'Freeland',
  'Bonner Springs',
  'Bulger',
  'Bow',
  'Marlboro Township',
  'Mount Oliver',
  'Locust Fork',
  'Virgie',
  'Haileyville',
  'Calumet',
  'East Norwich',
  'Millwood',
  'San Carlos',
  'Airville',
  'Blissfield',
  'Greenlawn',
  'Blooming Grove',
  'Big Pine',
  'Swords Creek',
  'Archer',
  'Woodhaven',
  'Kenedy',
  'Charlton',
  'Berrydale',
  'Long Valley',
  'Oak Forest',
  'Cockrell Hill',
  'Valley Grande',
  'Parowan',
  'Screven',
  'North Potomac',
  'Sault Ste. Marie',
  'Ben Lomond',
  'Marble Falls',
  'Lower Burrell',
  'Castleton',
  'Lyndonville',
  'Duboistown',
  'Red Bluff',
  'Brush Prairie',
  'Wayland',
  'Mercer',
  'De Leon Springs',
  'Melfa',
  'Mound Bayou',
  'Pomona Park',
  'Othello',
  'Glens Falls',
  'Brockway',
  'Brogden',
  'Granada Hills',
  'Baxter Estates',
  'Gilmanton',
  'Eudora',
  'Saint Marys',
  'Yosemite National Park',
  'Vashon',
  'North Versailles',
  'Badger',
  'Coupland',
  'West Fork',
  'Chester Gap',
  'Cold Spring',
  'Broadlands',
  'Valliant',
  'Edna',
  'North Bloomfield',
  'Catasauqua',
  'Hauppauge',
  'Napier Field',
  'Evans City',
  'Horicon',
  'Madrid',
  'Hewlett',
  'Mansfield Center',
  'Willow Street',
  'Smiley',
  'Bromley',
  'Alachua',
  'Century',
  'Blain',
  'Genoa',
  'Center',
  'New Chicago',
  'Skipwith',
  'Uhrichsville',
  'Wapella',
  'Royston',
  'Owings',
  'Redwood Falls',
  'Pipe Creek',
  'Ada',
  'Wellton',
  'Rising Fawn',
  'Edmonston',
  'Coila',
  'Woodbury Heights',
  'Batson',
  'Wallkill',
  'Arvin',
  'Montréal',
  'Green Level',
  'Manson',
  'Salt Lick',
  'Hinsdale',
  'Harviell',
  'Coarsegold',
  'Wexford',
  'Gowen',
  'Lewisport',
  'Bishop',
  'Blairsville',
  'Ehrhardt',
  'Roxana',
  'Baxter',
  'Rayland',
  'Ronan',
  'Wilmar',
  'TX 77434',
  'Pine Level',
  'Fulks Run',
  'Lake Panasoffkee',
  'New Concord',
  'Carolina Shores',
  'Ocklawaha',
  'Cape May Court House',
  'Zim',
  'Isanti',
  'Ramer',
  'Galliano',
  'Coral Gables',
  'Guntown',
  'Myrtle',
  'New Holstein',
  'Wynne',
  'Slippery Rock',
  'Ohioville',
  'Cranberry Twp',
  'Wolbach',
  'McAdoo',
  'Tripoli',
  'Fair Play',
  'Galivants Ferry',
  'Show Low',
  'Parrish',
  'Marriottsville',
  'Lamesa',
  'Hazelton',
  'Princewick',
  'West Lake Hills',
  'Williston Park',
  'Dinwiddie',
  'Lake Forest Park',
  'Ash Grove',
  'McClure',
  'Duenweg',
  'Nobleboro',
  'Glen Carbon',
  'New Ross',
  'Scottville',
  'Otterbein',
  'Saranac Lake',
  'St Clairsville',
  'East Islip',
  'New Buffalo',
  'Hurt',
  'Manchester M8',
  'China',
  'Pleasant Garden',
  'Lyndeborough',
  'Lawsonville',
  'East Hanover',
  'Osage',
  'Welsh',
  'Sutherlin',
  'Bermuda Run',
  'Elm City',
  'Fort Leonard Wood',
  'Deerfield',
  'Littlerock',
  'Maidsville',
  'Mena',
  'Blades',
  'Offutt Afb',
  'North Baldwin',
  'Bushkill',
  'Manassa',
  'Narrowsburg',
  'Savanna',
  'Allison Park',
  'Adams Run',
  'Glenpool',
  'Netcong',
  'Boulder Creek',
  'Saint Paul Park',
  'Grundy',
  'Topock',
  'Toronto',
  'Bluford',
  'Cooper City',
  'Madison Lake',
  'Eclectic',
  'Valier',
  'Combes',
  'Christopher',
  'Ernul',
  'Vanceboro',
  'Mashantucket',
  'Burdett',
  'Youngtown',
  'Stateline',
  'Babson Park',
  'Axton',
  'Rutherford College',
  'Mount Clare',
  'Clive',
  'Oelwein',
  '???-????????',
  'Millersburg',
  'North Judson',
  'Mount Perry',
  'New Egypt',
  'Northford',
  'Oglesby',
  'Sun City West',
  'Pipersville',
  'Shavertown',
  'Carlstadt',
  'Philomath',
  'Boyertown',
  'Red House',
  'Waubun',
  'St Albans City',
  'Wing',
  'Garrison',
  'Marshville',
  'Leo-Cedarville',
  'Kinsey',
  'Hosston',
  'South Bay',
  'Tremonton',
  'Astatula',
  'Glendive',
  'Siloam',
  'Frazee',
  'Oquawka',
  'Enola',
  'Resaca',
  'Mastic Beach',
  'Sarepta',
  'Fort Gay',
  'Hilmar',
  'Little Canada',
  'Edmonton',
  'Adona',
  'Tenino',
  'Lytton',
  'Roberts',
  'Manahawkin',
  'Kellogg',
  'Nickerson',
  'Wink',
  'Chamberlain',
  'Sandwich',
  'Big Pine Key',
  'Castleberry',
  'East Brewton',
  'Claxton',
  'Stuttgart',
  'Morenci',
  'Parlin',
  'Brownsdale',
  'Old Forge',
  'Poughquag',
  'Marblehead',
  'Kingfield',
  'Winterport',
  'Industry',
  'Doyle',
  'Barrington Hills',
  'Chuo-Ku',
  'San Juan Capistrano',
  'North Waterboro',
  'Laconia',
  'Homerville',
  'Charenton',
  'Grantsville',
  'Macclesfield',
  'Elmwood Place',
  'Kenly',
  'Waterport',
  'Tuba City',
  'St. Marys',
  'Aliceville',
  'Giddings',
  'Rockdale',
  'Fort Mohave',
  'Adena',
  'Moosup',
  'Shellsburg',
  'Hartley',
  'Silvis',
  'Glade Valley',
  'Lake Arrowhead',
  'Floydada',
  'Canutillo',
  'California 92314',
  'Thief River Falls',
  'Franklin Furnace',
  'Longs',
  'Goodland',
  'Atlantic',
  'Graytown',
  'Los Altos',
  'Ringold',
  'Ethel',
  'Dos Palos',
  'Blytheville',
  'Glenwood City',
  'Crimora',
  'Maxwell',
  'Lauderdale-by-the-Sea',
  'Rochester Hills',
  'Larimore',
  'Tequesta',
  'Snook',
  'Pinewood',
  'Montegut',
  'Nesconset',
  'Corinna',
  'Nowata',
  'Boxford',
  'Port Washington',
  'Gladwin',
  'Factoryville',
  'Paulina',
  '???',
  'Menno',
  'Saugus',
  'Attleboro Falls',
  'Downsville',
  'East Farms',
  'Weaver',
  'Cliffwood',
  'Metuchen',
  'Sussex',
  'Oakhurst',
  'Independence Charter Township',
  'Wilberforce',
  'Hamel',
  'Dillsburg',
  'Priceville',
  'Scottsville',
  'Thorntown',
  'Waynesfield',
  'Hillsborough Township',
  'Vardaman',
  'Christiana',
  'Farr West',
  'Whitefish Bay',
  'Fort Benning',
  'Point Pleasant Beach',
  'Terrell Hills',
  'Mohrsville',
  'Pinebluff',
  'Escobares',
  'Gilcrest',
  'Lincoln City',
  'Chazy',
  'Hoquiam',
  'Poynette',
  'Lincoln University',
  'Bellaire',
  'West Caldwell',
  'Falcon Heights',
  'Paraje',
  'Kitts Hill',
  'Lincoln Heights',
  'Odum',
  'East Flat Rock',
  'Oak Hills',
  'Moundsville',
  'Poolville',
  'Waller',
  'Cahokia',
  'Dorothy',
  'Terre Hill',
  'Wahneta',
  'Three Forks',
  'Minooka',
  'Mio',
  'Henry',
  'Lake Grove',
  'Spout Spring',
  'Veradale',
  'Trempealeau',
  'New Lebanon',
  'San Simon',
  'Ishpeming',
  'Bassfield',
  'Tuckahoe',
  'Tower Hill',
  'Cecil',
  'Frazier Park',
  'Leadwood',
  'New Madrid',
  'Marlow',
  'Vernon Hill',
  'Nags Head',
  'Cooksville',
  'Dunlap',
  'Newborn',
  'Woodson',
  'Markleville',
  'Wolf Point',
  'Eva',
  'New Kingman',
  'Zelienople',
  'Colstrip',
  'Coaldale',
  'Garden Valley',
  'Waipahu',
  'Schiller Park',
  'Burtchville Township',
  'Finleyville',
  'Superior Charter Twp',
  'Marathon',
  'Earlsboro',
  'Lagrange',
  'East Brunswick',
  'South Nyack',
  'Heuvelton',
  'Tamaqua',
  'Slaughters',
  'Vassalboro',
  'Poplarville',
  'Port Ludlow',
  'Omar',
  'Pago Pago',
  'Neptune Beach',
  'Alva',
  'Dubois',
  'East China',
  'Barryton',
  'Bono',
  'Loreauville',
  'Ault',
  'Detroit Lakes',
  'Wall Township',
  'East Berlin',
  'Brule',
  'Nelsonville',
  'Terra Bella',
  'Hartwell',
  'Sulligent',
  'Isonville',
  'Buffalo Grove',
  'Monroe City',
  'Center Cross',
  'Iowa Park',
  'Helper',
  'Dixie',
  'Deville',
  'North Branch',
  'Chebanse',
  'Arendtsville',
  'Deep River',
  'Gum Spring',
  'Sumterville',
  'North St. Paul',
  'Speedwell',
  'Drummonds',
  'Pinconning',
  'Reklaw',
  'Hauser',
  'Whitwell',
  'Accomac',
  'Kekaha',
  'Florien',
  'Sorento',
  'Rye Brook',
  'St Francis',
  'Convent',
  'Mead',
  'Kailua',
  'Rocheport',
  'Mt Ephraim',
  'Woodbridge Township',
  'Crossett',
  'Oracle',
  'Leetsdale',
  'Zapata',
  'Glenshaw',
  'Keaau',
  'Fly Creek',
  'Kaysville',
  'Morganville',
  'Spicewood',
  'Stanfield',
  'Fircrest',
  'Lake Saint Louis',
  'Clark',
  'Brady',
  'South Coatesville',
  'Lavaca',
  'Amenia',
  'Hillsdale',
  'Crozet',
  'East Bernard',
  'Blackduck',
  'East St Louis',
  'Oak Bluffs',
  'Sylva',
  'Hiltonia',
  'Copalis Beach',
  'Tennessee Colony',
  'Cornish',
  'Algona',
  'Copperopolis',
  'Muleshoe',
  'San Juan Bautista',
  'Sale Creek',
  'Greenwell Springs',
  'Grand Ronde',
  'Sidney Center',
  'Pittsville',
  'Merrill',
  'Welch',
  'Slate Hill',
  'Port Isabel',
  'Pine Castle',
  'Greene',
  'Bozrah',
  'Tiverton',
  'Columbia Falls',
  'Lindsay',
  'Okemah',
  'Florida 32084',
  'Groesbeck',
  'Pinetop',
  'Richmondville',
  'North Braddock',
  'Offutt AFB',
  'Kirkville',
  'Oakham',
  'CA 92673',
  'Saint Inigoes',
  'Cross Lanes',
  'Beech Bluff',
  'Marble Cliff',
  'Oklaunion',
  'Devils Lake',
  'St. Pauls',
  'Steens',
  'Hodgenville',
  'Condon',
  'Rawlins',
  'Dana',
  'Mill Run',
  'Penndel',
  'Elkins',
  'Dardenne Prairie',
  'Mc Clellandtown',
  'Colona',
  'Walthourville',
  'Sparrow Bush',
  'Renovo',
  'Elk City',
  'Disputanta',
  'Bay Village',
  'Red Bay',
  'Pennsville',
  'Blue Mounds',
  'New Wilmington',
  'Soldier',
  'Carnation',
  'Otisville',
  'Jayess',
  'Demotte',
  'Morningside',
  'Gillham',
  'Knox',
  'Gordonville',
  'Shuqualak',
  'Steinhatchee',
  'Sunset Valley',
  'Kapaa',
  'Macungie',
  'Ajo',
  'Mc Millan',
  'Rhodesdale',
  'Acton',
  'Cana',
  'Sandpoint',
  'Walpole',
  'Brazil',
  'Holloman Air Force Base',
  'Saint Leo',
  'Zimmerman',
  'Sausalito',
  'Pewaukee',
  'Centerton',
  'Valley Cottage',
  'Sea Cliff',
  'Scituate',
  'Grosse Pointe Woods',
  'Cost',
  'Hubert',
  'New Marshfield',
  'Chillum',
  'Coxsackie',
  'Penn Valley',
  'Guin',
  'Porterdale',
  'Ida',
  'Surf City',
  'North Easton',
  'Marion Center',
  'Pearl City',
  'Gooding',
  'Georgia 31645',
  'Oak Ridge North',
  'Havre De Grace',
  'Waveland',
  'Poultney',
  'Babylon',
  'Joseph City',
  'Teague',
  'Nanakuli',
  'Castalian Springs',
  'Silver Gate',
  'Arkoma',
  'Columbiana',
  'Skaneateles',
  'Paisley',
  'New Trenton',
  'Mc Calla',
  'Bassett',
  'Mooers',
  'Milltown',
  'East Aurora',
  'Lindstrom',
  'Yolo',
  'Orange Cove',
  '6608 S West Shore Blvd',
  'Galway',
  'North Springfield',
  'Prosser',
  'Lake Clarke Shores',
  'Hornsby',
  'Custer',
  'Pryor Creek',
  'Chunchula',
  'Plainsboro Township',
  'Peterman',
  'Goldendale',
  'Fife Lake',
  'Somis',
  'Defuniak Springs',
  'Knob Noster',
  'Mounds',
  'Mt Laurel Township',
  'Lanesville',
  'Pepperell',
  'Fairhaven',
  'Shalimar',
  'Etna',
  'Mustang',
  'Whitman',
  'Bruceton',
  'Ochlocknee',
  'Garden Ridge',
  'Niskayuna',
  'Manti',
  'Gold Hill',
  'McConnellsburg',
  'Manchester-by-the-Sea',
  'Valencia',
  'Mc Donald',
  'Marina Del Rey',
  'Arizona 85139',
  'Hudson Falls',
  'Amanda',
  'Carleton',
  'Cookstown',
  'Mount Holly Springs',
  'Peyton',
  'Belcamp',
  'Virden',
  'Wells Tannery',
  'Fannettsburg',
  'North Wildwood',
  'Sportsmen Acres',
  'Belfair',
  'Farmingville',
  'Rayne',
  'Iron City',
  'Country Club',
  'McCaulley',
  'Black Hawk',
  'San Elizario',
  'Glencoe',
  'Humansville',
  'Centertown',
  'Jetersville',
  'Fairchild Air Force Base',
  'Tarlton',
  'New Canaan',
  'Brush Creek',
  'Robertsdale',
  'Branchville',
  'Sallis',
  'Columbiaville',
  'Orwigsburg',
  'Van Horn',
  'Perkinston',
  'Richwoods',
  'Trout',
  'Amery',
  'Lake Waynoka',
  'East Hazel Crest',
  'West Paducah',
  'Climax',
  'Waitsfield',
  'Bastian',
  'Lanoka Harbor',
  'Reinholds',
  'Cofield',
  'North Amityville',
  'Morley',
  'Chestnut Hill',
  'Grand View',
  'Bonita',
  'White Stone',
  'Bevinsville',
  'Sebewaing',
  'Wailuku',
  'Deridder',
  'Osprey',
  'Altavista',
  'Man',
  'Bonneau',
  'Bernice',
  'Lawn',
  'Hurlock',
  'Rio',
  'Lee',
  'Reedsburg',
  'Vanderbilt',
  'Argo',
  'Doswell',
  'Bancroft',
  'Hainesport',
  'White Cloud',
  'Hoopeston',
  'Storrs Mansfield',
  'Saugatuck',
  'Laurel Hollow',
  'GA 31407',
  'OH 44070',
  'Hazlet',
  'Charlemont',
  'Chesapeake Beach',
  'Hot Springs Village',
  'Troutville',
  'Mc Gregor',
  'Davisburg',
  'Heppner',
  'Okmulgee',
  'Clear Brook',
  'Roaring Spring',
  'Joelton',
  'Crystal River',
  'Brandenburg',
  'Yacolt',
  'McConnelsville',
  'Collegeville',
  'Emlenton',
  'Monett',
  'Lone Rock',
  'Algodones',
  'Machias',
  'Pawcatuck',
  'Waretown',
  'Kerhonkson',
  'McEwen',
  'East Los Angeles',
  'Cinnaminson',
  'Eupora',
  'Acampo',
  'Beaverdam',
  'East Troy',
  'Wilkes Barre',
  'Smiths Grove',
  'Glenville',
  'Ruby',
  'Gardiner',
  'Hagerhill',
  'Hartford City',
  'Trevor',
  'Craigsville',
  'Lucasville',
  'Bonetraill',
  'Summerset',
  'Arcanum',
  'Blakeslee',
  'Hettinger',
  'Treynor',
  'Youngwood',
  'Laurel Springs',
  'Greentown',
  'Brewer',
  'North Riverside',
  'Slocomb',
  'Twain Harte',
  'Progreso',
  'Greenvale',
  'Rhoadesville',
  'Homer City',
  'Teutopolis',
  'Vaughn',
  'Orland Hills',
  'Mt Washington',
  'Corona De Tucson',
  'Rifle',
  'Botkins',
  'Miamitown',
  'Talty',
  'North Lawrence',
  'Dumont',
  'Mountain House',
  'Chadds Ford',
  'Mulvane',
  'Hadley',
  'North Webster',
  'Remer',
  'Guilford',
  'Prairie Village',
  'Middletown Township',
  'Kimper',
  'Hubbardston',
  'Custer City',
  'Killen',
  'Saronville',
  'Many',
  'Topsfield',
  'Camanche',
  'Scott Air Force Base',
  'Tabor City',
  'Vernonia',
  'Truckee',
  'Southborough',
  'Axis',
  'Kent City',
  'Big Bear Lake',
  'Dodgeville',
  'Knollwood',
  'Chambers',
  'PORT WENTWRTH',
  'Petal',
  'Ocean View',
  'New Hudson',
  'Slaughterville',
  'Voluntown',
  'Rolling Hills',
  'Rhinebeck',
  'Willowbrook',
  'Frisco City',
  'Harpers Ferry',
  'Electra',
  'Montz',
  'Mt Holly Springs',
  'North Brookfield',
  'Washoe Valley',
  'Stokes',
  'Drewryville',
  'Jim Thorpe',
  'Robertsville',
  'Cave Creek',
  'Russell',
  'Tennessee',
  'Weldon Spring',
  'Gilchrist',
  'West Green',
  'Milford Center',
  'Soldotna',
  'Ridgeley',
  'Round Mountain',
  'Fraser',
  'Burkesville',
  'Manorville',
  'Horton',
  'Gordo',
  'Yaphank',
  'Overgaard',
  'Robards',
  'Bee Cave',
  'Havre de Grace',
  'Jacks Creek',
  'Rappahannock Academy',
  'Knik',
  'Mahopac',
  'Campbellsville',
  'Mt Morris',
  'Rush Springs',
  'Platte City',
  'Coudersport',
  '425 E Brown Rd',
  'Minot AFB',
  'Mammoth',
  'Canastota',
  'Islandia',
  'Seaside Heights',
  'Portal',
  'Incline Village',
  'Wyalusing Township',
  'Western Springs',
  'Pinckneyville',
  'Morrisdale',
  'McCormick',
  'Santa Nella',
  'Eagletown',
  'East Honolulu',
  'Woodmere',
  'Warm Springs',
  'Ocean Grove',
  'Steeleville',
  'Shenandoah Junction',
  'Pickett',
  'Ravensdale',
  'Shorter',
  'Limestone',
  'Nixon',
  'New Augusta',
  'Strunk',
  'Maybee',
  'Wesson',
  'Hawaii 96792',
  'Wilburton',
  'Sunshine',
  'Ava',
  'Highgate Center',
  'Earleville',
  'Purcellville',
  'City of Orange',
  'Prineville',
  'Loxahatchee',
  'Estes Park',
  'Edwardsburg',
  'Leakesville',
  'Earlington',
  'Fort McCoy',
  'Roachdale',
  'Newfield',
  'Donalds',
  'New Pekin',
  'Frankton',
  'Holt',
  'Abbott',
  'Wellborn',
  'Laurys Station',
  'Bloomingburg',
  'Mabelvale',
  'Cambria',
  'Lemoyne',
  'Gentry',
  'Gerrardstown',
  'Ipswich',
  'Champions Gate',
  'Pinon Hills',
  'Asher',
  'MO 64420',
  'Mountville',
  'Blossburg',
  'Hartshorne',
  'Franktown',
  'Lakebay',
  'Greybull',
  'Nashport',
  'Barefoot Bay',
  'Alabama 35462',
  'Oacoma',
  'Efland',
  'Woolwich Township',
  'Harlan',
  'Hallettsville',
  'Waterford Works',
  'St. Augustine Beach',
  'North Brunswick Township',
  'Ochelata',
  'Earlham',
  'Silver Grove',
  'Templeton',
  'Pompton Lakes',
  'Ruthven',
  'Montague',
  'Blowing Rock',
  'Parish',
  'Solgohachia',
  'Ralston',
  'Mt Crawford',
  'Beaver County',
  'Poestenkill',
  'Eldorado',
  'Yale',
  'Texas 77493',
  'South Carolina 29728',
  'Fort Branch',
  'Keshena',
  'Faribault',
  'Castlewood',
  'Waddell',
  'Fairchance',
  'Donora',
  'Shoreview',
  'West Oaks Village',
  'Inkom',
  'Ovid',
  'New Florence',
  'Jewett',
  'Fort Cobb',
  'Cross Timber',
  'Delton',
  'Corrigan',
  'Grayville',
  'Rainelle',
  'Arcola',
  'Bisbee',
  'Granite Quarry',
  'Aromas',
  'Sneedville',
  'Velma',
  'Granite Bay',
  'Averill Park',
  'Maxeys',
  'Tarzana',
  'Penn Laird',
  'Tremont',
  'Atherton',
  'Geismar',
  'Whitinsville',
  'Bates City',
  'North Bennington',
  'Lake Helen',
  'Highland Springs',
  'Onamia',
  'Apison',
  'Scio',
  'Lavalette',
  'Scotts Hill',
  'Haughton',
  'Huttig',
  'Milam',
  'Saint Helena Island',
  'Hermann',
  'Mentor-On-The-Lake',
  'Long Pond',
  'Cowpens',
  'Hokes Bluff',
  'Blue Ridge',
  'Horseshoe Bay',
  'Feeding Hills',
  'Tchula',
  'Kenna',
  'Stewartville',
  'Gansevoort',
  'Kings Mills',
  'Ravenel',
  'Coloma',
  'Loranger',
  'Hurtsboro',
  'Rocky Hill',
  'Castor',
  'St John',
  'Remerton',
  'Uvalda',
  'Wingate',
  'Manakin Sabot',
  'Deering',
  'Georgia 30442',
  'North Utica',
  'Elverson',
  'Windfall',
  'Herlong',
  'Dover Plains',
  'Bledsoe',
  'Grand Chenier',
  'Lake Station',
  'La Jara',
  'Bridgeview',
  'Broad Run',
  'Airway Heights',
  'Orange Township',
  'Lake Ariel',
  'Bargersville',
  'New Church',
  'Spirit Lake',
  'Corfu',
  'Diana',
  'Eynon',
  'Plum',
  'Huntingtown',
  'Elberta',
  '11120 Beamer Way',
  'Colts Neck',
  'FL 32542',
  'OH 44060',
  'Davidsonville',
  'Lonoke',
  'Needham Heights',
  'Level Plains',
  'Tekoa',
  'Patton Village',
  'Bodega',
  'Oakridge',
  'Powderly',
  'Powhattan',
  'Hilham',
  'Richton',
  'Elm Grove',
  'South Lebanon',
  'Bucyrus',
  'Hometown',
  'TX 76549',
  'Grantham',
  'Larsen',
  'Carmichaels',
  'Minoa',
  'Globe',
  'Spiro',
  'Excelsior',
  'Hardinsburg',
  'Monument',
  'Rimrock',
  'Clark Fork',
  'Mustang Ridge',
  'Belle Fourche',
  'Bardwell',
  'Larchmont',
  'Redgranite',
  'Grove Hill',
  'Summitville',
  'Chippewa Falls',
  'Onawa',
  'Valatie',
  'Browning',
  'Argillite',
  'Adelphi',
  'Sells',
  'Lucerne',
  'Española',
  'Brookneal',
  'Cranberry',
  'Olla',
  'Shade',
  'Lincolnwood',
  'Annville',
  'Kaneohe',
  'Elkhorn City',
  'Princes Lakes',
  'Big Timber',
  'China Township',
  'Losantville',
  'Lake Lillian',
  'Cripple Creek',
  'Rector',
  'Brooklyn Heights',
  'Scotts Valley',
  'Shannon Hills',
  'New Vienna',
  'Perkins',
  'Higdon',
  'HI 96745',
  'Forreston',
  'Bull Creek',
  'Max Meadows',
  'McClellan Park',
  'Cave Spring',
  'Peach Springs',
  'Lutherville-Timonium',
  'Roopville',
  'Warner',
  'Kevil',
  'Kulpmont',
  'Fort Madison',
  'Mary Esther',
  'Wrentham',
  'Weedsport',
  'Rineyville',
  'Old Saybrook',
  'New Rockford',
  'Camp Lejeune',
  'Quartz Hill',
  'Luther',
  'Lesterville',
  'Lockwood',
  'Leechburg',
  'Edmonson',
  'North St Paul',
  'Clarion',
  'Tyndall',
  'Mossville',
  'Pocola',
  'Armada',
  'Boxborough',
  'Summit Hill',
  'Ariton',
  'White',
  'Chelan',
  'Pringle',
  'Pine Beach',
  'Vestal',
  'Smith River',
  'Balaton',
  'Sophia',
  'Hellertown',
  'Brownstown Twp',
  'Hamtramck',
  'Nantucket',
  'Halfmoon',
  'North Parkersburg',
  'Kimberling City',
  'River Ridge',
  'Vandling',
  'Prospect Heights',
  'North Attleborough',
  'Section',
  'Blountstown',
  'Sulphur Rock',
  'Colchester',
  'Friona',
  'Sewanee',
  'Eldon',
  'Malverne',
  'Indian Orchard',
  'Seaside Park',
  'Reseda',
  'Chilton',
  'Northborough',
  'Blanch',
  'Carbon Hill',
  'Merriam Woods',
  'Rogers City',
  'Tannersville',
  'Morse',
  'Scribner',
  'Walland',
  'Belden',
  'Samson',
  'Woolwine',
  'Limon',
  'Lamont',
  'Penfield',
  'Elk Garden',
  'Shermans Dale',
  'Loogootee',
  'Indian Springs',
  'Hermosa Beach',
  'Rabun Gap',
  'Hunt',
  'Olmito',
  'Cherry Valley',
  'Boylston',
  'Howe',
  'Colma',
  'Lake Bluff',
  'Chandlerville',
  'Woodlyn',
  'Keyser',
  'New Columbia',
  'La Jolla',
  'Reva',
  'Sheboygan Falls',
  'Farmerville',
  'Wellsboro',
  'Du Quoin',
  'Mc Connells',
  'Weare',
  'Hooksett',
  'Forks',
  'Thompson',
  'Gorham',
  'McChord Afb',
  'Nebraska City',
  'Walstonburg',
  'Tanner',
  'Webb',
  'Ledgewood',
  'Nassau Bay',
  'Benton City',
  'Thackerville',
  'Talmoon',
  'Jarvisburg',
  'Manton',
  'South West City',
  'Sandoval',
  'Hughes Springs',
  'Powdersville',
  'Fosston',
  'Turners Falls',
  'Milton Freewater',
  'Goodlettsville',
  'Apalachin',
  'Tool',
  'FL 34787',
  'Kentucky 42086',
  'Towanda',
  'Dry Fork',
  'Paulding',
  'Canehill',
  'Cropwell',
  'Dulce',
  'Mc Dade',
  'Meadow Bridge',
  'La Habra Heights',
  'Tower City',
  'Islip',
  'Bloxom',
  'Lanark',
  'Hardyville',
  'Deruyter',
  'Polkton',
  'Mentone',
  'Tunnelton',
  'Fellsmere',
  'Buras',
  'Wade',
  'Whitmire',
  'West Jefferson',
  'Tomah',
  'Smilax',
  'Holly springs',
  'Marmora',
  '?Ewa Beach',
  'Pamplico',
  'Osawatomie',
  'Duke Center',
  'Nuiqsut',
  'Fonda',
  'Oldtown',
  'Calimesa',
  'Mt Baldy',
  'Schellsburg',
  'Signal Mountain',
  'Gambier',
  'Castle Creek',
  'Canon City',
  'Bethel Island',
  'Lake',
  'East Longmeadow',
  'Ivins',
  'McDermott',
  'Timpson',
  'House Springs',
  'Burley',
  'Drewsey',
  'West Helena',
  'Tobaccoville',
  'Covington Township',
  'Olalla',
  'West Alexandria',
  'Smithland',
  'Leasburg',
  'Lakehurst',
  'Mineral Ridge',
  'Lago Vista',
  'Seven Springs',
  'Cheswick',
  'North Baltimore',
  'North Branford',
  'Clemson',
  'Roseau',
  'Steele',
  'Doyline',
  'Onsted',
  'Tuscarawas',
  'Green Camp',
  'Forestburg',
  'Beulah',
  'Patrick',
  'Voorhees Township',
  'Unicoi',
  'Kerens',
  'North Terre Haute',
  'Libby',
  'Terra Alta',
  'Posey',
  'Van Lear',
  'Kennedy',
  'Lester Prairie',
  'West Marlboro',
  'White Bluff',
  'Hillsville',
  'Haworth',
  'Le Sueur',
  'Konawa',
  'Avenel',
  'Barksdale AFB',
  'Powers Lake',
  'Dodge City',
  'Ilwaco',
  'Stanardsville',
  'Diboll',
  'Prim',
  'WI 54661',
  'Checotah',
  'Burt',
  'Chincoteague',
  'Altenburg',
  'Berkley',
  'Comanche',
  'Satsuma',
  'American Falls',
  'Crenshaw',
  'Earlville',
  'Lander',
  'Lepanto',
  'Wauseon',
  'Romeo',
  'Bay Harbor Islands',
  'Laurie',
  'Green Park',
  'Mount Rainier',
  'Dortches',
  'Sapphire',
  'Kelseyville',
  'Golden City',
  'Eloy',
  'Lerna',
  'Donald',
  'Deep Gap',
  'Scott Depot',
  'Emerson',
  'Swoyersville',
  'Freeburg',
  'Millvale',
  'Millen',
  'Rutland',
  'Cove',
  'Oscoda',
  'Parkesburg',
  'Port Jefferson Station',
  'TN 37742',
  'Fountain Lake',
  'Semora',
  'Arnoldsville',
  'Blandon',
  'Conneaut Lake',
  'Florham Park',
  'McClellandtown',
  'Leona',
  'Kewaunee',
  'Hiawatha',
  'Vernon Hills',
  'Riesel',
  'Kountze',
  'Kenyon',
  'Bronte',
  'Belle Rose',
  'Eastanollee',
  'Roscommon',
  'Coleman',
  'Bracey',
  'McLaughlin',
  'Primm Springs',
  'Poinciana',
  'Laurelville',
  'Horsham',
  'Ruth',
  'Culver',
  'Pinola',
  'Braidwood',
  'Edgemoor',
  'Amboy',
  'Friday Harbor',
  'Montverde',
  'Lone Oak',
  'Ravenswood',
  'North Tazewell',
  'Leavittsburg',
  'Eastaboga',
  'Rainbow City',
  'Lake Hallie',
  'Joint Base Lewis-McChord',
  'Mc Comb',
  'Lynnville',
  'Perdido',
  'Ossining',
  'Georgia 30094',
  'Flintstone',
  'Ilion',
  'Ellerslie',
  'Mt Union',
  'Clarks Summit',
  'Lochbuie',
  'Osage City',
  'Old Orchard Beach',
  'Anson',
  'Cortlandt',
  'Camano Island',
  'Tennessee 37061',
  'Bonanza',
  'St Paris',
  'Bountiful',
  'Buena',
  'Mars Hill',
  'Chilhowie',
  'Cardiff',
  'Selmer',
  'South Carolina 29730',
  'Odin',
  'Landisburg',
  'Dry Prong',
  'Tampico',
  'Gouldsboro',
  'Moundville',
  'Old River-Winfree',
  'West Burlington',
  '8801 Sudley Rd',
  'Severance',
  'Sleepy Hollow',
  'Alabama 36079',
  'McKenney',
  'Dell Rapids',
  'Philippi',
  'Centerburg',
  'Charlotte Court House',
  'Avinger',
  'Keego Harbor',
  'Mount Kisco',
  'Coaling',
  'Russells Point',
  'Gold River',
  'Goldvein',
  'Allenstown',
  'Tom Bean',
  'Napavine',
  'Kerkhoven',
  'Bell Buckle',
  'South Floral Park',
  'Holliston',
  'Rupert',
  'Kenockee',
  'Mongaup Valley',
  'Scappoose',
  'Driscoll',
  'Waggoner',
  'Crockett',
  'Summersville',
  'Dalwallinu',
  'Newland',
  'Broomall',
  'Mount Orab',
  'Lino Lakes',
  'Clarence Center',
  'Mc David',
  'Rio Vista',
  'Coopersburg',
  'Florida',
  'Kiefer',
  'Seagraves',
  'Elsa',
  'Campbell Hall',
  'Donahue',
  'Highland Village',
  'Grandy',
  'Mathews',
  'Wolverine Lake',
  'Stedman',
  'Windber',
  'Branson West',
  'Hallsboro',
  'West City',
  'Newton Falls',
  'Coal Valley',
  'Ashburnham',
  'Monessen',
  'Drums',
  'Readfield',
  'Wedowee',
  'Bermuda Dunes',
  'Priest Lake',
  'West Friendship',
  'Justice',
  'Adamstown',
  'Garden Plain',
  'West Liberty',
  'Halifax',
  'Rule',
  'Salisbury Mills',
  'Clear Fork',
  'Highlandville',
  'Gustine',
  'Kings Park',
  'Tarentum',
  'Petoskey',
  'Dillonvale',
  'Kohler',
  'Pearcy',
  'Houghton',
  'Prior Lake',
  'Concrete',
  'Muscle Shoals',
  'Ferrum',
  'Astoria',
  'Meadow Grove',
  'Leitchfield',
  'Copper Canyon',
  'North Courtland',
  'Sandia Park',
  'Jacksboro',
  'Orinda',
  'Sudlersville',
  'Crooks',
  'Brattleboro',
  'San Saba',
  'Sinking Spring',
  'Granite Shoals',
  'Pedricktown',
  'Hewett',
  'Moline Acres',
  'Petersville',
  'Bloomsbury',
  'Holladay',
  'Rockvale',
  'Coushatta',
  'North Benton',
  'Boomer',
  'Des Allemands',
  'Mt Prospect',
  'Ranlo',
  'Duson',
  'Goddard',
  'Selbyville',
  'Heidelberg',
  'Savoy',
  'East New Market',
  'Middle Grove',
  'Stickney',
  'Navassa',
  'Kahului',
  '9654 Norfolk St',
  'Tar Heel',
  'Pima',
  'Ball',
  'Archbald',
  'Oakboro',
  'Calhoun City',
  'Saylorsburg',
  'Belford',
  'New Lisbon',
  'Rosepine',
  'Robesonia',
  'Kunkletown',
  'Cutler',
  'Canada',
  'Okanogan',
  'Northmoor',
  'Gillett',
  'New Paltz',
  'Ballston Lake',
  'South Blooming Grove',
  'Sugar Creek',
  'Cobb Town',
  'Wynnewood',
  'Edgecliff Village',
  'Drakes Branch',
  'Apache',
  'Dennis Mills',
  'Peosta',
  'Pismo Beach',
  'Tillamook',
  'Bernardston',
  'Brownstown Charter Twp',
  'Colorado City',
  'Chocowinity',
  'Dowagiac',
  'Bentonia',
  'Three Oaks',
  'Chapman',
  'Smithton',
  'Druid Hills',
  'Iola',
  'Hildebran',
  'Chisago City',
  'Union Gap',
  'Cartwright',
  'Gates',
  'Eureka Springs',
  'Kitsap Lake',
  'Union Beach',
  'Melville',
  'Arden Hills',
  'Rio Communities',
  'Brecksville',
  'Grand Ledge',
  'Wallis',
  'Duncansville',
  'Nellis Afb',
  'Saint Ignatius',
  'Foster',
  'East Bethel',
  'Camden Wyoming',
  'Rocky Ford',
  'Chesapeake City',
  'Lisman',
  'Baconton',
  'Merom',
  'South Abington Township',
  'Royal City',
  'Basile',
  'Irwinton',
  'Brandy Station',
  'Garrettsville',
  'Nauvoo',
  'Ridge Farm',
  'Londonderry',
  'Brooker',
  'Mountain City',
  'Lacy-Lakeview',
  'Lake Barrington',
  'Dallastown',
  'Demorest',
  'Flagler Beach',
  'Fennimore',
  'New Waverly',
  'Cookville',
  'Walled Lake',
  'Nectar',
  'Ancona',
  'South Prince George',
  'Raiford',
  'Singers Glen',
  'Laceyville',
  'Cannelton',
  'Saint Peter',
  'Eads',
  'Burnside',
  'Gratiot',
  'Los Ranchos de Albuquerque',
  'Okatie',
  'Mayo',
  'Bradyville',
  'Fraziers Bottom',
  'Dandridge',
  'Ovilla',
  'Minerva',
  'Bakersville',
  'Fort Gaines',
  'Olivia',
  'Tishomingo',
  'Clayville',
  'Ignacio',
  'Calistoga',
  'McSherrystown',
  'Samsula',
  'Port Republic',
  'White Castle',
  'Hi-Nella',
  'Pierpont',
  'Richland Center',
  'Zephyr',
  'Oakwood Hills',
  'El Calaboz',
  'Brittany Farms',
  'Shandaken',
  'Huron',
  'Audubon',
  'Alabama 35111',
  'Aguadilla',
  'Yalesville',
  'Orchard Lake',
  'Science Hill',
  'Meadowview',
  'Haleiwa',
  'Jacinto City',
  'Lockney',
  'Glenns Ferry',
  'Stratton',
  'Hegins',
  'Wilbraham',
  'La Cañada Flintridge',
  'Susan',
  'Huntland',
  'Normangee',
  'Waskom',
  'Great Neck',
  'Salado',
  'Mundelein',
  'Iron Station',
  'New Harmony',
  'Kiln',
  'Norway',
  'Webster County',
  'Mapleton Depot',
  'Shavano Park',
  'Corbett',
  'Tega Cay',
  'Dellwood',
  'Hughson',
  'Whetstone',
  'Manilla',
  'Grover Beach',
  'North Muskegon',
  'Jasonville',
  'Chancellor',
  'Westmorland',
  'Crescent',
  'Farrell',
  'Spotswood',
  'Cottonwood Shores',
  'Moravian Falls',
  'New Zion',
  'North Irwin',
  'North Andover',
  'Taos',
  'Green Oaks',
  'Hustisford',
  'Ackley',
  'Staley',
  'Chaffee',
  'Howland',
  'Waite Park',
  'Edogawa-Ku',
  'Filadelfia',
  'Chadron',
  'Harmony',
  'Wingo',
  'Baileyville',
  'Stewardson',
  'Doniphan',
  'Dorris',
  'Alta',
  'Independence charter Township',
  'Dale City',
  'Grand Coulee',
  'Hughes',
  'Ranson',
  'Hurdle Mills',
  'New Plymouth',
  'Lowry City',
  'North Charleroi',
  'Goodman',
  'Hobgood',
  'La Cygne',
  'Pocomoke City',
  'Blum',
  'LaSalle',
  'Lanexa',
  'Herington',
  'UT 84761',
  'Delphi',
  'Queen City',
  'Osceola Mills',
  'Spurlockville',
  'Earle',
  'Carrolltown',
  'Huntingburg',
  'Molalla',
  'Ranger',
  'Saunemin',
  'Underwood',
  'Laurel Mountain Borough',
  'Raynham',
  'Larned',
  'Bangs',
  'Celeste',
  'Stonewood',
  'Baraga',
  'Charleroi',
  'TX 76567',
  'Rainier',
  'Lakeside Park',
  'Campbellsburg',
  'Breeden',
  'Lovell',
  'Wausaukee',
  'East Wareham',
  'South Solon',
  'Anahuac',
  'Coker',
  'Mayodan',
  'St. Helena',
  'Sauk Centre',
  'Bernie',
  'Valhalla',
  'Lyndon',
  'Ganado',
  'Andice',
  'Ledyard',
  'Delbarton',
  'Rural Retreat',
  'Bearden',
  'Cedar Island',
  'Pinetown',
  'Redington Shores',
  'Oak Island',
  'Cornwall Bridge',
  'Double Springs',
  'Killian',
  'Ocean',
  'Swepsonville',
  'Rushford',
  'Mineral Point',
  'South Monrovia',
  'Campbellton',
  'DePue',
  'Ruckersville',
  'Hudgins',
  'NY 12204',
  'Oologah',
  'Smithers',
  'Bohemia',
  'Delran',
  'Grethel',
  'Gatlinburg',
  'Walhonding',
  'La Coste',
  'Oceano',
  'Espanola',
  '510 1/2',
  'Wernersville',
  'Whitewater',
  'Owego',
  'Hunters Creek Village',
  'Lake Geneva',
  'Flippin',
  'Jamesburg',
  'East Lansdowne',
  'Iron River',
  'Church Road',
  'Deadwood',
  'Gasburg',
  'Lincroft',
  'Blandford',
  'Silt',
  'Fort Sill',
  'Timberville',
  'Childress',
  'Kremlin',
  'Penitas',
  'McKenzie',
  'Parksley',
  'Marion Junction',
  'Landrum',
  'Clarks Hill',
  'Yermo',
  'Dresser',
  'Jane',
  'Rivesville',
  'Wartrace',
  'Sackets Harbor',
  'Polk',
  'Honey Brook',
  'Stewartsville',
  'Connell',
  'Belvedere',
  'Bogue',
  'Cable',
  'Brawley',
  'Blanchester',
  'Cross Plains',
  'Fawn Grove',
  'Ariel',
  'Manorhaven',
  'Mount Shasta',
  'Crownpoint',
  'Glidden',
  'Ogdensburg',
  'Belfast',
  'Momence Township',
  'Wray',
  'Fairdale',
  'Truth or Consequences',
  'Bernalillo',
  'Skipperville',
  'East Elmhurst',
  'Lipan',
  'Madera Ranchos',
  'Malaga',
  'Eagle Rock',
  'Gagetown',
  'Bouse',
  'Stewart Manor',
  'Brigantine',
  'Dupo',
  'Emigrant',
  'Cross Junction',
  'Elk Point',
  'Edgarton',
  'St Clair Shores',
  'Worley',
  'Boscawen',
  'Orfordville',
  'Valley View',
  'Maben',
  'Oakmont',
  'Kennard',
  'Lake Villa',
  'Dennis Port',
  'Keeling',
  'Hector',
  'Harts',
  'Queenstown',
  'Cotter',
  'Millers Creek',
  'Holtville',
  'Rodney',
  'Beaver Meadows',
  'Kathryn',
  'Bond',
  'Womelsdorf',
  'Gaines',
  'Dairy',
  'Moncure',
  'Seward',
  'Haymarket',
  'Killingworth',
  'Roseto',
  'Rock City',
  'Lincolnshire',
  'Whitewood',
  'New Brockton',
  'Shelby Charter Twp',
  'White Water',
  'Roxbury',
  'Tujunga',
  'Fowler',
  'Chester Heights',
  'Vassar',
  'Foxworth',
  'East Greenbush',
  'Tow',
  'Mississippi 38901',
  'Kelford',
  'Round Top',
  'Esperance',
  'Shoals',
  'Heidrick',
  'AZ 85365',
  'Belhaven',
  'Cerulean',
  'Candia',
  'Wabasha',
  '800 Leawood Dr',
  'Gridley',
  'Rose Hill',
  'St. George',
  'Tamaroa',
  'West Sand Lake',
  'Fruitvale',
  'Fort Davis',
  'Carroll Valley',
  '1915 Richmond Rd',
  'Mullica Hill',
  'Noel',
  'Jarratt',
  'St Anne',
  'Annandale On Hudson',
  'Lawson',
  'Paoli',
  'Montesano',
  'Blanchardville',
  'Arvonia',
  'Trona',
  'Honor',
  'Days Creek',
  'Kirbyville',
  'Fryeburg',
  'Caret',
  'Shinnston',
  'St. Pete Beach',
  'Sidon',
  'South Jacksonville',
  'Pagosa Springs',
  'Newbury Park',
  'AZ 86515',
  'Northbridge',
  'Stone Park',
  'Killbuck',
  'Shickshinny',
  'Mokelumne Hill',
  'Fruitport Charter Twp',
  'Truesdale',
  'Pawnee City',
  'Gosport',
  'Mauk',
  'Barnhart',
  'Mecca',
  'Upper Chichester',
  'Ellisville',
  'Roaring River',
  'Whitestown',
  'Foreman',
  'Marienville',
  'Mullan',
  'Ritzville',
  'Wirtz',
  'Frametown',
  'Royal',
  'Idaho City',
  'Terrebonne',
  'Santa Teresa',
  'Snelling',
  '?Ewa Villages',
  'Renova',
  'Round Lake Park',
  'Beggs',
  'Hondo',
  'Bridgewater Township',
  'Clendenin',
  'Roeland Park',
  'Elfrida',
  'Sullivan City',
  'Hope Valley',
  '9066 Silver Maple Ct',
  'Herscher',
  'Fort McDowell',
  'Cumby',
  'Lineville',
  'Jal',
  'California 92308',
  'Redbush',
  'Utah 84074',
  'Schuylerville',
  'West Long Branch',
  'Parkston',
  'Heltonville',
  'Conowingo',
  'Prather',
  'Lonsdale',
  'Port Matilda',
  'Mayflower',
  'Boyds',
  'Kayenta',
  'Brownton',
  'Nedrow',
  'Pierceton',
  'May',
  'Stringer',
  'Mickleton',
  'South Dos Palos',
  'Jacksonport',
  'Clarksville City',
  'Wickett',
  'Fountain Green',
  'Bunker Hill Village',
  'Usaf Academy',
  'Fort Dix',
  'Georgiana',
  'Kennerdell',
  'West Hurley',
  'Clarinda',
  'Tiptonville',
  'Keota',
  'Jonestown',
  'West Falls',
  'Gibraltar',
  'Meraux',
  'Musella',
  'Lighthouse Point',
  'Zanesfield',
  'DuBois',
  'Angus',
  'Cissna Park',
  'Keyes',
  'Vicenza',
  'Okinawa-Shi',
  'Moro',
  'Sheppard AFB',
  'Sierra Madre',
  'Suring',
  'Beaver Springs',
  'Hockessin',
  'Del Rey',
  'Eagle Creek',
  'West Hanover Township',
  'Eleele',
  'Gibsonburg',
  'Simonton',
  'Weldon',
  'Blawnox',
  'Fries',
  'Misenheimer',
  'Taylor Mill',
  'Coleraine',
  'Hackberry',
  'Carmel Hamlet',
  'Geistown',
  'Bliss',
  'Ponte Vedra',
  'Vado',
  'Stony Brook',
  'Tatum',
  'West Kittanning',
  'Emerado',
  'Laflin',
  'New Bremen',
  'Weems',
  'Rollingstone',
  'Carlin',
  'Huachuca City',
  'Princeton Junction',
  'GA 31040',
  'Indian Rocks Beach',
  'Brightwood',
  'Scarbro',
  'Gloucester Point',
  'Foxboro',
  'Wiesbaden',
  'Davisboro',
  'Packwood',
  'Pella',
  'Paulden',
  'Jones Creek',
  'Carlock',
  'Manly',
  'La Grange Park',
  'Mildred',
  'Bergen',
  'East Atlantic Beach',
  'Heavener',
  'Orefield',
  'Grays River',
  'Perrinton',
  'Shamrock',
  'Cressona',
  'Wilkinson',
  'Belington',
  'Buzzards Bay',
  'Upperco',
  'Cowden',
  'Straughn',
  'Twin Lake',
  'Townville',
  'Thornfield',
  'Collinwood',
  'Denair',
  'Goode',
  'Newmarket',
  'Calais',
  'Labadieville',
  'Eveleth',
  'War',
  'Assonet',
  'Quaker City',
  'Amigo',
  'Freeman',
  'Winnebago',
  'Canaan Township',
  'Sondheimer',
  'Mahwah',
  'Walbridge',
  'Hackett',
  'Silver City',
  'San Joaquin',
  'Malakoff',
  'Indian Harbour Beach',
  'Mt Clemens',
  'Merritt',
  'Clarendon Hills',
  'Potts Camp',
  'Royal Kunia',
  'Oklahoma 74525',
  'Sneads',
  'Sturtevant',
  'Cranbury',
  'Waupaca',
  'Hollis',
  'College Grove',
  'Piggott',
  'Port Penn',
  'Sumas',
  'Newmanstown',
  'Red Bud',
  'Lulu',
  'Bronston',
  'Gamaliel',
  'Solvay',
  'Ethridge',
  'Covesville',
  'Harrah',
  'Minnie',
  'Constantine',
  'Warrensville',
  'Nova',
  'Rehoboth Beach',
  'Briaroaks',
  'Trexlertown',
  'Wilmington Manor',
  'Kettleman City',
  'Lorida',
  'Otho',
  'Bush',
  'Zenda',
  'Brantley',
  'Alapaha',
  'Swisher',
  'Monongahela',
  'Volant',
  'Hickory Corners',
  'Ticonderoga',
  'Cloquet',
  'Laporte',
  'Fort Morgan',
  'New Gloucester',
  'Alabama 35954',
  'Moville',
  'Campton Hills',
  'North Grafton',
  'Seth',
  'Rio Hondo',
  'Delaplane',
  'Adair Village',
  'Southlake',
  'Webster City',
  'Cave Springs',
  'Moss Landing',
  'Carey',
  'Linesville',
  'Ney',
  'Pink',
  'TX 78748',
  'Friendsville',
  'Watseka',
  'Avonmore',
  'Kawkawlin',
  'Agoura Hills',
  'Lafe',
  'Preble',
  'Gibbstown',
  'Laceys Spring',
  'Millry',
  'Oklahoma 74523',
  'Parlier',
  'West Farmington',
  'Linfield',
  'Strongstown',
  'Robbinsville',
  'Argyle',
  'Holmes',
  'Burr Ridge',
  'Norridgewock',
  'Westfir',
  'Calabasas',
  'River Bend',
  'Spanishburg',
  'Homosassa Springs',
  'Van Buren Charter Township',
  'New Hyde Park',
  'Pinetta',
  'Nokesville',
  'Mont Vernon',
  'Pleasant Hope',
  'Bechtelsville',
  'Congers',
  'Meigs',
  'Clatskanie',
  'Garnet Valley',
  'Pine',
  'Lihue',
  'Southbury',
  'Georgetown Twp',
  'Dundee Township',
  'Groveton',
  'Lutcher',
  'Mantachie',
  'Bridport',
  'Fair Grove',
  'Woodworth',
  'Statenville',
  '904 W Riverside Ave',
  'Fayette City',
  'Wolcottville',
  'Ferriday',
  'Anacoco',
  'Harrisville',
  'Weber City',
  'Hobson',
  'Cozad',
  'Rothschild',
  'Seven Points',
  'Grinnell',
  'Luna Pier',
  'Kiel',
  'Concordia',
  'St Peter',
  'East Millsboro',
  'Woodstown',
  'Florida 32081',
  'Kewanna',
  'Viroqua',
  'Leetonia',
  'Larksville',
  'Bowlegs',
  'Percy',
  'Pingree',
  'Berlin Heights',
  'Cosby',
  'Sheldon',
  'Lakewood Club',
  'Simsboro',
  'Lake Isabella',
  'Mira Loma',
  'Otisco',
  'Uniopolis',
  'Lyford',
  'Wimberley',
  'Clinton Corners',
  'Willington',
  'Bruceville',
  'Rison',
  'Sinton',
  'Texas 79705',
  'Lacona',
  'Seven Valleys',
  'Davis City',
  'Rock',
  'Hurleyville',
  'Falkner',
  'Dawson Springs',
  'Zwolle',
  'Kingsbury',
  'Danielson',
  '838 N El Molino Ave',
  'Henning',
  'Glade Spring',
  'Park Rapids',
  'Manitou Beach',
  'Bourg',
  'Perkinsville',
  '8669 Bruton Parish Ct',
  'Ohio City',
  'Young Harris',
  'Appling',
  'Point Marion',
  'Basking Ridge',
  '1405 SE 1st St',
  'Norwood Young America',
  'Champion',
  'St Paul Park',
  'Narrows',
  'St Landry',
  'Sauk City',
  'Rock Creek',
  'Port Hadlock-Irondale',
  'Newburyport',
  'Anawalt',
  'St Bernard',
  'El Prado',
  '2219 Hwy 55',
  'Allons',
  'Conestoga',
  'Cool',
  'Halls',
  'Doerun',
  'Eminence',
  'Village Of Indian Springs',
  'Taftville',
  'Okeana',
  'Loganton',
  'Pawhuska',
  'Moberly',
  'Richland City',
  'Llano',
  'Tabernash',
  'Nora Springs',
  'Duck Hill',
  'Steedman',
  'Kentucky 41086',
  'Huntertown',
  'Lake Crystal',
  'Sutter Creek',
  'Texas 75754',
  'Felicity',
  'Whittington',
  'Kersey',
  'Blasdell',
  'Thurston',
  'Rose',
  'Empire',
  'Mars',
  'Trevose',
  'North Syracuse',
  'Verdi',
  'Harwood Heights',
  'Hawthorn Woods',
  'North Street',
  'Glen Rose',
  'Bitely',
  'Henagar',
  'Twin City',
  'Ruidoso',
  'McDonald',
  'Rugby',
  'Richfield Springs',
  'Bonne Terre',
  'Rockbridge',
  'Harpursville',
  'Rossford',
  'Middleborough',
  'Middlesboro',
  'Briarcliff Manor',
  'Calvert',
  'Olmos Park',
  'Town and Country',
  'Baroda',
  'Blue Hill',
  'Northwoods',
  'White Sulphur Springs',
  'Orion Charter Township',
  'Palos Park',
  'Society Hill',
  '2550 Bainbridge Hwy',
  'Glenn',
  'Purgitsville',
  'Elkhart Lake',
  'Narberth',
  'Lovettsville',
  'Dededo',
  'Wiscasset',
  'Leland Grove',
  'Old Field',
  'Hustonville',
  'Northumberland',
  'Union Township',
  'Christiansted',
  'Manchaca',
  'Meshoppen',
  'Little Chute',
  'Westmoreland City',
  'Woolstock',
  'Presque Isle',
  'Egan',
  'Cedar Knolls',
  'Rib Lake',
  'Rich Square',
  'Turbotville',
  'Kaanapali',
  'Toano',
  'Cyclone',
  'Mora',
  'Poca',
  'South Hutchinson',
  'Waseca',
  'Texas 75169',
  'Ione',
  'Pool',
  'Brooks',
  'Gilberts',
  'Chandlersville',
  'Purdon',
  'North Carolina 28073',
  'South Williamsport',
  'Rootstown',
  'Bath Twp',
  'Ponder',
  'Keytesville',
  'Willsboro',
  'Lore City',
  'Texas 77354',
  'Three Springs',
  'Adin',
  'Lacy Lakeview',
  'Barataria',
  'Conneautville',
  'West Bloomfield Township',
  'Coward',
  'Jobstown',
  'Greenbackville',
  'Shippingport',
  'Monona',
  'Philmont',
  'Leighton',
  'Collegedale',
  'Rhodhiss',
  'Sun River Terrace',
  'Fieldsboro',
  'Lake Bryan',
  'Cherry Hills Village',
  'Medford Lakes',
  'Waipio Acres',
  'South Grafton',
  'Pocono Lake',
  'Elmwood',
  'Trafalgar',
  'Pine Grove',
  'Greater Northdale',
  'Davidson',
  'Port Crane',
  'Purcell',
  'Hulbert',
  'Uhland',
  'Gladys',
  'Pleasant Hills',
  'Casar',
  'Strong',
  'Orrington',
  'Talihina',
  'New Columbus',
  'Grosse Pointe',
  'Tupper Lake',
  'Gallion',
  'Hartman',
  'Berrien Springs',
  'North Franklin',
  'Mountain Rest',
  'Parksville',
  'Kaneohe Station',
  'Nunda',
  'Frontenac',
  'Caruthersville',
  'Moose River',
  'La Luz',
  'Taylortown',
  'Boykins',
  'Wagram',
  'Moxee',
  '????????',
  'Riviera',
  'Brodnax',
  'Pine Lawn',
  'Rossburg',
  'Du Bois',
  'Shelbiana',
  'Lott',
  'Bon Air',
  'White Salmon',
  'Emory',
  'Notasulga',
  'McClellan',
  'Los Alamitos',
  'Debord',
  'Estancia',
  'Corcoran',
  'Sherrill',
  'Louise',
  'Potterville',
  'Sinclair',
  'Hanam??ulu',
  'Owenton',
  'Premont',
  'Lake Luzerne',
  'Cedar Crest',
  'Ore City',
  'Woodsfield',
  'Terrytown',
  'International Falls',
  'Valley Springs',
  'Mt Healthy',
  'Sterlington',
  'Frazeysburg',
  'Vineyard Haven',
  'Pearisburg',
  'Makaha Valley',
  'Gunnison',
  'Sloan',
  'Cloverport',
  'Negaunee',
  'Moores Hill',
  'Roseboro',
  'Broadalbin',
  'Bosque Farms',
  'Bigelow',
  'Aroda',
  'Ford Heights',
  '????-??????-???',
  'Casa',
  'Saint Johnsbury',
  'KC Estates',
  'Mahtowa',
  'Sunbright',
  'Toluca Lake',
  'Chappaqua',
  'Surrey',
  'Grasonville',
  'Italy',
  'Blairs Mills',
  'Letohatchee',
  'Stone Creek',
  'Bruning',
  'Wofford Heights',
  'Mercersburg',
  'Bowler',
  'Cobden',
  'Meansville',
  'East Pittsburgh',
  'Aspen Hill',
  'Reeds Spring',
  'Salix',
  'Whitaker',
  'Langston',
  'Glen Alpine',
  'South Dennis',
  'Washington Depot',
  'Bruce',
  'Slaughter',
  'Roan Mountain',
  'Glendon',
  'Kaiser',
  'Given',
  'La Crescent',
  'Hankamer',
  'Moonachie',
  '11982 Coverstone Hill Cir',
  'Everson',
  'Castleton-On-Hudson',
  'Glenbrook',
  'Lakemont',
  'TN 37387',
  'Six Mile',
  'Mehoopany',
  'Parkhill',
  'Ligonier',
  'South Hackensack',
  'Collinston',
  'Wiley Ford',
  'Ossian',
  'Westhoff',
  'Dowling',
  'East Brookfield',
  'Oklahoma 74338',
  'North Hudson',
  'Holyrood',
  'Shady Dale',
  'Drake',
  'Mount Penn',
  'North Pekin',
  'Norris',
  'Shipman',
  'Mosca',
  'Decorah',
  'Mokane',
  'Shoreacres',
  'North Scituate',
  'Mine Hill',
  'Chiloquin',
  'Mohawk',
  'Warroad',
  'Kell',
  'Clymer',
  'Flourtown',
  'Cope',
  'Worthington Springs',
  'Mountain Pine',
  'Altheimer',
  'Gambrills',
  'Dunkard Township',
  'Stansbury Park',
  'Westerlo',
  'Laton',
  'West Bountiful',
  'Sherrills Ford',
  'Gardners',
  'Walcott',
  'Sellersville',
  'Shady Side',
  'Inyokern',
  'Genoa City',
  'Interlochen',
  'West Hills',
  'McDade',
  'National Park',
  'Lake Benton',
  'Schofield Barracks',
  'De Graff',
  'Nash',
  'Manitou',
  'Gilbertsville',
  'Diamondhead',
  'Old River Winfree',
  'Haslett',
  'Foxhome',
  'Rolling Prairie',
  'Saint Hedwig',
  'Beale Afb',
  'Red Hill',
  'Crestview Hills',
  'Verdigris',
  'Wakarusa',
  'Claude',
  'Nibley',
  'Cedaredge',
  'Hubertus',
  'Rayle',
  'Alma Center',
  'Wanchese',
  'Mount Hermon',
  'Blachly',
  'Bally',
  'Mifflinburg',
  'Jersey Shore',
  'Mertzon',
  'Gwinn',
  'Van Meter',
  'West Hazleton',
  'Vaiden',
  'Bruce Twp',
  'Gas City',
  'OH 43717',
  'Oklahoma 73437',
  'Hawaiian Paradise Park',
  'Rockaway Beach',
  '2000 Business Loop 70 W',
  'Ailey',
  'Zilwaukee',
  'Crisfield',
  'Novinger',
  'Albia',
  'Loudonville',
  'Panther',
  'Hawkins',
  'Booker',
  'Boothwyn',
  'Robbinston',
  'Sebree',
  'Gramercy',
  'Pelican',
  'Mississippi 39335',
  'WI 53916',
  'Lily',
  'Becker',
  'Glen Lyon',
  'Dillsboro',
  'Lamoni',
  'Valley Village',
  'Seven Fields',
  'Tye',
  'Ord',
  'Calumet Twp',
  'Minersville',
  'Chauncey',
  'Coffeyville',
  'Biglerville',
  'Ceylon',
  'Maple Plain',
  'Bee Spring',
  'New Deal',
  'Snover',
  'Brodhead',
  'Moriches',
  'East Greenville',
  'Richardsville',
  'Gilson',
  'Algonac',
  'Godeffroy',
  'Volcano',
  'Clark Mills',
  'Kuttawa',
  'Ghent',
  'Pamplin',
  'Montville',
  'South Congaree',
  'Kechi',
  'Oak Level',
  'Only',
  'Littlestown',
  'Donaldsonville',
  'Suitland-Silver Hill',
  'Placitas',
  'Pea Ridge',
  'Bay Head',
  'Horse Shoe',
  'Hindsville',
  'St Louis Park',
  'Milo',
  'Kemmerer',
  'Holly Pond',
  'Pitman',
  'Ste. Marie',
  'Schoharie',
  'Rydal',
  'Reddick',
  'Sylvan Beach',
  'Aniak',
  'Utqiagvik',
  'Dawes',
  'Nine Mile Falls',
  'Kildare',
  'Champlain',
  'Repton',
  'Nelson',
  'Magee',
  'Niantic',
  'Bryant Pond',
  'Cobleskill',
  'Swanzey',
  'Hardaway',
  'Calico Rock',
  'Zolfo Springs',
  'Eagle River',
  'Island',
  'Sebastopol',
  'KY 40129',
  'Shipshewana',
  'Etoile',
  'Alabama 35966',
  'Matador',
  'Cement',
  'Ponce De Leon',
  'Catawissa',
  'DeMotte',
  'North Manchester',
  'Knightstown',
  'Siletz',
  '175 Mill Pond Rd',
  'Point Blank',
  'Mosinee',
  'Summerton',
  'Ashaway',
  'Foreston',
  'Wilmot',
  'La Rue',
  'North Randall',
  'Mountain Grove',
  'South St Paul',
  'Engelhard',
  'Potlatch',
  'Bullard',
  'San Martin',
  'Sledge',
  'Vossburg',
  'Dennis',
  'Ponce Inlet',
  'Worthington Hills',
  'Virginia Gardens',
  'Crespin',
  'Tolono',
  'Corinne',
  'Lowville',
  'Aynor',
  'Buena Vista Township',
  'East Sparta',
  'Plantsville',
  'Iaeger',
  'Angie',
  'Clarksboro',
  'Wappapello',
  'Friendship',
  'Norman Park',
  'Eastern',
  'King of Prussia',
  'Slater',
  'Herminie',
  'Minerva Park',
  'Presto',
  'Mont Alto',
  'Farmer City',
  'Succasunna',
  'Cypremort Point',
  'Honea Path',
  'Brunson',
  'Depauw',
  'Ridge Manor',
  'Pope',
  'Conway Springs',
  'Boron',
  'Cassoday',
  'Texas 78934',
  'Saint Francis',
  'Evensville',
  'China Spring',
  'Marvell',
  'Melvern',
  'Gibbon',
  'Kinderhook',
  'Algoma',
  'Fountaintown',
  'Monsey',
  'Nunnelly',
  'North Billerica',
  'Elmsford',
  'LaGrangeville',
  'Orchard Grass Hills',
  'Yellow Springs',
  'Kemah',
  'Seaboard',
  'Lucerne Valley',
  '?? ?',
  'Itta Bena',
  'New Point',
  'Paintsville',
  'Landenberg',
  'Grosse Pointe Park',
  'Townley',
  'Irvona',
  'Ford City',
  'Aviston',
  'Harwood',
  'Theresa',
  'South Mountain',
  'Paragon',
  'Sunset Hills',
  'Tira',
  'Joanna',
  'Liscomb',
  'Maidens',
  'Finger',
  'Waiehu',
  'Lake View',
  'Aydlett',
  'Getzville',
  'South Wilmington',
  'Mc Henry',
  'Crouse',
  'Huntington Bay',
  'Rudy',
  'Grady',
  'Ridge Spring',
  'Hanna',
  'Bellona',
  'Yountville',
  'Lake Preston',
  'Kirkersville',
  'Wautoma',
  'Moran',
  'Natural Bridge Station',
  'Willamina',
  'Cullen',
  'Whiteface',
  'Tieton',
  'Yantis',
  'Kibler',
  'Robinsonville',
  'Timbercreek Canyon',
  'Linn Creek',
  'Elk Park',
  'Lancing',
  'Boothbay Harbor',
  'West Wareham',
  'Ralph',
  'Peninsula',
  'Dragoon',
  'East Nassau',
  'Saranac',
  'Lanesborough',
  'La Joya',
  'Cresskill',
  'Pelham Manor',
  'Iota',
  'Chubbuck',
  'St. Cloud',
  'Pritchett',
  'Tiger',
  'Rolling Fork',
  'Comer',
  'Grawn',
  'South Coffeyville',
  'Corbin City',
  'West Middlesex',
  'Purvis',
  'Jacksons Gap',
  'Port Saint Joe',
  'Deforest',
  'Jenkins',
  'Deepwater',
  'Kahuku',
  'Pardeeville',
  'Grosse Ile Township',
  'Mather',
  'Tabor',
  'Marmet',
  'McKean',
  'Garysburg',
  'Plum Grove',
  'Manalapan Township',
  'Munday',
  'Eutaw',
  'Pickrell',
  'Fairchilds',
  'Darmstadt',
  'Lake Odessa',
  'Beech Mountain',
  'Mount Nebo',
  'Baltic',
  'Lafourche',
  'Gerald',
  'Center Hill',
  'Neville',
  'Emporium',
  'Speer',
  'Wisner',
  'Moss Bluff',
  'Usk',
  'Delafield',
  'Ocean Isle Beach',
  'Pequot Lakes',
  'Ham Lake',
  'Stevenson',
  'Staatsburg',
  'Dongola',
  'Greenevers',
  'Pewee Valley',
  'Tea',
  'Kirksey',
  'Gillsville',
  'Elk Rapids',
  'Bunn',
  'Meadow',
  'Piperton',
  'Milesburg',
  'Tolland',
  'Bucksport',
  'Goodlow',
  'Le Mars',
  'Green Lane',
  'West Dundee',
  'Glasford',
  'Haddonfield',
  'Van Alstyne',
  'Millburn',
  'Moody Afb',
  'Calhan',
  'Clyman',
  'Wyomissing',
  'Salemburg',
  'Bray',
  'Merkel',
  'Gassaway',
  'Sanbornton',
  'Mayslick',
  'Viola',
  'Watkins Glen',
  'Weddington',
  'Swan Lake',
  'Dahlgren',
  'Belleair',
  'Axson',
  '???, ???',
  'Armbrust',
  'Tiburon',
  'Arthur City',
  'Hayneville',
  'East Bernstadt',
  'Oakvale',
  'Valles Mines',
  'Germansville',
  'Senecaville',
  'Mardela Springs',
  'Cisco',
  'Tabiona',
  'Wilbur',
  'Roxobel',
  'Minter',
  'Hazelbrook NSW 2779',
  'Saint Michael',
  'La Conner',
  'Persia',
  'Dilley',
  'Alloway',
  'Lake St. Croix Beach',
  'Peterborough',
  'Casco',
  'Alamo Heights',
  'Martindale',
  'Boones Mill',
  'Zion Crossroads',
  'Reed City',
  'East Liberty',
  'Bradley Beach',
  'Bass Harbor',
  'Hubbard Lake',
  'Larsen Bay',
  'Martville',
  'Croswell',
  'Tremont City',
  'Mt Ulla',
  'Worden',
  'Hornbeck',
  'Biscayne Park',
  'South Park Township',
  'Courtdale',
  'Coulee City',
  'Tappahannock',
  'IL 62320',
  'Volente',
  'Pilesgrove',
  'Atkinson',
  'Lake Lure',
  'Ferrisburgh',
  'Ellport',
  'Verplanck',
  'Orondo',
  'Langhorne Manor',
  'Elliottsburg',
  'Nashwauk',
  'Emsworth',
  'Meadow Lands',
  'Stryker',
  'Shawsville',
  '2012 Flagler St',
  'Arkdale',
  'Southmont',
  'Maynardville',
  'Meredosia',
  'Erieville',
  'Rusk',
  'Piney Creek',
  'Vega',
  'Minford',
  'Center Moriches',
  'Karnack',
  'Chappell',
  'Marion Station',
  'Burrillville',
  'Elk Mound',
  'Willisburg',
  'Cabazon',
  'St David',
  'Philip',
  'Rosendale',
  'Lake Village',
  'Wibaux',
  'Sharon Springs',
  'Puxico',
  'St Matthews',
  'Buffalo Gap',
  'Kanab',
  'Risingsun',
  'Highwood',
  'Langley',
  'Waupun',
  'Mettawa',
  'Streetman',
  'Naco',
  'Shingle Springs',
  'Surry',
  'Filer',
  'Tellico Plains',
  'Damariscotta',
  'Zion Grove',
  'Moab',
  'Taylors Island',
  'Palm Beach Shores',
  'Wintersville',
  'Ten Mile',
  'Commercial Point',
  'Fenwick',
  'Humble,',
  'Economy',
  'Canaan',
  'Rowley',
  'Fall City',
  'Makawao',
  'New Johnsonville',
  'Pounding Mill',
  'Ebro',
  'Sanctuary',
  'Mineral City',
  'Pansey',
  'Tomahawk',
  'New Stanton',
  'Hedrick',
  'Little Rock AFB',
  'North Cape May',
  '7518 Clemson Ct',
  'Cuddy',
  'Texas 77519',
  'Medical Lake',
  'Creighton',
  'Laveen',
  'Frankfurt',
  'Montereale Valcellina',
  'Yigo',
  'New Freedom',
  'Kailua-Kona',
  'Lake Waccamaw',
  'Mt Ida',
  'Kaiserslautern',
  'Kenbridge',
  'Eastchester',
  'New Fairview',
  'North Lewisburg',
  'Maury City',
  'Potrero',
  'Gate City',
  'Pandora',
  'NC 27954',
  'Brusly',
  'Ben Wheeler',
  'Chevy Chase View',
  'Matewan',
  'Mcconnellsburg',
  'CA 95827',
  'Omega',
  'Sag Harbor',
  'Pavilion Township',
  'Laguna',
  'Ennice',
  'Kendall Park',
  'Locust Hill',
  'Southern View',
  'Braxton',
  'Two Harbors',
  'San Marino',
  'Monkton',
  'Southside',
  'Mackinaw',
  'Malad City',
  'Pottersville',
  'Delanson',
  'Big Bear',
  'Lakeside Marblehead',
  'Saltsburg',
  'New Auburn',
  'Rego Park',
  'Cato',
  'Alford',
  'Snoqualmie',
  'Seal Beach',
  'Sturgeon Lake',
  'West Augusta',
  'Thorp',
  'Colgate',
  'Leesport',
  'Stoutsville',
  'Jessieville',
  'Woodstock Valley',
  'Clearmont',
  'Ladonia',
  'Hersey',
  'Fertile',
  'Lapine',
  'Des Peres',
  'North Oaks',
  'Weyers Cave',
  'West Rutland',
  'Montana 59860',
  'St Croix Falls',
  'St Stephen',
  'Acme',
  'Laketown',
  'Leith',
  'Imboden',
  'Gypsum',
  'Penn Hills',
  'Malabar',
  'CA 95305',
  'Cold Brook',
  'Honeoye Falls',
  'Leverett',
  'Edgard',
  'Fincastle',
  'He’eia',
  'Islamorada',
  'Hoodsport',
  'French Camp',
  'Gibsland',
  'San Anselmo',
  'Big Sur',
  'Emmetsburg',
  'Stromsburg',
  'Merchantville',
  'Fairmount City',
  'Little Valley',
  'Lake Providence',
  'Scotia',
  'Moose Lake',
  'Moseley',
  'WA 98855',
  'Agency',
  'Cannon Beach',
  'Magalia',
  'South Hamilton',
  'Pillager',
  'Ashcamp',
  'Hurón',
  'Barling',
  'Hopland',
  'Dubberly',
  'VA 24263',
  'Catlett',
  'Morro Bay',
  'Ingraham',
  'Kamiah',
  'Hindsboro',
  'Round Hill',
  'Leo',
  'MS 39120',
  'Gene Autry',
  'Lone Jack',
  'Oakland City',
  'Gillespie',
  'Peridot',
  'Rush City',
  'East Montpelier',
  'Peever',
  'El Dorado Springs',
  'Trujillo Alto',
  'Gold Canyon',
  'Lambert',
  'Mammoth Lakes',
  'Rehobeth',
  'Newman Lake',
  'Springdale Township',
  'Franksville',
  'Indialantic',
  'Ninnekah',
  'Upper Lake',
  'Olton',
  'Jenkins Township',
  'West Peoria',
  'Los Ranchos De Albuquerque',
  'Pauline',
  'Tuckerton',
  'Shelter Island Heights',
  'Blacksville',
  'Chepachet',
  'Rancho Viejo',
  'Hanscom AFB',
  'Mussey',
  'Ottawa Hills',
  'Normandy Park',
  'Wales',
  'Geary',
  'Scandia',
  'Lomira',
  'East York',
  'Aguadilla Pueblo',
  'Logan Township',
  'Eden Valley',
  'Mendota Heights',
  'Remsenburg',
  'Karnes City',
  'Lumpkin',
  'Imler',
  'Catlettsburg',
  'Penobscot',
  'Lucan',
  'Spring Arbor',
  'Twisp',
  'Grapeland',
  'Sayville',
  'Mesick',
  'Wilkes-Barre Township',
  'Huntly',
  'Montvale',
  'WA 98642',
  'Green Ridge',
  'Hemlock',
  'Dravosburg',
  'Suamico',
  'Sciota',
  'East Haddam',
  'Arnett',
  'Louisiana 70453',
  'Mobridge',
  'McLeansboro',
  'Air Force Academy',
  'Patriot',
  'La Verkin',
  'Fabens',
  'Yates Center',
  'Studio City',
  'Simmesport',
  'Mount Enterprise',
  'Nesquehoning',
  'Crab Orchard',
  'Whites Creek',
  'Gerry',
  'Beaver Dams',
  'Fairmont City',
  'Somerdale',
  'Cornell',
  'Bulan',
  'Waim?nalo Beach',
  'Mound',
  'Micanopy',
  'Martensdale',
  'Kirtland',
  'Fombell',
  'Perley',
  'Elko New Market',
  'Indian Hills',
  'Reed',
  'Harwich',
  'Star Valley',
  'Cooperstown',
  'Sandown',
  'Grant Town',
  'Grand Marais',
  'Plentywood',
  'New Athens',
  'Summer Shade',
  'Enigma',
  'Mount Solon',
  'Ickesburg',
  'Portia',
  'North Ogden',
  'Joint Base Pearl Harbor-Hickam',
  'Bal Harbour',
  'New Tripoli',
  'Carefree',
  'McCook',
  'Morocco',
  'Klahanie',
  'Upper Nyack',
  'Lester',
  'Mooreville',
  'Westernport',
  'Edgartown',
  'Vian',
  'Danforth',
  'Amado',
  'Tuxedo Park',
  'Parsonsfield',
  'Bonnie',
  'Strykersville',
  'Sipsey',
  'Big Bend',
  'Texas 77836',
  'Port Sulphur',
  'Pangburn',
  'Brinson',
  'Keokuk',
  'Spearsville',
  'Briceville',
  'Sharps Chapel',
  'Healdton',
  'Kendleton',
  'Grand Saline',
  'Exchange',
  'Ozona',
  'Oklahoma 74960',
  'Scotland',
  'Shell Lake',
  'Barron',
  'Newhope',
  'Moon Twp',
  'South Range',
  'Minonk',
  'Grant-Valkaria',
  'West Brownsville',
  'Alabama 35490',
  'Radiant',
  'Wister',
  'Tawas City',
  'Elnora',
  'Braithwaite',
  'Gideon',
  '261 Ryo Mountain Loop SE',
  'Emmons',
  'Medaryville',
  'New Middletown',
  'Stigler',
  'Tennyson',
  'Flatonia',
  'Cuddebackville',
  'Lookout Mountain',
  'Moira',
  'Jenkinsburg',
  'Elk Creek',
  'Heislerville',
  'Camptonville',
  'Masaryktown',
  'Eubank',
  'Sugar Valley',
  'Illinois City',
  'Una',
  'Prairie Du Sac',
  'Helenwood',
  'Millerstown',
  'Burgess',
  'Fairfield Township',
  'Postville',
  'Homeworth',
  'Maytown',
  'Lapel',
  'Bayfield',
  'Ottoville',
  'Soso',
  'North Fork',
  'Stonefort',
  'Cool Valley',
  'Cottage Hills',
  'Lascassas',
  'Kiester',
  'Stockertown',
  'Marco Island',
  'North Lima',
  'Mathias',
  'Chappells',
  'Friesland',
  'Iliff',
  'Halesite',
  'Red Mills',
  'Telephone',
  'Leeper',
  'Nichols',
  'Naylor',
  'Harper',
  'Kelly',
  'Mc Gaheysville',
  'Meadowlakes',
  'Rotterdam',
  'Leedey',
  'Wardensville',
  'Sarcoxie',
  'Oconto Falls',
  'Lloyd',
  'Westernville',
  'Lanesboro',
  'Platteville',
  'Island Park',
  'Long Lake',
  'Sabattus',
  'Pennsboro',
  'Tuolumne',
  'Osburn',
  'OH 44129',
  'Hampton Falls',
  'Nassau',
  'Suttons Bay',
  'South Yarmouth',
  'Hinesburg',
  'Sandy Ridge',
  'Gold Bar',
  'Horseshoe Lake',
  'Bridgton',
  'North Plains',
  'Woodsboro',
  'Lyon Mountain',
  'Cotati',
  'Jarreau',
  'Los Alamos',
  'Grundy Center',
  'Carbon Cliff',
  'Emmett',
  'Jenera',
  'Shreve',
  'Vincentown',
  'Picture Rocks',
  'Peculiar',
  'Morongo Valley',
  'Ashmore',
  'Little Mountain',
  'Guadalupita',
  'Maili',
  'Fort Washakie',
  'Earp',
  'Register',
  'Urbanna',
  'Trade',
  'Lake Ridge',
  'Haynesville',
  'Harrogate',
  'Cumberland Gap',
  'Lake Cormorant',
  'Fort Ann',
  'Simms',
  'North Freedom',
  'Graford',
  'Mountain Lakes',
  'Rosslyn Farms',
  'Roslyn',
  'Drain',
  'Dunnsville',
  'TX 75783',
  'Shoshone',
  'Newell',
  'Crown City',
  'Ironwood',
  'Wild Rose',
  'St. Leon',
  'Harleton',
  'Coulee Dam',
  'Reform',
  'Closter',
  'Kaska',
  'Mauston',
  'Sugarcreek',
  'Wallins Creek',
  'Walworth',
  'Mcchesneytown-Loyalhanna',
  'Haveli',
  'Glenfield',
  'River Forest',
  'South Royalton',
  'Pratt',
  'Gueydan',
  'Rosholt',
  'Rockholds',
  'Belcourt',
  'Texas 76664',
  'Galva',
  'Tahuya',
  'Tracy City',
  'Millers Tavern',
  'Gallatin Gateway',
  'Villanova',
  'Omro',
  'Idlewylde',
  'Granton',
  'Hardwick',
  'McCall',
  'Breedsville',
  'Iron Ridge',
  'Kinmundy',
  'Pitkin',
  'Sanborn',
  'Mariposa',
  'Melcroft',
  'Caliente',
  'Windom',
  'Ferrelview',
  'La Plume',
  'Elk',
  'TX 77290',
  'Lower Grand Lagoon',
  'Dixfield',
  'Texas 77328',
  'Tovey',
  'Dunn Loring',
  'Adkins',
  'AZ 86547',
  'Thaxton',
  'Flomaton',
  'NC 28570',
  'Manila',
  'Ruleville',
  'Carlton',
  'I-35E',
  'Barney',
  'Dolomite',
  'Laverne',
  'Bronwood',
  '7804 Rebel Walk Dr',
  'Camp Wood',
  'Frenchtown',
  'West Nyack',
  'Beresford',
  'Park Falls',
  'Whispering Pines',
  'Aberdeen Township',
  'WA 98909',
  'Corryton',
  'Wilber',
  'Dryfork',
  'Mc Arthur',
  'Lometa',
  'Texico',
  'Wheatfield',
  'Dunmor',
  'Point Roberts',
  'Platte Center',
  'Helmetta',
  'New Freeport',
  'Pennington',
  'Cobbtown',
  'Alger',
  'Greenwood Springs',
  'Opa Locka',
  'Miami Township',
  'East Freetown',
  'Page',
  'Mount Crawford',
  'Benton Township',
  'White Deer',
  'Trent',
  'North Hornell',
  'Whiteside',
  'Woollum',
  'Harbor Springs',
  'York Springs',
  'Beechmont',
  'Fox Island',
  'Braddock Hills',
  'Saxton',
  'Enville',
  'Sebeka',
  'Ackerman',
  'Mode',
  'Plattsburg',
  'Marston',
  'Bonners Ferry',
  'Pine Mountain',
  'Harwinton',
  'Hinkley',
  'Norwood Court',
  'Florala',
  'Hustle',
  'Onondaga',
  'Astor',
  'Roaring Brook Twp',
  'Mt Arlington',
  'Kingstown',
  'Fort Shawnee',
  'Texas 75156',
  'Belfield',
  'Bartonville',
  'Adger',
  'Baker City',
  'Mt Clare',
  'Deshler',
  'Onemo',
  'Nicholls',
  'Cumberland Center',
  'Hyden',
  'Mt Perry',
  'Van',
  'Woolwich',
  'Poulan',
  'AZ 85610',
  'Florida 32776',
  'Searsport',
  'St Helen',
  'Rillito',
  'St Helena Island',
  'Pine Bluffs',
  'Buckfield',
  'Pine City',
  'Masonville',
  'Todd',
  'Crane',
  'Frenchburg',
  'Elida',
  'Scottown',
  'Hamshire',
  'Lowellville',
  'Alberta',
  'Saint Ignace',
  'Pocono Summit',
  'Negley',
  'Norris City',
  'Taberg',
  'New Liberty',
  'Luckey',
  'Bowmansville',
  'Glorieta',
  'Ontonagon',
  'Stotesbury',
  'Onley',
  'Darrow',
  'Newhall',
  'Topping',
  'Hazlet Township',
  'Allenwood',
  '702 S 6th Ave',
  'Neon',
  'Moreauville',
  'Rochester Mills',
  'Arbuckle',
  'Rossiter',
  'Flintville',
  'Eagle Butte',
  'Canadensis',
  'Johnsonburg',
  'Saint Johnsville',
  'Lowndesville',
  'Alanson',
  'Pleasant Plains',
  'Port Deposit',
  'Glen Ullin',
  'High Bridge',
  'Ogema',
  'Wewahitchka',
  'Gallagher',
  'Wabash',
  'Fouke',
  'Park Hill',
  'Check',
  'Cream Ridge',
  'Ansonville',
  'Bondville',
  'Bowdoinham',
  'Helen',
  'Eleanor',
  'Sault Sainte Marie',
  'Port Monmouth',
  'Brant Lake',
  'Dunsmuir',
  'Willows',
  'Glenmora',
  'Medora',
  'Twin Oaks',
  'Ethelsville',
  'Lake Delton',
  'Goldonna',
  'Hobson City',
  'Gap',
  'Miller Place',
  'Reedville',
  'Forty Fort',
  'London Mills',
  'Kelsey',
  'Hartly',
  'Triadelphia',
  'Seven Lakes',
  'Lower Lake',
  'Isleton',
  'New Hampton',
  'Middlefield',
  'Beecher',
  'Boring',
  'Yamhill',
  'Aguila',
  'Catskill',
  'Eldridge',
  'South Greensburg',
  'Kittitas',
  'Jericho',
  'Caseville',
  'Robert Lee',
  'Zumbro Falls',
  'Alpha',
  'Shelburne Falls',
  'Amberg',
  'New Palestine',
  'Union Bridge',
  'Menlo',
  'Lackawaxen',
  'Brodheadsville',
  'Putney',
  'Plumerville',
  'Wevertown',
  'Smith Creek',
  'Fordland',
  'Ceredo',
  'Barnum',
  'Trappe',
  'Sloatsburg',
  'Mount Wolf',
  'Loda',
  'Juniata',
  'Cedar Rock',
  'Dameron',
  'Sodus',
  'Helena-West Helena',
  'Blossvale',
  'Makanda',
  'Roll',
  'Palm Valley',
  'McCullom Lake',
  'Falconer',
  'Altha',
  'Scroggins',
  'Dillard',
  'Newton Grove',
  'Kentucky 42724',
  'Conifer',
  'Seville',
  'Del Norte',
  'New Washington',
  'Peapack and Gladstone Borough',
  'Cheboygan',
  'Honaker',
  'Deer Creek',
  'Tollesboro',
  'Raccoon',
  'North Paramus',
  'Colliers',
  'Makaha',
  'Jack',
  'Gloverville',
  'White River Junction',
  'Peck',
  'Eddyville',
  'Berry',
  'Sunderland',
  'Oaktown',
  'Indian Village',
  'Foristell',
  'Thorsby',
  'Nowthen',
  'Allenton',
  'Fulshear',
  'Chouteau',
  'Stevens',
  'Mattawa',
  'Wapwallopen',
  'Battlement Mesa',
  'Trent Woods',
  'Randle',
  'Susquehanna',
  'Harrison Charter Township',
  'Garvin',
  'Ormoc City',
  'Molino',
  'Pattison',
  'Tibbie',
  'Chimacum',
  'Chinquapin',
  '5915 Uvalde Rd',
  'Hazel',
  'Mulga',
  'Hallock',
  'Brohman',
  'Phelps',
  'Beaverville',
  'Maquon',
  'Sun City Center',
  'Bandon',
  'Fairfield Bay',
  'Catharpin',
  'St Regis Falls',
  'Cannelburg',
  'Mt Enterprise',
  'Eddystone',
  'Ringling',
  'St. James',
  'Spring Mills',
  'Sheakleyville',
  'Lucas',
  'McLeansville',
  'Paige',
  'Pagedale',
  'Hellam',
  'Higden',
  'Jackson Center',
  'Sellers',
  'Epworth',
  'Pattersonville',
  'Rome City',
  'Amston',
  'Nevada City',
  'Shoemakersville',
  'Flat Lick',
  'Airport Drive',
  'Paint Rock',
  'Bloomery',
  'Lannon',
  'North Granby',
  'Storrs',
  'Candolim',
  '3207 Henderson Mill Rd',
  'Kettle River',
  'Metropolis',
  'Miner',
  'Chelmsford',
  '1200 Montreal Rd E',
  'Vergennes',
  'Daniels',
  'Ocean Bluff',
  'Cropseyville',
  'Brent',
  'Palm Shores',
  'Buckholts',
  'Garwood',
  'Hilbert',
  'Belleair Bluffs',
  'South Cle Elum',
  'Mifflin',
  'Aitkin',
  'North Dighton',
  'Haiku-Pauwela',
  'Saint David',
  '?????-?????',
  'Gorman',
  'MO 64150',
  'Santa Anna',
  'Lone Star',
  'Beach City',
  'Shingletown',
  'Medicine Lodge',
  'North Oxford',
  'Cool Ridge',
  'Menahga',
  'Peotone',
  'Keeseville',
  'Campbellsport',
  'Saegertown',
  'Hopkins Park',
  'Welda',
  'Nellysford',
  'Foxfield',
  'Jeromesville',
  'Bricelyn',
  'Kanona',
  'Six Mile Run',
  'Dolgeville',
  'Camp Pendleton North',
  'Munnsville',
  'Pinecrest',
  'Carmen',
  'Rawson',
  'Mountainburg',
  'Pascoag',
  'Bayard',
  'St. Thomas',
  'Lytle',
  'Buckingham',
  'Nanty-Glo',
  'Berino',
  'Eros',
  'Call',
  'Texas 79360',
  'New Ipswich',
  'Vaughan',
  'Candor',
  'FL 32207',
  'Minnetrista',
  'Britton',
  'Du Pont',
  'West Decatur',
  'Cades',
  'Souderton',
  'Harrington Park',
  'Bourne',
  'Gleneden Beach',
  'Old Lyme',
  'Buckhead',
  'Cooper',
  'Yosemite',
  'Elsmore',
  'Prophetstown',
  'Pine Lake',
  'Reevesville',
  'North Hodge',
  'Cardale',
  'Wewoka',
  'Galeton',
  'Mendon',
  'Kelayres',
  'Keystone',
  'Premium',
  'Showell',
  'Vinegar Bend',
  'Tyro',
  'Milton-Freewater',
  'Craig Beach',
  'Horatio',
  'Glen Dale',
  'Round O',
  'Riverview Park',
  'Remus',
  'Colora',
  'Harborcreek',
  'Melbourne Beach',
  'Mc Kee',
  'Nakaibito',
  'Aquasco',
  'Puryear',
  'Gower',
  'Anamosa',
  '8051 Portwood Turn',
  'Shevlin',
  'Hainesville',
  'Branch',
  'Bovina',
  'Springerville',
  '1219 Applewood Dr',
  '110 Pavilion Dr',
  'Micco',
  'Bratenahl',
  'US-80',
  'Bandera',
  'Grand Marsh',
  'Philpot',
  'Bovey',
  'Steeles Tavern',
  'Plum Branch',
  'North Clarendon',
  'Saint Michaels',
  'Cosmopolis',
  'Eaton Park',
  'MCBH',
  'Howey-in-the-Hills',
  'Miltonvale',
  'Bladen',
  'Havensville',
  'Mount Ayr',
  'Yoder',
  'Cornwall on Hudson',
  'Fieldale',
  'SC 29587',
  'East Spencer',
  'Pointblank',
  'Harrison City',
  'Weatherly',
  'Smithville Flats',
  'Hoyt',
  'Aldrich',
  'Alabama 35118',
  'Daggett',
  'Tahoma',
  'Carle Place',
  'Naranja',
  'Malinta',
  'Hampden',
  'Castile',
  'Dyess AFB',
  'Duffield',
  'Penryn',
  'Simpson',
  '2450 Little Sycamore Rd',
  'Ideal',
  'Fort Montgomery',
  'Alvaton',
  'Tinton Falls',
  'Echo',
  'Long Creek',
  'Mississippi 38804',
  'Nellis AFB',
  'Baldwin Place',
  'Esko',
  'Stillman Valley',
  'Lake Mills',
  'VA 22511',
  'Center City',
  'Brookston',
  'Great Neck Plaza',
  'South Carolina 29546',
  'David',
  '14455 E Hwy 25',
  'Conesville',
  'Belle Mead',
  'Eckert',
  'Polo',
  'Glen Rock',
  'Springbrook',
  'Angora',
  'Clintonville',
  'I-45',
  'Agua Caliente',
  'Biggs',
  'Random Lake',
  'Cross City',
  'Letart',
  'Aroma Park',
  'Barhamsville',
  'Paxton',
  'Larose',
  'Whiteman Air Force Base',
  'Big Creek',
  'Log Lane Village',
  'Frost',
  'Palermo',
  'New Knoxville',
  'West Yellowstone',
  '2800 Cerrillos Rd',
  'Pleasant Lake',
  'Wooton',
  'West Winfield',
  'United States',
  'Shippenville',
  'Bringhurst',
  'Hoonah',
  'La Blanca',
  'Roxton',
  'McGregor',
  'Texas 75551',
  'Doddridge',
  'Dike',
  'Waikoloa',
  'Venetie',
  'Mascot',
  'Zavalla',
  'Soap Lake',
  'Wildwood Crest',
  'Caryville',
  'Oaklawn',
  'Bolt',
  'Castle Dale',
  'Hermanville',
  'Arkansas 72601',
  'Epsom',
  'Vermontville',
  'Clearlake Oaks',
  'South Rockwood',
  'Simla',
  'Dorr',
  'Happy',
  'Diamond City',
  '443 N Adams St',
  'La Grulla',
  'Shady Shores',
  'Wynona',
  'Argos',
  'Villa Grove',
  'East Carondelet',
  'Flemingsburg',
  'TX 79336',
  'Greenland',
  'Muldraugh',
  'Arizona 86045',
  'Lettsworth',
  'Mc Carr',
  'Goshen Township',
  'Sarver',
  'Traskwood',
  'Hopwood',
  'Lewisberry',
  'Mandaree',
  'Bloomer',
  'Portageville',
  'Hernando Beach',
  'French Village',
  '8016 Ashland Ave',
  'Cottonport',
  'Cutchogue',
  'Quapaw',
  'Pomaria',
  'Salesville',
  'Lyle',
  'Venango',
  'Pawlet',
  'Hermosa',
  'Countryside',
  'Lake Linden',
  'North Collins',
  'Medfield',
  '1508 9th St',
  'Hymera',
  'Accord',
  'Campbell Station',
  'Lake Toxaway',
  'Zeigler',
  'Springhill',
  '294 Post Plant Rd',
  'Florida 34759',
  'Coxs Creek',
  'Hermantown',
  'White Earth',
  'Craftsbury',
  'Wymore',
  'Lanagan',
  'Mayview',
  'Point',
  'Osgood',
  'Mousie',
  'Lebo',
  'Culleoka',
  'Iuka',
  'NC 28547',
  'Geneva-on-the-Lake',
  '10 Stardust Way',
  'Brushy Fork',
  'Fallsburg',
  'Tamms',
  'Penn Yan',
  'Eglin AFB',
  'Murchison',
  'Worthville',
  'Dry Creek',
  'Oakes',
  'New Llano',
  'Cannon Afb',
  'Lampe',
  'Red Banks',
  'New Canton',
  'Covert',
  'Old Bridge Township',
  'Radisson',
  'Dennehotso',
  'Riceboro',
  'Thrall',
  'Mount Horeb',
  'Monte Sereno',
  'Cement City',
  'Armona',
  'Costa',
  'Glenwood Landing',
  'Side Lake',
  'East McKeesport',
  'Mendham',
  'Elburn',
  'Santa Nella Village',
  'Keewatin',
  'Ripplemead',
  'Ireton',
  'Sound Beach',
  'Nordheim',
  'Sainte-Julienne',
  'North Spring',
  'South Plymouth',
  'Urbancrest',
  'Dimmitt',
  'North Jackson',
  'Gibbsboro',
  'Port Byron',
  'Lonaconing',
  'Guffey',
  'Forks Twp',
  'McIntyre',
  'Somonauk',
  'Chilhowee',
  'Greenback',
  'Almena',
  'Donnelly',
  'Saint Rose',
  'Quinnesec',
  'Farwell',
  'Ellis',
  'Molena',
  'Hilltop',
  'Nabb',
  'Camp Grove',
  'Curtice',
  'Grandfield',
  'Southwest City',
  'Hineston',
  'Fanning Springs',
  'Allyn',
  'Brown City',
  'Home',
  'Chesterville',
  'Squaw Valley',
  'Rosser',
  'Shiprock',
  'Tomkins Cove',
  'Marriott-Slaterville',
  'North Sioux City',
  'Perrytown',
  'Burns Flat',
  'Reedsport',
  'Reynoldsville',
  'Vernon Center',
  'Charlevoix',
  'Ogunquit',
  'Englewood Cliffs',
  'Steelville',
  'Talbott',
  'Bryantown',
  'Clarkson',
  'Marilla',
  'Brackettville',
  'Woodbourne',
  'Chattaroy',
  'Mc Queeney',
  'Divide',
  'Sangerville',
  'Hill Afb',
  'Petersboro',
  'Hagan',
  'Lake Hughes',
  'Schnecksville',
  'Laughlin Afb',
  'Wilseyville',
  'Olyphant',
  'Titus',
  'Huddleston',
  'Green Mountain',
  'Bayou la Batre',
  'Gejayan',
  'Blauvelt',
  'Athena',
  'Big Flats',
  'Breeding',
  'Indian Land',
  'De Valls Bluff',
  'Tullytown',
  'Quartzsite',
  'Bivins',
  'South Wales',
  'Los Molinos',
  'Early Branch',
  'Au Sable Charter Twp',
  'Glenbeulah',
  'Valley Brook',
  'Alexandria Bay',
  'Dow',
  'Glenrock',
  'Stanleytown',
  'Green Brook',
  'St Joe',
  'Lacygne',
  'West Elizabeth',
  'Burrton',
  'Temperanceville',
  'Coral',
  'Maugansville',
  'O Neals',
  'Gilman',
  'Thiensville',
  'Nicollet',
  'McKinleyville',
  'Butte Falls',
  'Au Sable Forks',
  'Chestnut Mound',
  'Landover',
  'Haysi',
  'Rollins',
  'Clarks Grove',
  'Crozier',
  'Leaf River',
  'Dinosaur',
  'Hesperus',
  'Currituck',
  'Tysons',
  'Skare',
  'Warne',
  'Millis',
  'Smethport',
  'Valley Head',
  'Osage Beach',
  'TX 78801',
  'Kasota',
  'Clintondale',
  'Hennepin',
  'Olympian Village',
  'Rancho Santa Fe',
  'Fruithurst',
  '1829 N A St',
  'Beale AFB',
  'Ty Ty',
  'Burfordville',
  'Ecru',
  'Anza',
  'MT 59479',
  'Scott AFB',
  'Ellsworth AFB',
  'Emmalena',
  'Mancelona',
  'Mabscott',
  'Thelma',
  'Saint Paris',
  'Orrick',
  'Conning Towers-Nautilus Park',
  'Roosevelt Park',
  'Banner',
  'Reelsville',
  'Gerber',
  'Quebeck',
  'New Madison',
  'Texas 77389',
  'Yeagertown',
  '9513 Chatham St',
  'Ivesdale',
  'FL 32239',
  'Drummond',
  'Remsen',
  'St Simons Island',
  'South Amherst',
  '1600 Glenarm Pl',
  'Bluff Dale',
  'Logandale',
  'Black Lick',
  'Foothill Ranch',
  'Sunapee',
  'Black River',
  'Hamer',
  'Mc Kean',
  'Allerton',
  'Antwerp',
  'Brier',
  'Grand Coteau',
  'Mondovi',
  'Alburgh',
  'Hickory Grove Township',
  'Cubero',
  'Neah Bay',
  'Minor Hill',
  'Poplar Branch',
  'Santa Claus',
  'Colmar',
  'Orchard Beach',
  'Cotopaxi',
  'Barnard',
  '1900 State Hwy 299',
  'FL 32244',
  'Prunedale',
  'Burr Oak',
  'Southern Shores',
  'Hanley Hills',
  'West Manchester',
  'Bascom',
  'Dobbs Ferry',
  'North Anson',
  'San Roque',
  'Kronenwetter',
  'Dover Foxcroft',
  'West Fishkill',
  'CA 95741',
  'Hales Corners',
  'Barry',
  'Jena',
  'Highland Mills',
  'Sloansville',
  'Hoyt Lakes',
  'Jeremiah',
  'Valders',
  'Merrimac',
  'Milroy',
  'Francis E. Warren AFB',
  'Upper Chichester Township',
  'Laytonsville',
  'Blue Rock',
  'Sugar City',
  'Mount Arlington',
  'Michie',
  'Ida Grove',
  'Metolius',
  'Rollinsford',
  'Sprague River',
  'Clay Center',
  'Devonport TAS 7310',
  'Gilford',
  'Holgate',
  'Smithsburg',
  'Valmeyer',
  'Fort Ashby',
  'Dyke',
  'Toppenish',
  'Farmersburg',
  'Neillsville',
  'Counce',
  'Keymar',
  'Cornville',
  'Kansas',
  'Horseshoe Bend',
  'Basye',
  'St Johnsbury',
  'Rangely',
  'Dalworthington Gardens',
  'Jonesburg',
  'Sanibel',
  'Whiteriver',
  'Wellesley Hills',
  'Hooper',
  'Friendly',
  'North Kingsville',
  'New Beaver',
  'Macy',
  'Brierfield',
  'Bigfoot',
  'Port Hadlock',
  'Arrowhead Farms',
  'Bowerston',
  'Sawyer',
  '?????',
  'Devon',
  'Shamong',
  'Conehatta',
  'Ronda',
  'McBee',
  'Big Sky',
  'Goldston',
  'Burgoon',
  'Bell City',
  'Dingess',
  'Lupton',
  'Bottineau',
  'Whiteash',
  'Hagerman',
  'Center Ridge',
  'Ringoes',
  'Quicksburg',
  'Emden',
  'Higginsport',
  'Lakota',
  'Turnersville',
  'Mabie',
  'Morehouse',
  'Middle Township',
  'Wesley',
  'FL 32257',
  'Hagaman',
  'Shannock',
  'Lolita',
  'Gas',
  'Birchleaf',
  'Blue Diamond',
  'Chemung',
  'Sicily Island',
  'Muscadine',
  'High Shoals',
  'Quanah',
  'Table Rock',
  'Adell',
  'Latty',
  'Hubbard Township',
  'Little Suamico',
  'Nissequogue',
  'Osborn',
  'Faison',
  'Ridgedale',
  'Bethania',
  'Cave Junction',
  'West Roxbury',
  'Malta',
  'Swarthmore',
  'Crum',
  'Cypress Inn',
  'Bybee',
  'Frederic',
  'Sod',
  'Bushwood',
  'Chariton',
  'Orion',
  'Truro',
  'West Bradford Township',
  'East Dubuque',
  'Arco',
  'Wingdale',
  'Keatchie',
  'Shepherdstown',
  'Port Huron Charter Township',
  'Otter Lake',
  'Weyauwega',
  'Goldbond',
  'Avery',
  'Oley',
  'Mcveytown',
  'Bridgman',
  'Box Springs',
  'Dauphin',
  'Lapwai',
  'Florida 32083',
  'Haxtun',
  'Oakton',
  'Herald',
  'Cashmere',
  'Sutter',
  'Friedens',
  'Wahoo',
  'Sacred Heart',
  'Linville',
  'Mc Ewen',
  'Congress',
  'Smoketown',
  'Pierson',
  'Cadogan',
  'Peeples Valley',
  'Sac City',
  'Yates City',
  'Oden',
  'Camp Douglas',
  'Levan',
  'NV 89101',
  'Bear Lake',
  'Neola',
  'Cascade Locks',
  'Dola',
  'Alda',
  'East Lynn',
  'Lake Ronkonkoma',
  'Blossom',
  'Ider',
  'Anthon',
  'Lordsburg',
  'Casey',
  'Cokato',
  'Bainbridge Island',
  'Elkville',
  '1360 C H Matthies Jr',
  'Iraan',
  'Deer Trail',
  'Alton Bay',
  'Evarts',
  'Ronceverte',
  'Alabama 35089',
  '427 S Stewart St',
  'Holstein',
  'McIntosh',
  'Franklintown',
  'Oakland Gardens',
  'Robert',
  'Nakina',
  '10176 Portsmouth Rd',
  'Chain of Rocks',
  'Franklin Township',
  'Hayti',
  'Towaoc',
  'Atalissa',
  'FL 33584',
  'Felda',
  'Merrionette Park',
  'Willacoochee',
  'Oklahoma 74347',
  'Elmo',
  'Weidman',
  '????',
  'Lampasas',
  'Le Grand',
  'Chamisal',
  'Dailey',
  'Ridgetop',
  'Pixley',
  'Oak Brook',
  'Santo',
  'Arbutus',
  'Ancram',
  'North Carolina 27278',
  'Clairfield',
  'Mt Jackson',
  'La Farge',
  'Bonduel',
  'Tuckasegee',
  'Kinzers',
  'Mooresburg',
  'Walkerville',
  'Red Boiling Springs',
  'Florida 32433',
  'Moreland Township',
  '9929 Loudoun Ave',
  'North Huntingdon Township',
  'Landisville',
  'Osyka',
  'East Laurinburg',
  'Rural Ridge',
  'Ashby',
  'Cash',
  'Pecks Mill',
  'Clarkdale',
  'Prattsburgh',
  'Shohola',
  'Twin Bridges',
  'Rocky Ridge',
  'AZ 86413',
  'Lafayette Hill',
  'South Webster',
  'Belle Valley',
  'French Lick',
  'Unionville Center',
  'South Vinemont',
  'Tornado',
  'Concepcion',
  'Sasser',
  'Webster Springs',
  'Sparrows Point',
  'Myrtle Point',
  'Bon Wier',
  'Island Pond',
  'NC 28377',
  'Boscobel',
  '159 St Hebron Ct',
  'Conklin',
  'Schofield',
  'Fennville',
  'Hulmeville',
  'St Johnsville',
  'State Road',
  'Soquel',
  'Mc Leansboro',
  'Whitehouse Station',
  'Vandemere',
  'Russellton',
  'Mazomanie',
  '???????-????',
  'Dundas',
  'Dimondale',
  'Kualapuu',
  'Vestaburg',
  'Bee',
  'Little Compton',
  'Toomsuba',
  'Lecompte',
  'Mount Zion',
  'Port Trevorton',
  'Mount Angel',
  'Johnson',
  'White Heath',
  'Bowers',
  'Nanjemoy',
  'Trabuco Canyon',
  'Black',
  'Langdon',
  'Hiller',
  'Donaldson',
  'Perryopolis',
  'Wingina',
  'Grapeview',
  'Mannsville',
  'Red Lodge',
  'Rangeley',
  'Roaming Shores',
  'Jamison',
  'Rochelle Park',
  'Duck',
  'Oceanport',
  'Tamuning',
  'Sleepy Eye',
  'Urania',
  'Maywood Park',
  'Horace',
  'McRae-Helena',
  'Mc Clellanville',
  'Sodus Point',
  'King William',
  'Sankt Andrä am Zicksee',
  'Enosburg Falls',
  'Geronimo',
  'White Marsh',
  'GA 31519',
  'Croton-on-Hudson',
  'North Windham',
  'Freelandville',
  'Zionville',
  'Vina',
  'Beatty',
  'Hindman',
  'Bloomington Springs',
  'Kinloch',
  'NM 88220',
  'Tysons Corner',
  'Allenport',
  'Naschitti',
  'Centre Hall',
  'Wapato',
  'Annona',
  'Thorofare',
  'Mathiston',
  'Hypoluxo',
  'Bee Branch',
  'Palo',
  'Zabierzów',
  'Center Tuftonboro',
  'Dolphin',
  'Otis',
  'Cabin Creek',
  'Juliaetta',
  'Bradenton Beach',
  'Humphreys',
  '7589 Margate Ct',
  'Ranburne',
  'South Palm Beach',
  'Tidioute',
  'Myakka City',
  'Cygnet',
  'Wartburg',
  'Snow Shoe',
  'Juno Beach',
  'St Ignace',
  'Scipio',
  'Louin',
  'Ohio 43076',
  '6901 Trumpeter Swan Ln',
  '39 N Greenfield Dr',
  'Birdsnest',
  'North Robinson',
  'Kitty Hawk',
  'Catherine',
  'Coal Center',
  'Roxbury Township',
  'Fields Landing',
  'Swoope',
  'Parrottsville',
  'Mississippi 38920',
  'North Carolina',
  'Maquoketa',
  'Cordesville',
  'Southmayd',
  'Mears',
  'Onarga',
  'Stone Lake',
  '8600 Glen Myrtle Ave',
  'Laddonia',
  'Fall Branch',
  'Sedgwick',
  'Knotts Island',
  'Saint Bonifacius',
  'Olive Hill',
  'Bluff',
  'Ladysmith',
  'Brookside Village',
  'Walnut Hill',
  'Priest River',
  'SC 29607',
  'East Thermopolis',
  'Armstrong',
  'Sundown',
  'Putnam Valley',
  'Lost Nation',
  'Gearhart',
  'Lisbon Falls',
  'Lolo',
  'Sardis City',
  'Holmes Beach',
  'Appalachia',
  'Lost City',
  'Saddle River',
  'Fort Kent',
  'Maribel',
  'La Fargeville',
  'North Stonington',
  'Blackburn',
  'OR 97016',
  '2245 Greenridge Rd',
  'Hiawassee',
  'Line Lexington',
  'Algood',
  'Sweet Valley',
  'Medon',
  'Odanah',
  'Topton',
  'Luxemburg',
  'Dolan Springs',
  'SC 29856',
  'Guysville',
  'Pound Ridge',
  'East Springfield',
  'New Lothrop',
  'Allendale Charter Twp',
  'Yampa',
  'PA 15478',
  'Grover Hill',
  'Pine Brook',
  'Roxie',
  'Riner',
  'Lahoma',
  'Readyville',
  'Florida 32359',
  'Thayne',
  'Grand Lake',
  'Edgewater Park',
  'Niwot',
  'Kenvil',
  'Axtell',
  'Fort Leavenworth',
  'New Virginia',
  'Bradfordsville',
  'Sesser',
  'MO 65793',
  'Frenchville',
  'Joint Base Charleston',
  'Holly Grove',
  'Beckville',
  'South Weber',
  'Georgia 30093',
  'Kenwood',
  'Patoka',
  'Dorset',
  'Bagdad',
  'Sweet Water',
  'Cisne',
  'Gaylesville',
  'Mt Bethel',
  'Bellview',
  'Coalmont',
  'Rolette',
  'Lyndon Station',
  'Britt',
  'Calabash',
  'Intercession City',
  'Zoar',
  'Livonia Township',
  'Esto',
  'Fairway',
  'Arma',
  'Dalton Gardens',
  'Stuckey',
  'Glen',
  'Eagar',
  'Carmel-By-The-Sea',
  'Gassville',
  'Eastport',
  'Gladbrook',
  'Del Mar',
  'Lovilia',
  'FL 32225',
  'Geuda Springs',
  'Mt Rainier',
  'Zumbrota',
  'Crawford Township',
  'Kadena',
  'Sanbornville',
  'Oilton',
  'Riddleton',
  'Mc Call Creek',
  'Mountain Home AFB',
  'East Granby',
  'Milburn',
  'Readlyn',
  'Dellrose',
  'Dilliner',
  'Bouckville',
  'Bel-Nor',
  'Clarkson Valley',
  'Fisk',
  'Spurger',
  'Guston',
  'Landover Hills',
  'Arizona 86004',
  'Cannon Ball',
  'Fancy Gap',
  'Orofino',
  'Isle of Palms',
  'Pinckard',
  'Markle',
  'Stinnett',
  'Baudette',
  'Stronghurst',
  'Chaplin',
  'Ophiem',
  'Baird',
  'Vinalhaven',
  'Tignall',
  'Clarington',
  'Dorchester Center',
  'Blue Grass',
  'Talala',
  'TX 75763',
  'McGraw',
  'Welaka',
  'Edgemont',
  'Fair Bluff',
  'Kissee Mills',
  'NY 14048',
  'Skokomish',
  'New Germany',
  'Hillman',
  'Ubly',
  'Colerain',
  'Capron',
  'Meadowview Estates',
  'Graymoor-Devondale',
  'Duff',
  'Zirconia',
  'Munger',
  'Storm Lake',
  'Turin',
  'Cumberland City',
  'Rio Oso',
  'Moselle',
  'Fort Loramie',
  'Bokoshe',
  'South Carolina 29307',
  'Pawhuska Township',
  'Strum',
  'Warners',
  'Le Ray',
  'Acushnet',
  'Belville',
  'Zellwood',
  'Croton Falls',
  'Montgomery Center',
  'North Shore',
  'Blue Point',
  'Wesley Hills',
  'Cedarcreek',
  'Wanatah',
  'Bosque',
  'Indian Lake',
  'Canajoharie',
  'Key Biscayne',
  'Kiowa',
  'Millersport',
  'Adair',
  'Scuddy',
  'Newellton',
  'Camden on Gauley',
  'Spicer',
  'Mc Coll',
  'Whitharral',
  'Bristol Township',
  'Tunica Resorts',
  'Tecate',
  'Tafton',
  'Hornersville',
  'Mallard',
  'McCrory',
  'Marcy',
  'Hale Center',
  '8004 Leland Rd',
  'TX 76119',
  'San Felipe',
  'Nice',
  'Polvadera',
  'San Lucas',
  'East Fultonham',
  'Poquott',
  'Nyssa',
  'Ocean Pines',
  'Nekoosa',
  'Bentleyville',
  'Wathena',
  'Cheneyville',
  'Laurium',
  'Paola',
  'AR 72450',
  'Boyle',
  'Niota',
  'Keno',
  'Flinton',
  'New Miami',
  'Au Gres',
  'McCool Junction',
  'Amberley',
  'Arena',
  'Rolling Hills Estates',
  'Ronks',
  'Califon',
  'Pinedale',
  'Fork Union',
  'Eldred',
  'East Taunton',
  'Ullin',
  'Phenix',
  'Fairplay',
  'Eastview',
  'Hunlock Creek',
  'Manitowish Waters',
  'Mormon Lake',
  'Jane Lew',
  'Early',
  'Green Springs',
  'Harristown',
  'Circle',
  'Hurley',
  'Finley',
  'Mc Alpin',
  'Mangham',
  'McGehee',
  'Cadwell',
  'Sauquoit',
  'Winfield Park',
  'Mexico Beach',
  'Brightwaters',
  'Sugar Tree',
  'Port Gibson',
  'Kingsford',
  'Sublette',
  'Philo',
  'Griffithsville',
  'Wawaka',
  'South Setauket',
  'Bowlus',
  'Oklahoma 73089',
  'Pearlington',
  'Kiamesha Lake',
  'Veneta',
  'Moyie Springs',
  '10211 Jamaica Ln',
  'Lac Du Flambeau',
  'Scotts',
  'Blessing',
  'St Stephens Church',
  'Almo',
  'Warfordsburg',
  'Olin',
  'Coopertown',
  'Ector',
  'Erda',
  'Arbyrd',
  'Oak Park Heights',
  'Qulin',
  'Madeira Beach',
  'West Edmeston',
  'North Brentwood',
  'Washington 98577',
  'Phillips',
  'Wantage',
  'Runnells',
  'Rocky Top',
  'Fisher',
  'Willcox',
  'Council Hill',
  'Alberton',
  'Wampum',
  'Alabama 35640',
  'Sadler',
  'US-84',
  'Mc Caysville',
  'GA 31776',
  'Nordland',
  'Callensburg',
  'Sycamore Hills',
  'Camp Creek',
  'Bloomburg',
  'Bienville',
  'Borden',
  'Donnellson',
  'Baskin',
  'Burlison',
  'Turbeville',
  'Cecilton',
  'Double Oak',
  'Ebensburg',
  'Lorenzo',
  'Sandyville',
  'Port Barrington',
  'Christoval',
  'Gore Springs',
  'Maple Glen',
  'Ballinger',
  'Pleasant Unity',
  'Union Church',
  'North Bangor',
  'Grapeville',
  'West Charleston',
  'Talkeetna',
  'St Rose',
  'Nevada 89404',
  'Holloman AFB',
  'McColl',
  'Farragut',
  'Wekiwa Springs',
  'Bellemont',
  'Yalaha',
  'Wanblee',
  'AL 36312',
  'Natoma',
  'Pollocksville',
  'Rising City',
  'Jongno-gu',
  'Montauk',
  'Bloomville',
  'Spearman',
  'Louisiana 70775',
  'Tuckerman',
  '14511 Hamowell St',
  'Emerald Isle',
  'Leroy',
  'Squire',
  'Whitley City',
  'Portersville',
  'Nezperce',
  'Coleville',
  'Red Level',
  'Union Park',
  'Glen Aubrey',
  'Archer City',
  'Ellsinore',
  'Evening Shade',
  'Maurertown',
  'Hutsonville',
  'Gans',
  'Yatesville',
  'Quail Valley',
  'Miles',
  'TX 76401',
  'ME 04068',
  'Alcolu',
  'Bussey',
  'Due West',
  'Neche',
  'Sabinsville',
  'Leonville',
  'Quinter',
  'Goodhue',
  'Star Tannery',
  'Leeton',
  'Prairie du Sac',
  'Monclova',
  'Varney',
  'Pleasant City',
  'Harned',
  'Canadian',
  'Moravia',
  'Fithian',
  'Evant',
  'Jean Lafitte',
  'Haines',
  'Oradell',
  'Littcarr',
  'Bowersville',
  'Thurmond',
  'Grand Meadow',
  'Conyngham',
  'Kenefick',
  'Coal Grove',
  'Center Ossipee',
  'Çankaya',
  'Plummer',
  'Kempton',
  'Dayville',
  'Nichols Hills',
  'Haven',
  'Crested Butte',
  'Coeymans',
  'Mount Crested Butte',
  'New Houlka',
  'West Carthage',
  'Brookfield Township',
  'Monmouth Beach',
  'WV 26681',
  'Bahama',
  'OH 43130',
  'Kalama',
  'Pilot Mound',
  'Laguna Woods',
  'South Whitley',
  'Hyrum',
  'Brooten',
  'Fruit Heights',
  'Hickory Valley',
  'Estherwood',
  'Pine Mountain Valley',
  'Guthrie Center',
  'Tuscarora',
  'Lorman',
  'Merlin',
  'Forkland',
  'Farina',
  'Washington Park',
  'Westtown',
  'Cullom',
  'Warfield',
  'Bruceton Mills',
  'Dodson',
  'Goodson',
  'Georges Mills',
  'Sprague',
  'Georgia 31037',
  'Pedro',
  'Tillatoba',
  'JB Lewis-McChord',
  'Palatine Bridge',
  'Pellston',
  'Romance',
  'Elkland',
  'Mount Victory',
  'Upperstrasburg',
  'Hunnewell',
  'Donie',
  'Horse Branch',
  'Marmaduke',
  'Delcambre',
  'Gable',
  'Briarcliff',
  'Cabins',
  'Lueders',
  'Grand Mound',
  'Gotha',
  'Enon Valley',
  'MO 65534',
  'Brasher Falls',
  'Hiltons',
  'Yoakum',
  'Bruceville-Eddy',
  'Bar Nunn',
  'Chimayo',
  'Bedford Hills',
  'White Lake Charter Township',
  'Slater-Marietta',
  'Pleasant Mount',
  'Montgomery Township',
  'Shelburne',
  'Southwest Harbor',
  'Magnetic Springs',
  'OK 74434',
  'Texas 75480',
  'Backus',
  'Pond Creek',
  'Strabane',
  'Fairchild AFB',
  'Eland',
  'Dowell',
  'Alleyton',
  'CA 95713',
  'Lyburn',
  'Grantsburg',
  'Cranks',
  'Port Henry',
  'Arbovale',
  'Vergas',
  'South Carolina 29803',
  'Surfside',
  'Le Raysville',
  'Ford',
  'Balsam Lake',
  'PA 15322',
  'OK 73442',
  'Renfrew',
  'Wayne City',
  'Woodbranch',
  'Bent Mountain',
  'Hanston',
  'Loxahatchee Groves',
  'Magazine',
  'Bruin',
  'Sligo',
  'Haubstadt',
  'Larue',
  'Toquerville',
  'Texas 76641',
  'Sperry',
  'Frankston',
  'Dallesport',
  'Braggs',
  'Green Island',
  'Briar Creek',
  'Arapahoe',
  'Larwill',
  'South Boardman',
  'Lost Creek Township',
  'Kane',
  'Emerald',
  'Los Indios',
  'Letcher',
  'Pleasureville',
  'Mermentau',
  'Desert Center',
  'Mount Sinai',
  'Capitan',
  'Koshkonong',
  'Estelline',
  'Holland Patent',
  'Zephyr Cove',
  'Drumright',
  'Dill City',
  'Bettsville',
  'Kerby',
  'Olustee',
  'Arthur',
  'Oak Leaf',
  'Deemston',
  'Lamoine',
  'Elizaville',
  'Heber',
  'East Corinth',
  'Byrnes Mill',
  'Montandon',
  'Rindge',
  'Drayden',
  'Ashley Falls',
  'Wikiup',
  'Georgia 30453',
  'Athalia',
  'Gnadenhutten',
  '1400 Central Ave',
  'West Gardiner',
  'West Tawakoni',
  'Washington Boro',
  'Ashfield',
  'Hillburn',
  'IL 61401',
  'Orlinda',
  'Friendship Heights',
  'Sabin',
  'Turrell',
  'Lindon',
  'Dry Run',
  'Kintnersville',
  'Mount Royal',
  'Rescue',
  'Cheswold',
  'Atascocita',
  'Palmer Lake',
  'Churchill',
  'Glenmoore',
  '12430 NE Glisan St',
  'McChord AFB',
  'Short Hills',
  'St. Augusta',
  'Casstown',
  'Mt Ayr',
  'Meadowbrook',
  'Velda Village Hills',
  'Half Way',
  'Hayden Lake',
  '350 E Tasman Dr',
  'Lower Paxton Township',
  'Wall',
  'Shapleigh',
  'Stacy',
  'Oliver',
  'Westfield Center',
  'Morea',
  'Kewadin',
  'Mooreland',
  'Kenhorst',
  'Suffield',
  'Great Valley',
  'Winlock',
  'Ellicottville',
  'Oyster Bay',
  'Donovan',
  'Anmoore',
  '10854 Peachwood Dr',
  'Grahamsville',
  'Mineville',
  'South Connellsville',
  'Rancho Murieta',
  'Brisbane',
  'The Hills',
  'Center Township',
  'Bethel Acres',
  'Sherburne',
  'Equality',
  'West Sayville',
  'Chaumont',
  'River Vale',
  'Orcutt',
  'Clearview',
  'Old Monroe',
  'Bel Aire',
  'Port Carbon',
  'Convoy',
  'Kellyville',
  'Saint Louisville',
  'Saint Elmo',
  'Hamler',
  'Toddville',
  'Blue Mountain',
  'Valleyview',
  'Guilderland',
  'Berkshire',
  'Cedar Key',
  'Waddy',
  'Radnor',
  'Pequea',
  'Gracemont',
  'Nashotah',
  'Linndale',
  'Mattituck',
  'Medusa',
  'Spottsville',
  'Avenal',
  'Lake Success',
  'Thornwood',
  'West Shokan',
  'Peckville',
  'Noxapater',
  'Duxbury',
  'Captain Cook',
  'Red Creek',
  'Jeffersonton',
  'Richmond Dale',
  'Armonk',
  'West Pittsburg',
  'Dunbarton',
  'Cowley',
  'Fossil',
  'South Cairo',
  'Buffalo Junction',
  'Voca',
  'West Lawn',
  'AL 35466',
  'Laneview',
  'Bartonsville',
  'Basin',
  'OH 44112',
  'CO 80632',
  'French Settlement',
  'Lexa',
  'Monongah',
  '10310 Lomond Dr',
  'Nevada 89046',
  'Sabillasville',
  'Dunseith',
  'Wainwright',
  'Campti',
  'Knox City',
  'Rombauer',
  'Deckerville',
  'Rosman',
  'Summit Point',
  'Rixford',
  'WV 26280',
  'Glennallen',
  'Tresckow',
  'Inchelium',
  'Perryton',
  'Banner Elk',
  'Sears',
  'Cohocton',
  'Laurel Run',
  'North Java',
  'Peytona',
  'Edom',
  'Cavalier',
  'Rosburg',
  'Gowanda',
  'Sumerco',
  'Pawling',
  'Harbert',
  'North Berwick',
  'Jellico',
  'East Glacier Park',
  '2223 Bennett Ave',
  'Westhope',
  'Reidville',
  'Gibson City',
  'Mattaponi',
  '9025 Longstreet Dr',
  'Jenkinsville',
  'Elmore City',
  'Ordway',
  'Crawley',
  'Cathlamet',
  'Oil Trough',
  'Pe Ell',
  'Auxier',
  'Wellfleet',
  'Borrego Springs',
  'Goodwell',
  'Lavallette',
  'Clarks Green',
  '73 Harmony Ln',
  '3',
  'Sutherland Springs',
  'Stephens',
  'Hinkle',
  'Claflin',
  '187 Shiloh Church Ln',
  'Owaneco',
  'Subiaco',
  'TN 37217',
  'Cove City',
  'Kline',
  'Thayer',
  'Mt Wolf',
  'Katonah',
  'La Pryor',
  'Oblong',
  'Stormville',
  'Rosebud',
  'State Center',
  'MCAS Cherry Point',
  'Marcus',
  'Holiday Island',
  'Raft Swamp',
  'Heber Springs',
  'Carpendale',
  'Lake Nebagamon',
  'Naper',
  'Post Oak Bend City',
  'Sisseton',
  'Indian Point',
  'Thompsonville',
  'Holmen',
  'Alabama 36756',
  'Georgia 31308',
  'Gaylordsville',
  'Lithopolis',
  'Seaton',
  'Micro',
  'Rouseville',
  'Tavernier',
  'Calgary',
  'Eastford',
  'Wellesley',
  'Blandinsville',
  'Barlow',
  'Bingham',
  'Hobbsville',
  'Tillar',
  '530 Dusty House Rd',
  'Harris',
  'Mount Sherman',
  'Saint Georges',
  'Mackinaw City',
  'Sedley',
  'Glen Spey',
  'Pioche',
  '11',
  'Niverville',
  'Adolphus',
  'South Russell',
  'Custer Park',
  'Applegate',
  'Watchung',
  'What Cheer',
  'Kress',
  'Wagner',
  'Hastings-On-Hudson',
  'Cordell',
  'Volga',
  'Talco',
  'Lake Wylie',
  'Odell',
  'Joffre',
  'Barnstead',
  'Coeur D Alene',
  'Gallaway',
  'Bokchito',
  'Bayou Vista',
  'Wallops Island',
  'Benzonia',
  'Powells Point',
  'Willshire',
  'Pembroke Township',
  'Davis Junction',
  'Larkhall',
  'Chenoa',
  'Cedar Point',
  'Chili',
  'Le Claire',
  'Vida',
  'Bonnerdale',
  'Tillman',
  'Parkers Prairie',
  'North Cleveland',
  'Tygh Valley',
  'Hackleburg',
  'Little Torch Key',
  'Parsonsburg',
  'Point Venture',
  'New Era',
  'Keedysville',
  'Roslyn Heights',
  'Marquand',
  'Brownville',
  'Reynolds Station',
  'Maxwelton',
  'Cadott',
  'Buckatunna',
  'Pembine',
  'South Greenfield',
  'Pentwater',
  'Edon',
  'Novelty',
  'Humarock',
  'Monte Alto',
  'Fall Creek',
  'Fort Towson',
  'Floral',
  'Ivey',
  'Daviston',
  'Maypearl',
  'Johannesburg',
  '????????????',
  'Burges',
  'South Portsmouth',
  'Maceo',
  'Earth',
  'Parker City',
  'Albright',
  'Mansura',
  'Brookside',
  'Toughkenamon',
  'Slatedale',
  'Bloomdale',
  'Zagreb',
  'Kylertown',
  'TN 37849',
  'Goochland',
  'Hampden Sydney',
  'Big Prairie',
  'Elora',
  'Stephentown',
  'Elsie',
  'West Baraboo',
  'Maupin',
  'Aspen',
  'Cut Bank',
  'MO 63621',
  'Las Piedras',
  'Pike Rd',
  'Manquin',
  'Madison Township',
  'Fourmile',
  'Noti',
  'Patterson Springs',
  'Cypress Gardens',
  'Salineville',
  'Mountain Park',
  'Teaticket',
  'Neoga',
  'Stowe',
  'West Dennis',
  'Isabel',
  'Hiwassee',
  'Meade',
  'Kimmell',
  'New Glarus',
  'Indian Valley',
  'Clarkrange',
  'Rices Landing',
  'Pine Knot',
  'Crystal Beach',
  'Cascilla',
  'Killona',
  'Third Lake',
  'Burlingham',
  'East Wakefield',
  'Sugarcreek Township',
  'Lohman',
  'Red Cliff',
  'Soulsbyville',
  'Weldona',
  'Orangeville',
  'Hollsopple',
  'Miltona',
  'Chamois',
  'Kellyton',
  'Michigan',
  'Barco',
  'Robins AFB',
  'Eastampton Township',
  'Barnardsville',
  'Joaquin',
  'Ansted',
  'Shoal Creek Drive',
  'Suches',
  'Albert City',
  'Neshkoro',
  'Blue Earth',
  'Pengilly',
  'Wabbaseka',
  'Braham',
  'Oak Grove Village',
  'Warrensburg Township',
  'Arizona 85354',
  '67657 Kaiserslautern',
  'Wadmalaw Island',
  'Makoti',
  'Shacklefords',
  'Palo Verde',
  'Pretty Prairie',
  'Iron Mountain',
  'Baldwinville',
  'Gray Township',
  'K. I. Sawyer',
  'Rushsylvania',
  'Ivel',
  'Wabasso',
  'Ulysses',
  'Kincaid',
  'Sutherland',
  'Partlow',
  'Serena',
  'Shabbona',
  'Lake Harmony',
  'Nevils',
  'Mescalero',
  'Millmont',
  'Grace',
  'Jewell',
  'Chesterhill',
  'Gilby',
  'Wishram',
  'Sunray',
  'Dellroy',
  'Belle Center',
  'Grey Eagle',
  'Bowdoin',
  'West Hamlin',
  'Pewamo',
  'Lake Bridgeport',
  'Weston Lakes',
  'Mowbray',
  'Goldsby',
  'Ash Flat',
  'Pinetop-Lakeside',
  'Mound City',
  'Lumberport',
  'Saint Stephens Church',
  'WV 25637',
  'Mt Cory',
  'Lower Salford Township',
  'Mount Gretna',
  'Calcutta',
  'Dunnigan',
  'Palmhurst',
  'Georgia 30102',
  'Fort Johnson',
  'Oaks',
  'Foresthill',
  'Harveys Lake',
  'Drayton',
  'Blue River',
  'Pocono Pines',
  'Suquamish',
  'Reardan',
  'Saint Stephens',
  'Playa Del Rey',
  'Stearns',
  'Clallam Bay',
  'OH 44104',
  'Quaker Hill',
  'Brooksburg',
  'Nisswa',
  'Linglestown',
  'Naplate',
  'Spartansburg',
  'Cross Hill',
  'Roodhouse',
  'San Miguel',
  'Greenfield Township',
  'Irasburg',
  'Schriever',
  'New Enterprise',
  'Catlin',
  'Elbridge',
  'Highfill',
  'Tekonsha',
  'Georgia 30034',
  'Peachland',
  'North Garden',
  'Slingerlands',
  'El Cenizo',
  'Houghton Lake',
  'Columbus Junction',
  'Texas 77612',
  'Waynetown',
  'San Germán',
  'Bay',
  'Bagnell',
  'West Chazy',
  'Rich Hill',
  'Carter',
  'Big Run',
  'Olmsted Township',
  'Primos',
  'Boyceville',
  'Palm Beach',
  'Smock',
  'Skillman',
  'Orchard',
  'Merna',
  'Sanostee',
  'South Carolina 29511',
  'St Leonard',
  'Colt',
  'Township of Cottrellville',
  'Sundance',
  'Loyal',
  'Kings',
  'Queen Valley',
  'Bankston',
  'GA 31313',
  'Mosses',
  'Oak City',
  'Running Springs',
  'Powells Crossroads',
  'Window Rock',
  'Crookston',
  'Niland',
  'Roaring Branch',
  'Primghar',
  'Essie',
  'Geraldine',
  'Triana',
  'Newtonia',
  'Santa Rosa Valley',
  'Nantes',
  'Powellton',
  'Saguache',
  'Necedah',
  'Weimar',
  'Alum Creek',
  'Sedan',
  'Lost Hills',
  'Saint Croix Falls',
  'Bolivar Peninsula',
  'Corte Madera',
  'Gap Mills',
  'Prahran',
  'Transfer',
  'Dagsboro',
  'Waterman',
  'Noxen',
  'Cochecton',
  'Lane',
  'South Carolina 29544',
  'Charlo',
  'Claycomo',
  'Clancy',
  'Arriba',
  'Mount Sidney',
  'Conrad',
  'Morganza',
  'Volin',
  'Southold',
  'Arnegard',
  'Ovett',
  'Belvue',
  '2200 Monitor Dr',
  'Clicquot',
  'Olivebridge',
  'Moatsville',
  'Clifford',
  'Papaikou',
  'AL 36445',
  'Devils Elbow',
  'Hastings on Hudson',
  'Eliot',
  'Adams Center',
  'Thompsons Station',
  'Wind Lake',
  'East Leroy',
  'Eastbrook',
  'Rover',
  'New Trier',
  'Coburg',
  'Toone',
  'Portola Valley',
  'Secor',
  '??????????',
  'Surgoinsville',
  'Mountain Lake Park',
  'Mariemont',
  'Eckerty',
  'Mt Penn',
  'Cusick',
  'NC 27525',
  'Blenheim',
  'Gill',
  'Bay Pines',
  'Bob White',
  'Kaohsiung',
  'Tiltonsville',
  'Painter',
  'Grovertown',
  'Tybee Island',
  'Vickery',
  'Darien Center',
  'Riva',
  '709 Sargent St',
  'Dupree',
  'Lottie',
  'Silas',
  'Towner',
  'Erskine',
  'Cornwall-On-Hudson',
  'Little River-Academy',
  'Spruce',
  'Maringouin',
  'MO 64682',
  'Sweet Springs',
  'Lakeshore',
  'Vershire',
  'Modoc',
  'Winchester Bay',
  'Little Silver',
  'Maple Bluff',
  'Arizona 86436',
  'Gwalior',
  'Ira Township',
  'Spring Green',
  'Morrill',
  'Chaseburg',
  'South Fallsburg',
  'Nahant',
  'Talmo',
  'Pavillion',
  'East Walpole',
  'Sage',
  'Saulsbury',
  'Caney',
  'Laurel Bloomery',
  'Levering',
  'MI 48858',
  'Pheba',
  'TX 77037',
  'Lärbro',
  'Dartmouth',
  'Otway',
  'Stanchfield',
  'David City',
  'Siracusa',
  'Bleiblerville',
  'Marlinton',
  'Strausstown',
  'Genoa Township',
  '3770 Flora Vista Ave',
  'West University Place',
  'Idaho 83342',
  'South Ryegate',
  'Flat Top',
  'Mantorville',
  'Haverford Township',
  'Emelle',
  'Arnolds Park',
  'Sturgeon',
  'Langeloth',
  'Greenwood Lake',
  'Woodlands',
  'Chalfant',
  'Red Lake',
  'North Redington Beach',
  'Richview',
  'Flag Pond',
  '11800 SW 18th St',
  'North High Shoals',
  'Westhampton Beach',
  'Stark City',
  'Winner',
  'Potter Valley',
  'Mill City',
  'Pittsgrove',
  'Valley Lee',
  'Ahuimanu',
  'Rosanky',
  'Phyllis',
  'Lennox',
  'Howey In The Hills',
  'Woodloch',
  'Iroquois',
  'Pilot Hill',
  'Kendall',
  'Glen Campbell',
  'Sergeant Bluff',
  'Wheeler',
  'Paris Crossing',
  'Springfield Township',
  'Knapp',
  'East Carbon City',
  'North Grosvenor Dale',
  'El Cajón',
  'Antonito',
  'Florida 34472',
  'South Dayton',
  'Basalt',
  'Port Hope',
  'Harold',
  'Birch River',
  'Alabama 36587',
  'Greens Fork',
  'Westchase',
  'Brillion',
  'New Alexandria',
  'Rumney',
  'Utah 84721',
  'Lizemores',
  'State Line',
  'Riegelwood',
  '328 Old Stage Trail',
  'Killingly',
  'Vilseck',
  'Cross Roads',
  'Middlebury Center',
  'LA 70821',
  'Beechgrove',
  'Saint Jo',
  'Chula',
  'Otterville',
  'Stoddard',
  'Township of Washington',
  'Coalville',
  'Freeman Spur',
  '6510 US-301',
  'Romoland',
  'Black Diamond',
  'Patrick Springs',
  'Ogilvie',
  'Toccopola',
  'Mertztown',
  'Flanagan',
  'West Baden Springs',
  'Campo',
  'Puckett',
  'Bunceton',
  'Markesan',
  'Rich Creek',
  'Stout',
  'Dassel',
  'Kentucky 41301',
  '8600 E Alameda Ave',
  'Comfort',
  'Mechanicstown',
  'Swea City',
  'Loraine',
  'Chase',
  'NH 03812',
  'Cumberland Furnace',
  'Edgemere',
  'Bergholz',
  'Edisto Island',
  'Couderay',
  'McCook Lake',
  'Mullens',
  'CA 90247',
  'Hatch',
  'Green Brook Township',
  'Heathrow',
  'Wattsburg',
  'Makinen',
  'Kennett Square',
  'Pineview',
  'Pennellville',
  'Toulon',
  'Donner',
  'Jacobsburg',
  'TX 78704',
  'Frierson',
  'Laquey',
  'Tamworth',
  'Sapello',
  'Penacook',
  'Lake Peekskill',
  'Jumping Branch',
  'Hughestown',
  'Gold Beach',
  'Mine Hill Township',
  'Nome',
  'Funkstown',
  'Neligh',
  'Kotlik',
  'Asherton',
  'Kentucky 41663',
  'Luttrell',
  'Lubec',
  'Cook Station',
  'Ottawa Lake',
  'Levant',
  'East Berne',
  'Ozawkie',
  'Sparkill',
  'South Branch',
  'Haskins',
  'Meyers Lake',
  'Clements',
];

/**
 * Derive lookup data from the city names so the large list is not duplicated
 * in the bundle.
 */
export const CitiesData: CityOption[] = Cities.map(displayName => ({
  displayName,
  key: normalizeCity(displayName),
}));

/**
 * Pre-computed map from display name to normalized key
 * Use this to get the normalized key when sending to API
 * Example: CitiesKeyMap.get('St. Louis') => 'saintlouis'
 */
export const CitiesKeyMap = new Map<string, string>(
  CitiesData.map(city => [city.displayName, city.key])
);

/**
 * Helper function to get normalized key from display name
 * @param displayName - The city display name (e.g., "St. Louis")
 * @returns The normalized key (e.g., "saintlouis")
 */
export function getCityKey(displayName: string): string {
  return CitiesKeyMap.get(displayName) || normalizeCity(displayName);
}

/**
 * Reverse map from normalized key to display name
 * Use this to get the display name when loading data from API
 * Example: CitiesDisplayMap.get('saintlouis') => 'St. Louis'
 */
export const CitiesDisplayMap = new Map<string, string>(
  CitiesData.map(city => [city.key, city.displayName])
);

/**
 * Helper function to get display name from normalized key
 * @param normalizedKey - The normalized city key (e.g., "saintlouis")
 * @returns The display name (e.g., "St. Louis") or the key if not found
 */
export function getCityDisplayName(normalizedKey: string): string {
  return CitiesDisplayMap.get(normalizedKey) || normalizedKey;
}
